<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div class="page">
        <separate-panel-components
                :min="20"
                :max="100"
                :triggerLength="5"
                :paneLengthPercent.sync="paneLengthPercent"
                @close="closeSeparate()"
        >
            <template v-slot:one>
                <div style="width: 100%; height: 100%; ">
                    <div class="canvas-panel" style="left:0">
                        <v-overlay v-if="showOverlay">
                            <v-col align="center">
                                <div>{{ showOverlay }}</div>
                                <v-progress-circular indeterminate size="64">
                                    <v-btn text @click="closeOverlay()"></v-btn>
                                </v-progress-circular>
                            </v-col>
                        </v-overlay>


                        <v-layout>
                            <modal name="uml-modal" :height='"80%"' :width="'80%'">
                                <class-modeler></class-modeler>
                            </modal>
                        </v-layout>


                        <v-snackbar v-model="deleteSnackbar" color="primary" multi-line :timeout="5000">
                            해당 BoundedContext ( {{ deleteBounded }} )데이터가 삭제되었습니다.
                            <v-btn dark @click="deleteSnackbar = false">
                                Close
                            </v-btn>
                        </v-snackbar>

                        <v-snackbar
                                v-model="ideSnackBar.show"
                                :timeout="ideSnackBar.timeout"
                                auto-height
                                :color="ideSnackBar.Color"
                                multi-line
                        >
                            <v-layout align-center pr-4>
                                <v-icon v-if="ideSnackBar.icon" class="pr-3" dark large>{{ ideSnackBar.icon }}</v-icon>
                                <v-layout column>
                                    <div v-if="ideSnackBar.title">
                                        <strong>{{ ideSnackBar.title }}</strong>
                                    </div>
                                    <div>{{ ideSnackBar.Text }}</div>
                                </v-layout>
                            </v-layout>
                            <template v-slot:action="{ attrs }">
                                <v-btn
                                        v-if="ideSnackBar.wrongGitInfo"
                                        color="white"
                                        outlined
                                        small
                                        v-bind="attrs"
                                        @click="functionSelect('opentheiaIDE'), ideSnackBar.show = false"
                                >
                                    open with theia IDE
                                </v-btn>
                                <v-btn
                                        color="white"
                                        text
                                        small
                                        v-bind="attrs"
                                        @click="ideSnackBar.show = false"
                                >
                                    Close
                                </v-btn>
                            </template>
                        </v-snackbar>


                        <v-snackbar v-model="snackbar.show" :color="snackbar.color"
                                    :multi-line="snackbar.mode === 'multi-line'"
                                    :timeout="snackbar.timeout"
                                    :vertical="snackbar.mode === 'vertical'"
                                    :top="snackbar.top"
                                    :bottom="snackbar.bottom"
                                    :centered="snackbar.centered">
                            {{ snackbar.text }}
                            <v-btn v-if="snackbar.showCloseBtn" dark @click="snackbar.show = false" small
                                   style="margin-left: 10px;">
                                Close
                            </v-btn>
                        </v-snackbar>


                        <v-alert
                                dense
                                elevation="6"
                                colored-border
                                :value="alertInfo.show"
                                :border="alertInfo.border"
                                :type="alertInfo.type"
                                :max-width="alertInfo.maxWidth"
                                :color="alertInfo.color"
                                width="100%"
                                style="align-self: center; position: absolute; z-index:999; margin-left: 35%;"
                        >
                            <div style="color: black;"> {{alertInfo.text}}</div>
                            <a v-if="alertInfo.link" target="_blank" :href="alertInfo.link">Github Persenal Access Token
                                발행 방법</a>
                            <div style="text-align: right;">
                                <v-btn v-if="alertInfo.submit" @click="alertSubmit(alertInfo.fnNum)" small color="green"
                                       style="margin-right: 5px;" dark>
                                    {{alertInfo.submit}}
                                </v-btn>
                                <v-btn @click="alertClose(alertInfo.fnNum)" small text>{{$t('word.close')}}</v-btn>
                            </div>
                        </v-alert>

                        <v-layout right>
                            <opengraph ref="opengraph"
                                       :width=100000 :height=100000
                                       :sliderLocationScale=sliderLocationScale
                                       focus-canvas-on-select wheelScalable :labelEditable="true"
                                       :dragPageMovable="dragPageMovable" :enableContextmenu="false"
                                       :automaticGuidance="automaticGuidance"
                                       :enableRootContextmenu="false"
                                       :enableHotkeyCtrlC="false" :enableHotkeyCtrlV="false"
                                       :enableHotkeyDelete="false" :enableHotkeyCtrlZ="false" :enableHotkeyCtrlD="false"
                                       :enableHotkeyCtrlG="false" :slider="true"
                                       :movable="!getReadOnly"
                                       :resizable="!getReadOnly"
                                       :selectable="true"
                                       :connectable="!getReadOnly"
                                       v-if="value"
                                       :autoSliderUpdate="true"
                                       :imageBase="imageBase"
                                       v-on:update:sliderLocationScale="sliderLocationScale = $event"
                                       v-on:connectShape="onConnectShape"
                                       v-on:canvasReady="bindEvents"
                            >
                                <!--  Model -->
                                <div v-if="value.elements &&  typeof value.elements == 'object'"
                                     v-for="elementId in Object.keys(value.elements)">
                                    <component
                                            v-if="elementId && value.elements[elementId]"
                                            :is="getComponentByClassName(value.elements[elementId]._type)"
                                            :value.sync="value.elements[elementId]"
                                            :ref="elementId"
                                    ></component>
                                </div>

                                <div v-if=" value.relations && typeof value.relations == 'object'"
                                     v-for="relationId in Object.keys(value.relations)">
                                    <component
                                            v-if="relationId && value.relations[relationId]"
                                            :is="getComponentByClassName(value.relations[relationId]._type)"
                                            :value.sync="value.relations[relationId]"
                                            :ref="relationId"
                                    ></component>
                                </div>
                            </opengraph>


                            <v-layout row>
                                <v-flex v-if="!getReadOnly && !isHexagonalModeling">
                                    <v-row style="margin-left: 70px; margin-top: 22px">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn :disabled="checkUndo" text small right @click.native="undo()"
                                                       v-on="on">
                                                    <v-icon medium>mdi-undo</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Undo</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn :disabled="checkRedo" text small right @click.native="redo()"
                                                       v-on="on">
                                                    <v-icon medium>mdi-redo</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Redo</span>
                                        </v-tooltip>
                                    </v-row>
                                </v-flex>


                                <slot name="top">
                                    <v-flex style="justify:end; align:start;">
                                        <v-row style="margin-right:10px;">
                                            <v-row justify="end" align="start"
                                                   style="margin-right: 5px; margin-top:16px;">
                                                <slot name="projectName">
                                                    <v-col align="start" justify="end" cols="5" md="5" sm="5"
                                                           id="project-name">
                                                        <v-text-field
                                                                :disabled="getReadOnly || (fullPath && fullPath.includes('replay')) "
                                                                :color="projectNameColor"
                                                                :error-messages="projectNameHint"
                                                                label="Project Name" v-model="projectName"
                                                                @click.native="unselectedAll">
                                                        </v-text-field>
                                                    </v-col>
                                                </slot>
                                            </v-row>
                                            <div>
                                                <div v-if="isMobile">
                                                    <v-card id="mobile-menu-popup-btn">
                                                        <v-speed-dial
                                                                v-model="fab"
                                                                right
                                                                bottom
                                                        >
                                                            <template v-slot:activator>
                                                                <v-btn
                                                                        v-model="fab"
                                                                        color="blue darken-2"
                                                                        dark
                                                                        fab
                                                                        small
                                                                >
                                                                    <v-icon v-if="fab">
                                                                        mdi-playlist-remove
                                                                    </v-icon>
                                                                    <v-icon v-else>
                                                                        mdi-playlist-check
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <v-row id="mobile-action-btn" justify="end" align="start"
                                                                   style="margin-right: 10px;">
                                                                <slot name="mobile-menu-buttons">
                                                                    <v-menu
                                                                            open-on-hover
                                                                            offset-y
                                                                    >
                                                                        <template v-slot:activator="{ on }">

                                                                            <v-btn
                                                                                    text
                                                                                    v-if="getReadOnly"
                                                                                    :color="joinRequestedText.show ? 'primary' :'success'"
                                                                                    dark
                                                                                    @click="requestInviteUser()"
                                                                                    small
                                                                            >
                                                                                <div v-if="joinRequestedText.show">
                                                                                    <v-icon>{{icon.join}}</v-icon>
                                                                                </div>
                                                                                {{ joinRequestedText.text }}
                                                                            </v-btn>

                                                                            <v-btn
                                                                                    text
                                                                                    v-if="getReadOnly"
                                                                                    color="primary"
                                                                                    dark
                                                                                    @click="saveComposition('fork', gitOrgName, gitRepoName)"
                                                                                    small
                                                                            >
                                                                                <v-icon>{{icon.fork}}</v-icon>
                                                                                FORK
                                                                            </v-btn>
                                                                            <v-btn
                                                                                    text
                                                                                    v-else
                                                                                    color="primary"
                                                                                    dark
                                                                                    @click.native="saveComposition('save')"
                                                                                    v-on="on"
                                                                                    small
                                                                            >
                                                                                <v-icon>{{icon.save}}</v-icon>
                                                                                SAVE
                                                                            </v-btn>
                                                                        </template>
                                                                        <v-list v-if="!isClazzModeling">
                                                                            <v-list-item
                                                                                    v-for="(item, index) in saveItems"
                                                                                    :key="index"
                                                                                    @click="functionSelect(item.title,index)"
                                                                            >
                                                                                <v-list-item-title>{{ item.title }}
                                                                                </v-list-item-title>
                                                                            </v-list-item>
                                                                        </v-list>
                                                                    </v-menu>

                                                                    <v-menu
                                                                            v-if="isMineProject && isServerModeling && !getReadOnly "
                                                                            class="pa-2"
                                                                            offset-y
                                                                            open-on-hover
                                                                    >
                                                                        <template v-slot:activator="{ on }">
                                                                            <div>
                                                                                <v-btn
                                                                                        text
                                                                                        color="primary"
                                                                                        dark
                                                                                        v-on="on"
                                                                                        @click="openInviteUsers()"
                                                                                        small
                                                                                >
                                                                                    <v-icon>{{icon.share}}</v-icon>
                                                                                    SHARE
                                                                                    <v-avatar v-if="requestCount"
                                                                                              size="25" color="red"
                                                                                              style="margin-left: 2px;">
                                                                                        {{ requestCount }}
                                                                                    </v-avatar>
                                                                                </v-btn>
                                                                            </div>
                                                                        </template>
                                                                        <v-list>
                                                                            <v-list-item
                                                                                    v-for="(item, index) in shareItems"
                                                                                    :key="index"
                                                                                    @click="functionSelect(item.title,index)"
                                                                            >
                                                                                <v-list-item-title>{{ item.title }}
                                                                                </v-list-item-title>
                                                                            </v-list-item>
                                                                        </v-list>
                                                                    </v-menu>

                                                                    <v-menu
                                                                            text
                                                                            v-if="isServerModeling && !isClazzModeling"
                                                                            class="pa-2"
                                                                            open-on-hover
                                                                            offset-y>
                                                                        <template v-slot:activator="{ on }">
                                                                            <div>
                                                                                <v-btn
                                                                                        color="primary"
                                                                                        dark
                                                                                        @click='showReplay()'
                                                                                        small
                                                                                        :disabled="disableBtn"
                                                                                        text
                                                                                >
                                                                                    <v-icon>mdi-restart</v-icon>
                                                                                    Replay
                                                                                </v-btn>
                                                                            </div>
                                                                        </template>
                                                                    </v-menu>

                                                                    <v-menu
                                                                            open-on-hover
                                                                            offset-y>
                                                                        <template v-slot:activator="{ on }">
                                                                            <div>
                                                                                <v-btn
                                                                                        text
                                                                                        color="orange"
                                                                                        dark
                                                                                        @click="codeModalShow()"
                                                                                        v-on="on"
                                                                                        small
                                                                                >
                                                                                    <v-icon> {{ icon.code}}</v-icon>
                                                                                    CODE
                                                                                </v-btn>
                                                                            </div>
                                                                        </template>
                                                                        <v-list>
                                                                            <v-list-item
                                                                                    v-for="(item, index) in codeItems"
                                                                                    :key="index"
                                                                                    @click="functionSelect(item.title,index)"
                                                                            >
                                                                                <v-list-item-title>{{ item.title }}
                                                                                </v-list-item-title>
                                                                            </v-list-item>
                                                                        </v-list>
                                                                    </v-menu>
                                                                </slot>
                                                            </v-row>
                                                        </v-speed-dial>
                                                    </v-card>
                                                </div>

                                                <div v-else style="margin-top:36px;">
                                                    <v-row id="action-btn" justify="end" align="start"
                                                           style="margin-right: 15px;">

                                                        <slot name="menu-buttons">
                                                            <v-menu
                                                                    class="pa-2"
                                                                    open-on-hover
                                                                    offset-y
                                                                    left
                                                            >
                                                                <template v-slot:activator="{ on }">
                                                                    <div>
                                                                        <v-btn color="primary" text
                                                                               style="margin-right: 5px; margin-top: 15px;"
                                                                               :disabled="disableBtn"
                                                                               @click="openEmbeddedCanvas('Kubernetes')"
                                                                        >
                                                                            <v-icon>mdi-kubernetes</v-icon>
                                                                            Kubernetes
                                                                        </v-btn>
                                                                    </div>
                                                                </template>
                                                            </v-menu>

                                                            <v-menu
                                                                    class="pa-2"
                                                                    open-on-hover
                                                                    offset-y
                                                                    left
                                                            >
                                                                <template v-slot:activator="{ on }">
                                                                    <div>
                                                                        <v-btn
                                                                                v-if="isHexagonalModeling"
                                                                                text
                                                                                style="margin-right: 5px; margin-top: 15px;"
                                                                                color="primary"
                                                                                @click='generateModel()'
                                                                                :disabled="disableBtn"
                                                                        >
                                                                            <v-icon>
                                                                                mdi-checkbox-multiple-blank-outline
                                                                            </v-icon>
                                                                            Model
                                                                        </v-btn>
                                                                        <v-btn
                                                                                v-else
                                                                                text
                                                                                style="margin-right: 5px; margin-top: 15px;"
                                                                                color="primary"
                                                                                @click='generateHexagonal()'
                                                                                :disabled="disableBtn"
                                                                        >
                                                                            <v-icon>mdi-hexagon-outline</v-icon>
                                                                            Hexagonal
                                                                        </v-btn>
                                                                    </div>
                                                                </template>
                                                            </v-menu>

                                                            <v-menu
                                                                    v-if="isServerModeling && !isClazzModeling"
                                                                    class="pa-2"
                                                                    open-on-hover
                                                                    offset-y
                                                                    left
                                                            >
                                                                <template v-slot:activator="{ on }">
                                                                    <div>
                                                                        <v-btn
                                                                                text
                                                                                style="margin-right: 5px; margin-top: 15px;"
                                                                                color="primary"
                                                                                @click='showReplay()'
                                                                                :disabled="disableBtn"
                                                                        >
                                                                            <v-icon>mdi-restart</v-icon>
                                                                            Replay
                                                                        </v-btn>
                                                                    </div>
                                                                </template>
                                                            </v-menu>

                                                            <v-menu
                                                                    class="pa-2"
                                                                    open-on-hover
                                                                    offset-y
                                                                    left
                                                            >
                                                                <template v-slot:activator="{ on }">
                                                                    <div v-if="getReadOnly">
                                                                        <v-btn
                                                                                text
                                                                                color="primary"
                                                                                :disabled="disableBtn"
                                                                                @click="saveComposition('fork', gitOrgName, gitRepoName)"
                                                                                style="margin-right: 5px; margin-top: 15px;"
                                                                        >
                                                                            <v-icon>{{icon.fork}}</v-icon>
                                                                            FORK
                                                                        </v-btn>
                                                                        <v-btn
                                                                                :color="joinRequestedText.show ? 'primary' :'success'"
                                                                                :disabled="disableBtn"
                                                                                @click="requestInviteUser()"
                                                                                style="margin-right: 5px; margin-top: 15px;"
                                                                                text
                                                                        >
                                                                            <div v-if="joinRequestedText.show">
                                                                                <v-icon>{{icon.join}}</v-icon>
                                                                            </div>
                                                                            {{ joinRequestedText.text }}
                                                                        </v-btn>
                                                                    </div>
                                                                    <div v-else>
                                                                        <v-btn
                                                                                text
                                                                                v-if="isMineProject && !isClazzModeling"
                                                                                style="margin-right: 5px; margin-top: 15px;"
                                                                                color="primary"
                                                                                :disabled="disableBtn"
                                                                                @click="saveComposition('save')"
                                                                                v-on="on"
                                                                        >
                                                                            <v-icon>{{icon.save}}</v-icon>
                                                                            SAVE
                                                                        </v-btn>
                                                                        <v-btn
                                                                                text
                                                                                v-else-if="!isMineProject || (isClazzModeling && information.RegisteredLabName)"
                                                                                color="primary"
                                                                                :disabled="disableBtn"
                                                                                @click="saveComposition('fork', gitOrgName, gitRepoName)"
                                                                                style="margin-right: 5px; margin-top: 15px;"
                                                                        >
                                                                            <v-icon>{{icon.fork}}</v-icon>
                                                                            FORK
                                                                        </v-btn>
                                                                    </div>
                                                                </template>
                                                                <v-list v-if="!isClazzModeling">
                                                                    <v-list-item
                                                                            v-for="(item, index) in saveItems"
                                                                            :key="index"
                                                                            @click="functionSelect(item.title,index)"
                                                                    >
                                                                        <v-list-item-title>{{ item.title }}
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>

                                                            <v-menu
                                                                    v-if="isMineProject && isServerModeling && !getReadOnly "
                                                                    offset-y
                                                                    open-on-hover
                                                                    left
                                                            >
                                                                <template v-slot:activator="{ on }">
                                                                    <div>
                                                                        <v-btn
                                                                                text
                                                                                style="margin-right: 5px; margin-top: 15px;"
                                                                                color="primary"
                                                                                :disabled="!initLoad"
                                                                                v-on="on"
                                                                                @click="openInviteUsers()"
                                                                        >
                                                                            <v-icon>{{icon.share}}</v-icon>
                                                                            SHARE
                                                                            <v-avatar v-if="requestCount" size="25"
                                                                                      color="red"
                                                                                      style="margin-left: 2px;"> {{
                                                                                requestCount }}
                                                                            </v-avatar>
                                                                        </v-btn>
                                                                    </div>
                                                                </template>
                                                                <v-list>
                                                                    <v-list-item
                                                                            v-for="(item, index) in shareItems"
                                                                            :key="index"
                                                                            @click="functionSelect(item.title,index)"
                                                                    >
                                                                        <v-list-item-title>{{ item.title }}
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>
                                                            <v-menu
                                                                    v-if="isMineProject || isServerModeling || isClazzModeling"
                                                                    offset-y
                                                                    open-on-hover
                                                                    left
                                                            >
                                                                <template v-slot:activator="{ on }">
                                                                    <div>
                                                                        <v-btn
                                                                                text
                                                                                style="margin-right: 5px; margin-top: 15px; color: white;"
                                                                                color="orange"
                                                                                @click="codeModalShow()"
                                                                                :disabled="!initLoad"
                                                                                v-on="on"
                                                                        >
                                                                            <v-icon>{{icon.code}}</v-icon>
                                                                            CODE
                                                                            <v-progress-circular indeterminate
                                                                                                 v-if="ideWindow && completedSourceCount && (completedSourceCount != totalSourceCount)"></v-progress-circular>
                                                                        </v-btn>
                                                                    </div>
                                                                </template>
                                                                <v-list style="width:175px;">
                                                                    <v-list-item
                                                                            v-for="(item, index) in codeItems"
                                                                            :key="index"
                                                                            @click="functionSelect(item.title,index)"
                                                                    >
                                                                        <v-list-item-title>{{ item.title }}
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>
                                                        </slot>
                                                    </v-row>
                                                </div>
                                            </div>
                                        </v-row>
                                    </v-flex>
                                </slot>
                                <v-fab-transition>
                                    <v-btn
                                            v-if="!rtcLogin && ((isServerModeling && (information && information.permissions)) )"
                                            color="blue"
                                            dark
                                            fab
                                            small
                                            absolute
                                            bottom
                                            right
                                            style="margin:0 5px 40px 0;"
                                            @click="onJoin()"
                                    >
                                        <v-icon>mdi-camera</v-icon>
                                    </v-btn>
                                </v-fab-transition>
                            </v-layout>


                            <v-card class="tools" style="top:100px; text-align: center;">
                                
                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span class="bpmn-icon-hand-tool"
                                            v-bind:class="{ icons : !dragPageMovable, hands : dragPageMovable }"
                                            _width="30"
                                            _height="30" v-on:click="toggleGrip"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                        </span>
                                    </template>
                                    <span v-if="dragPageMovable == true">Draggable Screen : on</span>
                                    <span v-if="dragPageMovable == false">Draggable Screen : off</span>
                                </v-tooltip>
                                
                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span class="gs-automatic-guidance-btn"
                                            @click="automaticGuidanceChange"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon class="gs-automatic-guidance-icon" large style="color:#FBC02D" v-if="automaticGuidance == true">mdi-border-inside</v-icon>
                                            <v-icon class="gs-automatic-guidance-icon" large v-if="automaticGuidance == false">mdi-border-none</v-icon>
                                        </span>
                                    </template>
                                    <span v-if="automaticGuidance == true">Arrange Guidance : on</span>
                                    <span v-if="automaticGuidance == false">Arrange Guidance : off</span>
                                </v-tooltip>
                                <v-tooltip large nudge-top="10" v-for="(item, key) in elementTypes" :key="key" right>
                                    <template v-slot:activator="{ on }">
                                    <span
                                            class="draggable"
                                            align="center"
                                            :_component="item.component"
                                            :_width="item.width"
                                            :_height="item.height">
                                    <img height="30px" width="30px" :src="item.src" v-on="on"
                                         v-if="!getReadOnly && !isHexagonalModeling">
                                    </span>
                                    </template>
                                    <span>{{item.label}}</span>
                                </v-tooltip>
                            </v-card>

                            <modal name="code-modal" :width="codeModalWidth" :height='"auto"' scrollable
                                   @closed="closeCodeModal">
                                <v-dialog v-model="settingGitInfoDialog" max-width="290">
                                    <v-card>
                                        <v-card-title>Git Configure</v-card-title>
                                        <v-card-text>
                                            <v-radio-group
                                                    v-model="gitInfo.type"
                                                    row
                                            >
                                                <v-radio
                                                        label="Github"
                                                        value="github"
                                                ></v-radio>
                                                <v-radio
                                                        disabled
                                                        label="Gitlab"
                                                        value="gitlab"
                                                ></v-radio>
                                            </v-radio-group>
                                            <v-text-field
                                                    v-model="gitInfo.name"
                                                    label="Repository Name"
                                            ></v-text-field>
                                            <v-text-field
                                                    v-model="gitInfo.token"
                                                    label="Git Token"
                                            ></v-text-field>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="green darken-1" text @click="setGitRepository()">Save</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-card flat>
                                    <v-card-title style="margin-top:-10px; height:90px;">
                                        <v-btn class="code-preview-left-re-size-btn"
                                               fab x-small icon @click="codePreviewLeftReSize()"
                                        >≡
                                        </v-btn>
                                        <v-row>
                                            <v-row style="width: 35%; margin-left: 2%; margin-top:0px;">
                                                <span class="headline" v-if="changedModifying">Merge with exsiting changes</span>
                                                <span class="headline" v-else>Code Preview</span>
                                            </v-row>
                                            <v-row style="height: 60px; display:contents;">
                                                <!--                                <div style="width:120px; margin-right:20px;">-->
                                                <!--                                    <v-select-->
                                                <!--                                            :items="templateList"-->
                                                <!--                                            v-model="template"-->
                                                <!--                                            item-text="display"-->
                                                <!--                                            item-value="template"-->
                                                <!--                                            hide-details-->
                                                <!--                                            dense-->
                                                <!--                                    ></v-select>-->
                                                <!--                                </div>-->
                                                <div style="width: 90px;">
                                                    <v-menu
                                                            left
                                                            :close-on-content-click="false">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn text small
                                                                   v-bind="attrs"
                                                                   v-on="on"
                                                                   @click="showTopping = !showTopping"
                                                                   style="width: 100%; font-size: 10px; margin-top: 5px; right:15px;"
                                                            >
                                                                Toppings
                                                                <v-icon>{{ showTopping ? ' mdi-menu-up' :
                                                                    'mdi-menu-down' }}
                                                                </v-icon>
                                                            </v-btn>
                                                        </template>

                                                        <div>
                                                            <v-card>
                                                                <v-card-text>
                                                                    Java/Spring Version
                                                                    <v-divider></v-divider>
                                                                    <div>

                                                                        <v-radio-group
                                                                                v-model="selectedVersion"
                                                                                row
                                                                                style="font-size: 10px; height: 35px;"
                                                                        >
                                                                            <v-radio
                                                                                    label="JAVA 8"
                                                                                    value="java8"
                                                                                    :disabled="onlyJava15"
                                                                            ></v-radio>
                                                                            <v-radio
                                                                                    label="JAVA 15"
                                                                                    value="java15"
                                                                            ></v-radio>
                                                                        </v-radio-group>
                                                                    </div>
                                                                    <div class="topping-radio-group">
                                                                        Security - Token based Authentication
                                                                        <v-divider></v-divider>
                                                                        <div>
                                                                            <v-checkbox
                                                                                    v-model="selectedSecurity"
                                                                                    label="Oauth by Spring Security + Spring GW"
                                                                                    value="isSpringSecurity"
                                                                                    dense
                                                                            ></v-checkbox>
                                                                            <v-checkbox
                                                                                    v-model="selectedSecurity"
                                                                                    label="Keycloak + Spring GW"
                                                                                    value="isKeycloakSecurity"
                                                                                    dense
                                                                                    class="topping-checkbox"
                                                                            ></v-checkbox>
                                                                        </div>

                                                                        Kubernetes/Service Mesh
                                                                        <v-divider></v-divider>
                                                                        <div>
                                                                            <v-checkbox
                                                                                    v-model="isServiceMesh"
                                                                                    label="Istio"
                                                                                    dense
                                                                                    @click="changedTopping()"
                                                                            ></v-checkbox>
                                                                            <v-checkbox
                                                                                    v-model="isIngress"
                                                                                    label="Ingress"
                                                                                    dense
                                                                                    @click="changedTopping()"
                                                                                    class="topping-checkbox"
                                                                            ></v-checkbox>
                                                                        </div>

                                                                        DevOps
                                                                        <v-divider></v-divider>
                                                                        <div>
                                                                            <v-checkbox
                                                                                    v-model="isRollout"
                                                                                    label="Argo + Istio"
                                                                                    dense
                                                                                    @click="changedTopping()"
                                                                            ></v-checkbox>
                                                                        </div>

                                                                        Data Projection
                                                                        <v-divider></v-divider>
                                                                        <div>
                                                                            <v-checkbox
                                                                                    v-model="isApolloGraphQL"
                                                                                    label="Apollo GraphQL"
                                                                                    dense
                                                                                    @click="changedTopping()"
                                                                            ></v-checkbox>
                                                                            <v-checkbox
                                                                                    v-model="isJavaGraphQL"
                                                                                    label="JAVA GraphQL"
                                                                                    disabled
                                                                                    dense
                                                                                    @click="changedTopping()"
                                                                                    class="topping-checkbox"
                                                                            ></v-checkbox>
                                                                        </div>
                                                                    </div>
                                                                </v-card-text>
                                                            </v-card>
                                                        </div>
                                                    </v-menu>
                                                </div>
                                            </v-row>
                                        </v-row>
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text style="width: auto; height: auto; margin-bottom:-30px;">
                                        <v-row
                                                class="mb-6"
                                                no-gutters
                                        >
                                            <v-col
                                                    style="border-right: 1px solid black; max-height: 550px; display: flex;"
                                                    id="scroll-target"
                                                    class="overflow-auto code-preview-left-re-size"
                                            >
                                                <v-treeview
                                                        v-if="changedModifying"
                                                        :items.sync='changedTmp'
                                                        :active.sync="openCode"
                                                        activatable
                                                        item-key="hash"
                                                        return-object
                                                        :transition="treeOpen"
                                                        open-on-click
                                                        transition
                                                        dense
                                                >
                                                    <template v-slot:prepend="{ item, open }">
                                                        <v-icon v-if="item.changed > 0">
                                                            mdi-autorenew
                                                        </v-icon>
                                                        <v-icon v-if="item.isNew">
                                                            mdi-plus
                                                        </v-icon>
                                                    </template>
                                                    <template v-slot:append="{ item, open }" color="red">
                                                        {{item.changed == 0 ? "" : item.changed}}
                                                    </template>
                                                </v-treeview>
                                                <v-treeview
                                                        v-else
                                                        :items.sync='treeList'
                                                        :active.sync="openCode"
                                                        activatable
                                                        item-key="key"
                                                        return-object
                                                        :transition="treeOpen"
                                                        transition
                                                        dense
                                                        style="text-overflow: clip !important; width:1500px;"
                                                >
                                                    <template v-slot:prepend="{ item, open }">
                                                        <v-icon v-if="!item.file">
                                                            {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                                        </v-icon>
                                                        <v-icon v-else>
                                                            {{ icon[item.file] }}
                                                        </v-icon>
                                                    </template>
                                                    <template v-slot:label="{ item, open }">
                                                        {{item.name}}
                                                    </template>

                                                    <template v-slot:append="{ item, open }">
                                                        <v-row style="align-items: center; justify-content: flex-end; margin-right: 0px;">

                                                            <v-menu offset-y v-if="item.preferredPlatform">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-chip
                                                                            x-small
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                            style="position:absolute; left:200px; top:12px;"
                                                                    >
                                                                        {{item.preferredPlatform}}
                                                                    </v-chip>
                                                                </template>
                                                                <v-list>
                                                                    <div v-for="(tempItem, index) in templateList"
                                                                         :key="index">
                                                                        <div v-if="tempItem.display == 'Custom Template'">
                                                                            <v-divider></v-divider>
                                                                        </div>
                                                                        <v-list-item
                                                                                @click="changePreferredPlatform(item, tempItem.template)"
                                                                        >

                                                                            <v-list-item-title>{{ tempItem.display }}
                                                                            </v-list-item-title>
                                                                        </v-list-item>

                                                                    </div>
                                                                </v-list>
                                                            </v-menu>

                                                            <div style="color:red;">
                                                                {{item.changed == 0 ? "" : item.changed}}
                                                            </div>
                                                        </v-row>
                                                    </template>
                                                </v-treeview>
                                            </v-col>
                                            <v-col>
                                                <div v-if="changedModifying">
                                                    <h2 v-if="openCodeWeb.length > 0"
                                                        style="float:left; margin-left: 27px">IDE Exist
                                                        Code</h2>
                                                    <h2 v-if="openCodeWeb.length > 0"
                                                        style="float:right; margin-right: 27px">Merged
                                                        Code</h2>
                                                    <code-viewer
                                                            :project-i-d="projectID"
                                                            v-if="openCodeWeb.length > 0"
                                                            v-model="openCodeMerge"
                                                            :type="'diff'"
                                                            :diff-value="openCodeWeb"
                                                            :create-value="passValue"
                                                            @update="updatePathTmp"
                                                            style="padding: 0 !important;"
                                                    ></code-viewer>
                                                </div>
                                                <div v-else>
                                                    <code-viewer
                                                            :project-i-d="projectID"
                                                            v-if="codeViewing"
                                                            v-model="getOpenCodeTemplate"
                                                            style="padding: 0 !important;"
                                                            @update="updatePathTmp"
                                                    ></code-viewer>
                                                </div>
                                            </v-col>
                                            <v-col style="max-height: 50%; margin-top: 12px;" v-if="gitAccessInput">
                                                <v-card>
                                                    <v-card-title class="headline">Template from Git</v-card-title>
                                                    <v-card-text>
                                                        <v-text-field
                                                                v-model="gitUrl"
                                                                label="Git Repo URL"
                                                        ></v-text-field>
                                                        <v-text-field
                                                                disabled-v-if="!gitAccessTokenIs"
                                                                v-model="gitAccessToken"
                                                                label="Github AccessToken"
                                                        ></v-text-field>
                                                        <a href="http://naver.com" target="_blank">Custom Template
                                                            튜토리얼</a>
                                                    </v-card-text>
                                                    <v-card-actions v-if="changedModifying">
                                                        <div v-if="!linkedSCM">
                                                            <v-icon>mdi-link-variant-off</v-icon>
                                                            No SCM has been configured.
                                                            <v-btn text type="success"
                                                                   @click="settingGitInfoDialog = true">Configure
                                                                git
                                                            </v-btn>
                                                        </div>
                                                        <div v-else>
                                                            <v-icon>mdi-link-variant</v-icon>
                                                            {{ scmUrl.replace(scmUrl.substring("8", scmUrl.indexOf("@")
                                                            + 1), "") }}
                                                        </div>
                                                        <v-spacer></v-spacer>
                                                        <v-btn @click="cancelModify" color="error">cancel</v-btn>
                                                        <v-btn @click="endModify" color="green" style="color: white;">
                                                            ok
                                                        </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </modal>
                        </v-layout>
                    </div>


                    <participant-panel
                            v-if="showParticipantPanel"
                            :lists="participantLists"
                    ></participant-panel>

                    <!--  dialog       -->
                    <invite-user-dialog
                            v-model="inviteLists"
                            :showDialog="inviteDialog"
                            :checkPublic="showPublicModel"
                            @all="invitePublic"
                            @apply="applyInviteUsers"
                            @close="closeInviteUsers"
                            @add="addInviteUser"
                            @remove="removeInviteUser"
                    ></invite-user-dialog>
                    <v-dialog v-model="clusterDialog" persistent fullscreen hide-overlay
                              transition="dialog-bottom-transition">
                        <v-card>
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>Manage Clusters</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn icon dark @click="clusterDialog = false">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>
                            <v-list three-line subheader>
                                <v-list-item>
                                    <v-list-item-content>
                                        <clusters @close="clusterDialog = false" v-model="clusterInfo"/>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-dialog>
                    <model-storage-dialog
                            :condition="storageCondition"
                            :showDialog="showStorageDialog"
                            :isClazzModeling="isClazzModeling"
                            @updateClassModelingId="updateClassModelingId"
                            @save="saveModel"
                            @fork="forkModel"
                            @backup="backupModel"
                            @close="storageDialogCancel"
                    >
                    </model-storage-dialog>

                    <!-- <v-overlay v-if="loadMerge" :absolute="true">
                        <v-progress-circular indeterminate></v-progress-circular>
                        소스코드 생성중...
                    </v-overlay> -->


                    <dialog-purchase-item
                            v-model="purchaseItemDialog"
                            :purchase-item-info="purchaseItemDialogInfo"
                            @result="purchaseItemDialogSubmit"
                            @close="purchaseItemDialogClose"
                    >
                    </dialog-purchase-item>

                    <!--        <v-dialog v-model="ideCheckDialog" max-width="340">-->
                    <!--            <v-card>-->
                    <!--                <v-card-title class="headline">Project IDE</v-card-title>-->
                    <!--                <v-card-text>-->
                    <!--                    <div style="color: #8b0000; font-size: medium">파일을 업데이트 하시겠습니까?</div>-->
                    <!--                    &lt;!&ndash;                    <div style="color: #000000"></div>&ndash;&gt;-->
                    <!--                    <v-checkbox label="Github 연동 (Github 로그인 필요) " v-model="githubCheck"></v-checkbox>-->
                    <!--                    <v-checkbox label="초기화 (체크 시, 기존 파일이 모두 삭제됩니다.)" v-model="ideUpdateCheck"></v-checkbox>-->
                    <!--                </v-card-text>-->
                    <!--                <v-card-actions>-->
                    <!--                    <v-spacer></v-spacer>-->
                    <!--                    <v-btn color="green darken-1" text @click="openProjectIDE()">OK</v-btn>-->
                    <!--                    <v-btn color="red darken-1" text @click="ideCheckDialog = false">Cancel</v-btn>-->
                    <!--                </v-card-actions>-->
                    <!--            </v-card>-->
                    <!--        </v-dialog>-->

                    <v-dialog
                            v-model="resourceQuotaDialog"
                            @click:outside="closeResourceQuota()"
                            max-width="550"
                    >
                        <div style="text-align: -webkit-center;">
                            <ide-resource-dialog :namespace="hashName"
                                                 @submit="closeResourceQuota"></ide-resource-dialog>
                        </div>
                    </v-dialog>

                    <v-dialog v-model="generateZipDialog" persistent max-width="290">
                        <v-card>
                            <v-card-title class="headline">Generate Zip Archive</v-card-title>
                            <v-card-text>
                                Default Template
                                <v-select
                                        :disabled="isDownloading"
                                        v-model="template"
                                        :items="templateList"
                                        item-text="display"
                                        item-value="template"
                                        hide-details
                                        class="pa-0"
                                ></v-select>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <div v-if="!isDownloading">
                                    <v-btn text @click="generateZipDialog = false">Cancel</v-btn>
                                    <v-btn color="primary" text @click="checkedPaidItem()">Download</v-btn>
                                </div>
                                <v-progress-circular
                                        v-else
                                        indeterminate
                                        color="primary"
                                ></v-progress-circular>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="tokenDialog" max-width="290">
                        <v-card>
                            <v-card-title class="headline">Token Dialog</v-card-title>
                            <v-card-text>
                                <v-text-field v-model="clusterAddress" label="Cluster Address"
                                              required></v-text-field>
                                <v-text-field v-model="kubernetesToken" label="Kubernetes Token"
                                              required></v-text-field>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text @click="tokenSave()">Download</v-btn>
                                <v-btn color="red darken-1" text @click="tokenDialog = false">Cancel</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="forkAlertDialog" max-width="290">
                        <v-card>
                            <v-card-title class="headline">Fork
                                <v-icon>{{icon.fork}}</v-icon>
                            </v-card-title>
                            <v-card-text> 권한이 없어서 수정 할 수 없습니다. Fork를 하여 사용해 주세요.</v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text
                                       @click="saveComposition('fork', gitOrgName, gitRepoName)">Fork
                                </v-btn>
                                <v-btn color="red darken-1" text @click.native="forkAlertDialog = false">Close</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="projectIdeAlertDialog" max-width="500">
                        <v-card>
                            <v-card-title class="headline">Warning</v-card-title>
                            <v-card-text> There are <span style="color:red;">{{errorCount}}</span> elements that would
                                bother the project.<br>Would you like to continue?
                            </v-card-text>
                            <v-card-actions>
                                <v-list>
                                    <v-list-group
                                            no-action
                                    >
                                        <template v-slot:activator>
                                            <v-list-item-content>
                                                <!-- <v-icon style="margin-right: 2%;" :color="validationLevelIcon[errorList[0].level].color">{{validationLevelIcon[errorList[0].level].icon}}</v-icon> -->
                                                <v-list-item-title>Get specifics</v-list-item-title>
                                            </v-list-item-content>
                                        </template>

                                        <v-list-item
                                                v-for="item in errorList"
                                                :key="item.code"
                                                style="margin-left:-12%"
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <v-icon style="margin-right: 2%;"
                                                            :color="validationLevelIcon[item.level].color">
                                                        {{validationLevelIcon[item.level].icon}}
                                                    </v-icon>
                                                    [ {{item.eleName}} ] {{item.msg}}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-group>
                                </v-list>
                                <br>
                            </v-card-actions>
                            <div style="margin-left:58%; padding-bottom:10px;">
                                <v-btn text @click.native="projectIdeAlertDialog = false">Cancel</v-btn>
                                <v-btn color="primary" text @click="openIdeAccept(), functionSelect('Project IDE')">Open
                                    IDE
                                </v-btn>
                            </div>
                        </v-card>
                    </v-dialog>

                    <v-dialog content-class="gs-embedded-model" v-model="embeddedCanvasDialog" persistent fullscreen hide-overlay
                              transition="dialog-bottom-transition">
                        <v-card>
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>{{ embeddedCanvasType }}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn icon dark @click="closeEmbeddedCanvas()" style="margin-right:400px;">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>
                            <v-layout v-if="embeddedCanvasType == 'Domain Class Modeling'">
                                <uml-class-model-canvas
                                        :embedded="true"
                                        v-model="embeddedCanvasValue"
                                        :aggregateRootList="aggregateRootList"
                                ></uml-class-model-canvas>
                            </v-layout>
                            <v-layout v-else-if="embeddedCanvasType == 'Kubernetes'">
                                <kubernetes-model-canvas
                                        :embedded="true"
                                        v-model="embeddedCanvasValue"
                                        :boundedContextList="boundedContextList"
                                ></kubernetes-model-canvas>
                            </v-layout>
                        </v-card>
                    </v-dialog>

                    <!--        <modal name="ide-modal" :height='"80%"' :width="'80%'" :draggable="true" :hash-name="hashName"-->
                    <!--               :resizable="true">-->
                    <!--            <ide-loading-page></ide-loading-page>-->
                    <!--        </modal>-->

                    <!--   model IMAGE     -->
                    <modeler-image-generator ref="modeler-image-generator"></modeler-image-generator>
                    <!-- autoPay -->
                    <auto-payment-composition></auto-payment-composition>


                    <hsc-window-style-metal>
                        <hsc-window title="User Camera"
                                    :closeButton="true"
                                    :isOpen.sync="webRtcDialog"
                                    :resizable="true"
                                    :isScrollable="true"
                                    :minWidth="400"
                                    :minHeight="110"
                                    :maxWidth="800"
                                    :maxHeight="110"
                                    positionHint="5 / -10"
                                    style="
                        color: rgb(0, 0, 0);
                        box-shadow: rgba(0, 0, 0, 0.5) 0px 4pt 8pt;
                        background: linear-gradient(rgb(255, 255, 255), rgb(255, 255, 255));
                        z-index: 0;
                        overflow: visible;
                        width: 404px;
                        height: 154.2px;"
                        >
                            <v-layout>
                                <v-col>
                                    <v-row style="margin-left: 2px; margin-bottom: 2px">
                                        <vue-webrtc ref="webrtc"
                                                    width="100%"
                                                    height="160px"
                                                    cameraHeight="50px"
                                                    enableAudio
                                                    class="video-list"
                                                    :roomId="rtcRoomId"
                                                    @error="onError"/>

                                    </v-row>
                                </v-col>
                            </v-layout>
                        </hsc-window>
                    </hsc-window-style-metal>
                </div>
            </template>

            <template v-slot:two>
                <div style="height: 100%; max-height:100%;">
                    <v-card flat style="height: 98%;">
                        <v-card-title style="min-height: 65px;">
                            <div style="position: absolute;
                                top: -20px;
                                left: 0px;"
                            >
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="code-preview-left-re-size-btn"
                                               fab x-small icon @click="codePreviewLeftReSize()"
                                               style="margin-top:2px;"
                                               v-bind="attrs"
                                               v-on="on"

                                        >
                                            <v-icon style="font-size:20px;">mdi-menu</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>left menu fold & unfold</span>
                                </v-tooltip>
                                <div style="z-index: 9999;">
                                    <v-menu
                                            v-model="gitMenu"
                                            :close-on-click="false"
                                            :close-on-content-click="false"
                                            offset-y
                                    >
                                        <template v-slot:activator="{ on: menu, attrs }">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on: tooltip }">
                                                    <v-btn
                                                            :disabled="!isListSettingDone"
                                                            class="code-preview-left-re-size-btn"
                                                            icon x-small
                                                            v-bind="attrs"
                                                            v-on="{ ...tooltip, ...menu }"
                                                            style="margin-left:50px; margin-top:2px;"
                                                    >
                                                        <v-icon style="font-size:20px;" :color="gitMenu ? 'primary':''">
                                                            mdi-git
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Commit & Push on Git</span>
                                            </v-tooltip>
                                        </template>

                                        <div v-if="gitMenu" :key="gitMenuRenderKey">
                                            <gitAPIMenu 
                                                @closeMenu="gitMenu = false"
                                                :isOnPrem="isOnPrem"
                                                :information="information"
                                                :isListSettingDone="isListSettingDone"
                                                :isMineProject="isMineProject"
                                                :changedPathListsForGit="changedPathListsForGit"
                                                :fullPathList="fullPathList"
                                                :mergeCodeList="NewMergeCodeList"
                                                :getCodeList="getCodeList"
                                                :projectId="modelingProjectId"
                                                :projectName="projectName"
                                                :git-users="gitUsers"
                                                @openIDE="openProjectIDE($event.target.value)"
                                            />
                                        </div>
                                    </v-menu>
                                </div>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" class="code-preview-left-re-size-btn"
                                               :disabled="!existChangedFile || !isListSettingDone"
                                               icon x-small @click="setChangedPathLists()"
                                               style="margin-left:20px;"
                                        >
                                            <div v-if="!isListSettingDone">
                                                <v-progress-circular
                                                        size="23"
                                                        :width="3"
                                                        indeterminate
                                                        color="primary"
                                                ></v-progress-circular>
                                            </div>
                                            <div v-else>
                                                <v-icon :size="20" :color="existChangedFile ? 'primary':''">mdi-filter
                                                </v-icon>
                                            </div>
                                        </v-btn>
                                    </template>
                                    <span>Changed File</span>
                                </v-tooltip>
                            </div>

                            <v-row>
                                <v-row style="width: 35%; margin-left: 2%; margin-top:-15px; height:35px;">
                                    <span class="headline" v-if="changedModifying">Merge with existing changes</span>
                                    <span class="headline" v-else>Code Preview</span>
                                </v-row>
                                <v-row style="height: 60px; display:contents;">
                                    <!--                                <div style="width:120px; margin-right:20px;">-->
                                    <!--                                    <v-select-->
                                    <!--                                            :items="templateList"-->
                                    <!--                                            v-model="template"-->
                                    <!--                                            item-text="display"-->
                                    <!--                                            item-value="template"-->
                                    <!--                                            hide-details-->
                                    <!--                                            dense-->
                                    <!--                                    ></v-select>-->
                                    <!--                                </div>-->
                                    <div style="width: 90px;">
                                        <v-menu
                                                left
                                                :close-on-content-click="false">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn text small
                                                       v-bind="attrs"
                                                       v-on="on"
                                                       @click="showTopping = !showTopping"
                                                       style="width: 100%; font-size: 10px; margin-top: 5px; right:15px;"
                                                >
                                                    Toppings
                                                    <v-icon>{{ showTopping ? ' mdi-menu-up' :
                                                        'mdi-menu-down' }}
                                                    </v-icon>
                                                </v-btn>
                                            </template>

                                            <div>
                                                <v-card>
                                                    <v-card-text>
                                                        Java/Spring Version
                                                        <v-divider></v-divider>
                                                        <div>

                                                            <v-radio-group
                                                                    v-model="selectedVersion"
                                                                    row
                                                                    style="font-size: 10px; height: 35px;"
                                                            >
                                                                <v-radio
                                                                        label="JAVA 8"
                                                                        value="java8"
                                                                        :disabled="onlyJava15"
                                                                ></v-radio>
                                                                <v-radio
                                                                        label="JAVA 15"
                                                                        value="java15"
                                                                ></v-radio>
                                                            </v-radio-group>
                                                        </div>
                                                        <div class="topping-radio-group">
                                                            Security - Token based Authentication
                                                            <v-divider></v-divider>
                                                            <div>
                                                                <v-checkbox
                                                                        v-model="selectedSecurity"
                                                                        label="Oauth by Spring Security + Spring GW"
                                                                        value="isSpringSecurity"
                                                                        dense
                                                                ></v-checkbox>
                                                                <v-checkbox
                                                                        v-model="selectedSecurity"
                                                                        label="Oauth by Keycloak + Spring GW"
                                                                        value="isKeycloakSecurity"
                                                                        dense
                                                                        class="topping-checkbox"
                                                                ></v-checkbox>
                                                            </div>

                                                            Kubernetes/Service Mesh
                                                            <v-divider></v-divider>
                                                            <div>
                                                                <v-checkbox
                                                                        v-model="isServiceMesh"
                                                                        label="Istio"
                                                                        dense
                                                                        @click="changedTopping()"
                                                                ></v-checkbox>
                                                                <v-checkbox
                                                                        v-model="isIngress"
                                                                        label="Ingress"
                                                                        dense
                                                                        @click="changedTopping()"
                                                                        class="topping-checkbox"
                                                                ></v-checkbox>
                                                            </div>

                                                            DevOps
                                                            <v-divider></v-divider>
                                                            <div>
                                                                <v-checkbox
                                                                        v-model="isRollout"
                                                                        label="Argo + Istio"
                                                                        dense
                                                                        @click="changedTopping()"
                                                                ></v-checkbox>
                                                            </div>

                                                            Data Projection
                                                            <v-divider></v-divider>
                                                            <div>
                                                                <v-checkbox
                                                                        v-model="isApolloGraphQL"
                                                                        label="Apollo GraphQL"
                                                                        dense
                                                                        @click="changedTopping()"
                                                                ></v-checkbox>
                                                                <v-checkbox
                                                                        v-model="isJavaGraphQL"
                                                                        label="JAVA GraphQL"
                                                                        disabled
                                                                        dense
                                                                        @click="changedTopping()"
                                                                        class="topping-checkbox"
                                                                ></v-checkbox>
                                                            </div>
                                                        </div>
                                                    </v-card-text>
                                                </v-card>
                                            </div>
                                        </v-menu>
                                    </div>
                                </v-row>
                            </v-row>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text style="max-height: 93%; width: auto;  height: 93%;">
                            <v-row
                                    class="mb-6"
                                    no-gutters
                                    style="height: 100%;"
                            >
                                <v-col
                                        style="border-right: 1px solid black; max-height: 100%; display: flex;"
                                        id="scroll-target"
                                        class="overflow-auto code-preview-left-re-size"
                                >
                                    <div v-if="changedModifying">
                                        <v-treeview
                                                :items.sync='changedTmp'
                                                @update:active="selectedActive"
                                                activatable
                                                item-key="hash"
                                                return-object
                                                :transition="treeOpen"
                                                open-all
                                                transition
                                                dense
                                        >
                                            <template v-slot:prepend="{ item, open }">
                                                <v-icon v-if="item.changed > 0">
                                                    mdi-autorenew
                                                </v-icon>
                                                <v-icon v-if="item.isNew">
                                                    mdi-plus
                                                </v-icon>
                                            </template>
                                            <template v-slot:append="{ item, open }" color="red">
                                                {{item.changed == 0 ? "" : item.changed}}
                                            </template>
                                        </v-treeview>
                                    </div>
                                    <div v-else>
                                        <v-treeview
                                                ref="codeTrees"
                                                :items.sync='getTreeLists'
                                                @update:active="selectedActive"
                                                @update:open="selectedOpen"
                                                :open="getTreeOpenLists"
                                                activatable
                                                item-key="hash"
                                                return-object
                                                :transition="treeOpen"
                                                transition
                                                dense
                                                style="text-overflow: clip !important; height: 800px; max-height: 1000px;"
                                        >
                                            <template v-slot:prepend="{ item, open }">
                                                <v-icon v-if="isChangedTemplate(item)"
                                                        color="#00B0FF"
                                                        x-small
                                                        style="position: absolute; z-index:9999; font-size: 1px;"
                                                >fiber_manual_record
                                                </v-icon>
                                                <v-icon v-if="!item.file">
                                                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                                </v-icon>
                                                <v-icon v-else>
                                                    {{ icon[item.file] }}
                                                </v-icon>
                                            </template>
                                            <template v-slot:label="{ item, open }">
                                                <div style="font-size: 1px; margin-top: 5px;" v-if="showTemplatePath">
                                                    {{getTemplatePath (item)}}
                                                </div>
                                                {{item.name}}
                                            </template>

                                            <template v-slot:append="{ item, open }">
                                                <v-row style="align-items: center; justify-content: flex-end; margin-right: 0px;">

                                                    <div v-if="showChangedPathLists && !item.file && item.name == 'Changed Files' ">
                                                        <v-icon style="font-size: 16px; position: absolute;left: 270px;top: 15px;"
                                                                @click="clearChangedPathListsBucket()"
                                                        >mdi-delete
                                                        </v-icon>
                                                    </div>

                                                    <div v-else>
                                                        <v-menu offset-y v-if="item.preferredPlatform">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-chip
                                                                        x-small
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        style="position:absolute; left:190px; top:12px;"
                                                                >
                                                                    {{item.preferredPlatform ? item.preferredPlatform :
                                                                    'selected'}}
                                                                </v-chip>
                                                            </template>
                                                            <v-list>
                                                                <v-list-item
                                                                        v-for="(tempItem, index) in templateList"
                                                                        :key="index"
                                                                        @click="changePreferredPlatform(item, tempItem.template)"
                                                                >
                                                                    <v-list-item-title>{{ tempItem.display }}
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-menu>

                                                        <div style="color:red;">
                                                            {{item.changed == 0 ? "" : item.changed}}
                                                        </div>
                                                    </div>
                                                </v-row>
                                            </template>
                                        </v-treeview>
                                    </div>
                                </v-col>
                                <v-col>
                                    <div v-if="changedModifying">
                                        <h2 v-if="openCodeWeb.length > 0"
                                            style="float:left; margin-left: 27px">IDE Exist
                                            Code</h2>
                                        <h2 v-if="openCodeWeb.length > 0"
                                            style="float:right; margin-right: 27px">Merged
                                            Code</h2>
                                        <code-viewer
                                                :project-i-d="projectID"
                                                v-if="openCodeWeb.length > 0"
                                                v-model="openCodeMerge"
                                                :type="'diff'"
                                                :diff-value="openCodeWeb"
                                                :create-value="passValue"
                                                @update="updatePathTmp"
                                                style="padding: 0 !important;"
                                        ></code-viewer>
                                    </div>
                                    <div v-else-if="changedDiffCodeViewer" style="height: 100%;">
                                        <code-viewer
                                                :project-i-d="projectID"
                                                :type="'diff'"
                                                v-model="getOpenCodeTemplate"
                                                :create-value="changedDiffCode"
                                                style="padding: 0 !important;"
                                                @update="updatePathTmp"
                                        ></code-viewer>
                                    </div>
                                    <div v-else style="height: 100%;">
                                        <code-viewer
                                                :project-i-d="projectID"
                                                v-if="codeViewing"
                                                v-model="getOpenCodeTemplate"
                                                style="padding: 0 !important;"
                                                @update="updatePathTmp"
                                        ></code-viewer>
                                    </div>
                                </v-col>
                                <v-col style="max-height: 50%; margin-top: 12px;" v-if="gitAccessInput">
                                    <v-card>
                                        <v-card-title class="headline">Template from Git</v-card-title>
                                        <v-card-text>
                                            <v-text-field
                                                    v-model="gitUrl"
                                                    label="Git Repo URL"
                                            ></v-text-field>
                                            <v-text-field
                                                    disabled-v-if="!gitAccessTokenIs"
                                                    v-model="gitAccessToken"
                                                    label="Github AccessToken"
                                            ></v-text-field>
                                            <a href="https://intro-kor.msaez.io/custom-template/tutorial/#%EC%BB%A4%EC%8A%A4%ED%85%80-%ED%85%9C%ED%94%8C%EB%A6%BF-%EC%84%A4%EC%A0%95%ED%95%98%EA%B8%B0"
                                               target="_blank">Custom Template 튜토리얼</a>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                    color="red darken-1"
                                                    text
                                                    @click="gitAccessInput = false"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                    color="green darken-1"
                                                    text
                                                    @click="saveGitToken()"
                                            >
                                                Apply
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions v-if="changedModifying">
                            <div v-if="!linkedSCM">
                                <v-icon>mdi-link-variant-off</v-icon>
                                No SCM has been configured.
                                <v-btn text type="success" @click="settingGitInfoDialog = true">Configure git</v-btn>
                            </div>
                            <div v-else>
                                <v-icon>mdi-link-variant</v-icon>
                                {{ scmUrl.replace(scmUrl.substring("8", scmUrl.indexOf("@") + 1), "") }}
                            </div>
                            <v-spacer></v-spacer>
                            <v-btn @click="cancelModify" color="error">cancel</v-btn>
                            <v-btn @click="endModify" color="green" style="color: white;">ok</v-btn>
                        </v-card-actions>
                    </v-card>
                </div>
            </template>
        </separate-panel-components>
        <git-information v-model="gitInfoDialog" @close="closeGitInfo()" :git.sync="gitURLforModel"></git-information>


    </div>
</template>

<script>
    // import { Octokit, App } from "https://cdn.skypack.dev/octokit";

    import ModelCanvas from "../modeling/ModelCanvas";
    import TextReader from "@/components/yaml.vue";
    import CodeViewer from "../CodeViewer";
    import gitAPIMenu from "../gitAPIMenu";
    import MonacoEditor from 'vue-monaco';
    // import CodeViewer from "./EventStormingCodeViewer";


    import {
        mdiAbTesting
    } from '@mdi/js';
    import * as io from 'socket.io-client';
    import DiffMatchPatch from "diff-match-patch";

    var JSZip = require('jszip')
    var yamlpaser = require('js-yaml');
    var changeCase = require('change-case');
    var pluralize = require('pluralize');
    var path = require('path')
    var Minio = require('minio');
    var ConfigIniParser = require("config-ini-parser").ConfigIniParser;
    var delimiter = "\r\n"; //or "\n" for *nux
    import {diffString, diff} from "json-diff";
    import IdeLoadingPage from "../../IdeLoadingPage";
    import GitInformation from "../../GitInformation";
    import json2yaml from 'json2yaml';

    var jsondiffpatch = require('jsondiffpatch').create({
        objectHash: function (obj, index) {
            return '$$index:' + index;
        },
    });

    var codeArraydiffpatch = require('jsondiffpatch').create({
        objectHash: function (obj, index) {
            console.log(obj)
            return obj.code;
        },
    });

    const prettier = require("prettier");
    const plugins = require("prettier-plugin-java");
    const axios = require('axios');

    export default {
        name: 'event-storming-model-canvas',
        mixins: [ModelCanvas],
        components: {
            GitInformation,
            IdeLoadingPage,
            TextReader,
            saveAs,
            CodeViewer,
            gitAPIMenu,
            mdiAbTesting,
            diffString, diff,
            io,
            MonacoEditor,
        },
        props: {
            labId: String,
        },
        data() {
            return {
                gitMenuRenderKey: 0,
                gitUsers: null,
                gitOrgName: null,
                gitRepoName: null,
                useIdeItem: null,
                ideSnackBar: {
                    Text: '',
                    show: false,
                    Color: null,
                    icon: null,
                    title: null,
                    timeout: null,
                    wrongGitInfo: false,
                },
                gitMenu: false,
                changedPathListsForGit: [],
                setTreeHashLists: false,
                gitInfoDialog: false,
                gitURLforModel: null,
                codePreviewLeftReSizeNumber: null,
                //Hexagonal
                isHexagonal: false,
                hexagonalValue: null,
                hashName: undefined,
                projectID: undefined,
                settingGitInfoDialog: false,
                linkedSCM: false,
                scmUrl: null,
                monacoEditor: '',
                fab: false,
                sshUrl: "",
                gitInfo: {
                    name: "",
                    type: "github",
                    token: ""
                },
                // Source Count
                completedSourceCount: undefined,
                // 윈도우
                ideWindow: undefined,
                windowWidth: window.innerWidth,
                ideUpdateCheck: false,
                githubCheck: false,
                ideCheckDialog: false,
                codeModalWidth: '80%',
                mergedExist: true,
                gitAccessToken: '',
                gitAccessTokenIs: false,
                gitAccessInput: false,
                deleteSnackbar: false,
                deleteBounded: "",
                isNetworkOffline: false,
                eventListener: null,
                //db permission
                isMultiShareType: 'ReadOnly',
                isMultiShareTypeList: ['ReadOnly', 'Write'],
                codeLoading: false,
                codeViewing: false,
                changedCount: 0,
                test: [],
                versionItems: [
                    {title: 'Versions'},
                ],
                shareItems: [
                    {title: 'Share'},
                ],
                saveItems: [
                    {title: 'Save to Server'},
                    {title: 'Download model File'},
                    {title: 'Duplicate'},
                    {title: 'Git URL for Model'}
                ],
                openItems: [
                    {title: 'Open from Files'},
                    {title: 'Open from Local'},
                ],
                codeItems: [
                    {title: 'Code Preview'},
                    {title: 'Download Archive'},
                    {title: 'Project IDE'},
                    {title: 'Reset Config'}
                ],
                projectNameHint: null,
                projectNameColor: null,
                rules: {
                    required: value => !!value || 'ProjectName required.',
                    min: v => v.length >= 8 || 'Min 8 characters',
                    emailMatch: () => ('The email and password you entered don\'t match'),
                },
                generateZipDialog: false,
                imageBase: 'static/image/symbol/',
                //Zip
                resourceQuotaDialog: false,
                setResourceQuota: false,
                //ide
                resourceQuota: {
                    memory: "4Gi",
                    cpu: "2"
                },
                resourceType: 'ide-4m2c',
                //tool
                toolResourceQuota: {
                    memory: "4Gi",
                    cpu: "2",
                },
                toolResourceType: 'k8s-4m2c',

                mergeStatus: false,
                pathTmp: [],
                changedTmp: [],
                gitCodeUrl: {},
                codeStatus: null,
                passValue: [],

                //data structure
                selectedElementIds: [],

                model: [],
                fullPathList: [],
                treeList: [],
                mergeTreeList: [],
                getCodeList: [],
                mergeCodeList: [],
                NewMergeCodeList: {},
                openCode: [],
                openCodeWeb: [],
                openCodeMerge: [],
                template: 'spring-boot',
                changedHashList: [],
                // topping
                showTopping: false,
                preferredToppingPlatforms: [],
                selectedVersion: 'java8',
                isJava15: false,
                selectedSecurity: null,
                isSpringSecurity: false,
                isKeycloakSecurity: false,
                isServiceMesh: false,
                isRollout: false,
                isIngress: false,
                isApolloGraphQL: false,
                isJavaGraphQL: false,

                isListSettingDone: false,
                templateSendCnt: -1,
                templateDoneCnt: 0,
                toppingSendCnt: -1,
                toppingDoneCnt: 0,


                treeOpen: true,
                getTreeOpenLists: [],
                gitUrl: '',
                gitPath: [],
                gitCode: [],
                checkName: true,
                changedModifying: false,
                cancelModifying: false,
                changedDiffCodeViewer: false,
                changedDiffCode: null,
                // Children
                drawer: false,
                chatUid: '',
                messageRef: {},
                //version
                versionList: [],
                version: '',
                revisionInfo: {},
                kubernetesToken: '',
                clusterAddress: '',
                tokenDialog: false,

                //embedded Canvas
                embeddedCanvasDialog: false,
                embeddedCanvasType: '',
                embeddedCanvasValue: null,
                aggregateRootId: '',
                aggregateRootList: [],
                boundedContextList: [],

                //replay

                //view
                viewSelect: {},
                viewOpenId: '',
                defaultValue: '',

                //edit
                //fork
                forkAlertDialog: false,
                ////////////////////// Validation ERROR CODE /////////////////////////////
                ESC_NOT_PJ_NAME: 0,
                validationCodeLists: {
                    0: {
                        'level': 'warning',
                        'msg': 'Please input your ProjectName(English Only)'
                    },
                },
                /////////////////////////////////
                elementTypes: [
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'domain-event-definition',
                        'label': 'Event',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/event.png`
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'command-definition',
                        'label': 'Command',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/command.png`
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'policy-definition',
                        'label': 'Policy',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/policy.png`
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'aggregate-definition',
                        'label': 'Aggregate',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/aggregate.png`
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'external-definition',
                        'label': 'External',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/external.png`

                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'view-definition',
                        'label': 'Read Model',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/view.png`

                    },
                    {
                        'icon': 'bpmn-icon-start-issue-none',//'OG.shape.essencia.Alpha',
                        'component': 'issue-definition',
                        'label': 'Issue',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/issue.png`
                    },
                    {
                        'icon': 'bpmn-icon-start-event-none',//'OG.shape.essencia.Alpha',
                        'component': 'bounded-context-definition',
                        'label': 'Bounded Context',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/bounded2.png`

                    },
                    {
                        'icon': 'bpmn-icon-start-actor-none',//'OG.shape.essencia.Alpha',
                        'component': 'actor-definition',
                        'label': 'Actor',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/event/actor.png`
                    },
                    {
                        'component': 'es-line-element',
                        'label': 'Line',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/symbol/edge.png`,
                    },
                    {
                        'component': 'es-text-element',
                        'label': 'Text',
                        'width': '100',
                        'height': '100',
                        'src': `${window.location.protocol + "//" + window.location.host}/static/image/symbol/text_element.png`,
                    },
                ],
                isDownloading: false,
                // copy & paste
                tmpValue: [],
                errorCount: 0,
                projectIdeAlertDialog: false,
                openIde: false,
                errorList: [],
                validationLevelIcon:
                    {
                        'error': {icon: 'mdi-close-circle-outline', color: '#E53935'},
                        'warning': {icon: 'mdi-alert-outline', color: '#FFA726'},
                        'info': {icon: 'mdi-information-outline', color: '#29B6F6'},
                    },

            }
        },
        computed: {
            isOnPrem() {
                if (window.MODE == "onprem") {
                    return true
                } else {
                    return false
                }
            },
            existChangedFile() {
                if ((this.changedPathLists.length > 0 && this.changedPathListsBucket.length == 0)
                    || (this.changedPathListsBucket && this.changedPathListsBucket.length > 0)
                ) {
                    return true
                }
                return false
            },
            getDiffTreeLists() {
                var me = this
                // var list = {}
                var newList = []
                if (Object.keys(me.oldTreeHashLists) && Object.keys(me.oldTreeHashLists).length > 0) {

                    var arr = Object.keys(me.newTreeHashLists).filter((hash, index) => {
                        if (me.oldTreeHashLists && Object.keys(me.oldTreeHashLists).indexOf(hash) == -1) {
                            return true
                        }
                    });

                    const set = new Set(arr);
                    var diffHash = [...set];

                    if (diffHash.length > 0) {
                        diffHash.forEach(function (hash) {
                            var path = me.newTreeHashLists[hash]
                            newList.push(path)
                        })
                    }


                    if (!me.changedPathLists) me.changedPathLists = []
                    if (newList.length > 0 && me.isChangedPathLists) {
                        // me.changedPathLists = me.changedPathLists.concat(newList)
                        me.changedPathLists = [
                            ...me.changedPathLists,
                            ...newList,
                        ];

                        const setse = new Set(me.changedPathLists);
                        me.changedPathLists = [...setse];
                        me.isChangedPathLists = false


                        me.changedPathListsForGit = [
                            ...me.changedPathListsForGit,
                            ...me.changedPathLists,
                        ];
                        const setsegit = new Set(me.changedPathListsForGit);
                        me.changedPathListsForGit = [...setsegit];
                        me.gitMenuRenderKey++;
                    }

                    return me.changedPathLists
                }
                return []
            },
            getOpenCodeTemplate() {
                var me = this
                var l = []

                function filterData(data, predicate) {
                    // if no data is sent in, return null, otherwise transform the data
                    return !!!data ? null : data.reduce((list, entry) => {
                        let clone = null;
                        if (predicate(entry)) {
                            // if the object matches the filter, clone it as it is
                            clone = Object.assign({}, entry)
                            clone && l.push(clone)
                        } else if (entry.children) {
                            // if the object has childrens, filter the list of children
                            filterData(entry.children, predicate)
                        }
                        return l
                    }, [])
                }

                if (!me.isListSettingDone) {
                    //loading..
                    if (me.openCode.length == 0) {
                        var getCode = localStorage.getItem('openCode')
                        getCode = JSON.parse(getCode)
                        if (getCode && getCode.length > 0) {
                            me.openCode = getCode
                        } else {
                            me.openCode = []
                        }
                        return me.openCode
                    } else {
                        return []
                    }

                } else {
                    //done
                    if (me.openCode.length > 0) {
                        // return me.getCodeList.filter( x => x.hash == me.openCode[0].hash)
                        return filterData(this.treeList, function (item) {
                            //just Path compare
                            return item.code && (item.path == me.openCode[0].path)
                        });
                    }

                    if (me.getTreeLists.length > 0) {
                        return me.getTreeLists[0].children
                    }

                    return []
                }

            },
            getSelectedElementIds() {
                var me = this
                var eleObj = me.selectedElementIds[0] ? me.selectedElementIds[0] : null
                var eleId = eleObj ? eleObj.id : null

                if (eleId) {
                    if (!me.value.elements[eleId] && eleObj) {
                        var fidx = me.selectedElementIds.findIndex(obj => obj.id == eleId)
                        if (fidx != -1) {
                            me.selectedElementIds.splice(fidx, 1);
                        }
                    }
                }
                return me.selectedElementIds ? me.selectedElementIds : null
            },
            getTreeLists() {
                var me = this
                me.showTemplatePath = false
                me.getTreeOpenLists = []
                if (!me.isClosedTemplateCode && me.isListSettingDone) {
                    try {
                        var eleObj = me.getSelectedElementIds ? me.getSelectedElementIds[0] : null
                        var eleId = eleObj ? eleObj.id : null
                        var eleType = eleObj ? eleObj.type : null
                        var returnArray = [];

                        if (eleId) {
                            me.showChangedPathLists = false

                            if (eleType && eleType.endsWith("BoundedContext")) {
                                returnArray = me.treeList.filter(tree => tree.bcId == eleId)
                            } else {
                                me.showTemplatePath = true

                                var representativeForArray = [];
                                var relatedArray = [];

                                var bcName = me.value.elements[eleId] ? JSON.parse(JSON.stringify(me.value.elements[eleId].boundedContext)) : null
                                bcName = bcName ? bcName.name : null
                                me.getCodeList.forEach(function (code, idx) {

                                    // representativeFor
                                    if (code.representativeFor
                                        && bcName
                                        && bcName == code.boundedContext
                                        && eleType
                                        && eleType.endsWith(code.representativeFor)
                                    ) {

                                        if (code && code.forEach == code.representativeFor) {
                                            // forEach  == representativeFor  동일 한경우 모든 대표파일이 나오는 문제.
                                            if (code.element == eleId) {
                                                // 자신의 템플릿 파악.
                                                var data = {
                                                    name: code.fileName,
                                                    key: code.key,
                                                    file: code.file,
                                                    code: code.code,
                                                    path: me.fullPathList[idx].fullPath,
                                                    // beforeFullPath: me.fullPathList[idx].beforeFullPath,
                                                    changed: 0,
                                                    hash: code.hash,
                                                }
                                                representativeForArray.push(data)
                                            }
                                        } else {
                                            // 같은 BC , representativeFor 같은 Type
                                            //중복 제거.
                                            if (representativeForArray.findIndex(obj => obj.path == me.fullPathList[idx].fullPath) == -1) {
                                                var data = {
                                                    name: code.fileName,
                                                    key: code.key,
                                                    file: code.file,
                                                    code: code.code,
                                                    path: me.fullPathList[idx].fullPath,
                                                    // beforeFullPath: me.fullPathList[idx].beforeFullPath,
                                                    changed: 0,
                                                    hash: code.hash,
                                                }
                                                representativeForArray.push(data)
                                            }
                                        }
                                    }

                                    // related
                                    if (code.element == eleId && !code.representativeFor) {
                                        if (relatedArray.findIndex(obj => obj.path == me.fullPathList[idx].fullPath) == -1) {
                                            var data = {
                                                name: code.fileName,
                                                key: code.key,
                                                file: code.file,
                                                code: code.code,
                                                path: me.fullPathList[idx].fullPath,
                                                // beforeFullPath: me.fullPathList[idx].beforeFullPath,
                                                changed: 0,
                                                hash: code.hash,
                                            }
                                            relatedArray.push(data)
                                        }
                                    }

                                });

                                var mainData = {
                                    name: 'Representative',
                                    key: 'Representative',
                                    hash: 'Representative0',
                                    path: '/',
                                    children: representativeForArray,
                                    file: null,
                                    code: null,
                                    changed: 0,
                                }

                                var subData = {
                                    name: 'Referenced',
                                    key: 'Referenced',
                                    hash: 'Referenced0',
                                    path: '/',
                                    children: relatedArray,
                                    file: null,
                                    code: null,
                                    changed: 0,
                                }

                                returnArray.push(mainData)
                                returnArray.push(subData)
                                // tree open
                                me.getTreeOpenLists = returnArray
                            }
                        } else if (me.showChangedPathLists) {
                            var changedArray = []

                            if (me.changedPathListsBucket.length > 0) {
                                var merged = [...me.changedPathListsBucket, ...me.changedPathLists]
                                me.changedPathListsBucket = [...new Set(merged)]
                            } else {
                                me.changedPathListsBucket = JSON.parse(JSON.stringify(me.changedPathLists))
                            }

                            me.changedPathListsBucket.forEach(function (changedPath) {
                                var file = me.fullPathList.find(item => item.code && (item.fullPath == changedPath))
                                if (file) {
                                    var code = me.getCodeList.find(item => item.code && item.hash == (file && file.hash))
                                    var data = {
                                        name: code.fileName,
                                        key: code.key,
                                        file: code.file,
                                        code: code.code,
                                        path: file.fullPath,
                                        changed: 0,
                                        hash: code.hash,
                                    }
                                    changedArray.push(data)
                                } else {
                                    // delete file
                                }

                            })


                            var mainData = {
                                name: 'Changed Files',
                                key: 'ChangedFiles',
                                hash: 'ChangedFiles0',
                                path: '/',
                                children: changedArray,
                                file: null,
                                code: null,
                                changed: 0,
                            }
                            returnArray.push(mainData)

                            me.getTreeOpenLists = returnArray

                        } else {
                            me.showChangedPathLists = false
                            returnArray = me.treeList
                        }

                        return returnArray;
                    } catch (e) {
                        return []
                    }
                }
                return []
            },
            totalSourceCount() {
                return this.fullPathList.length;
            },
            onlyJava15() {
                if (this.template == 'spring-boot-mybatis') {
                    this.selectedVersion = 'java15';
                    return true
                }
                return false
            },
            isHexagonalModeling() {
                return this.isHexagonal
            },
            getUserCoin() {
                if (this.userInfo.savedCoin) {
                    return this.userInfo.savedCoin
                }
                return 0
            },
            getUserToolTime() {
                if (this.userInfo.savedToolTime) {
                    return this.userInfo.savedToolTime.toFixed(1)
                }
                return 0
            },
            getReadOnly() {
                return this.readOnly
            },
            loadMerge() {
                if (!this.mergeStatus && this.mergeStatus != null) {
                    return true
                }
                return false
            },
            disableBtn() {
                if (this.disableModel || !this.initLoad) {
                    return true
                }
                return false
            },
            attachedLists() {
                var me = this
                var bounedTmp = {}
                var aggregateTmp = {}
                var eventTmp = {}
                var commandTmp = {}
                var policyTmp = {}
                var actorTmp = {}

                Object.values(me.value.elements).forEach(function (element) {
                    if (element != null) {
                        if (element._type == 'org.uengine.modeling.model.BoundedContext') {
                            me.$set(bounedTmp, element.elementView.id, element)
                        } else if (element._type == 'org.uengine.modeling.model.Aggregate') {
                            me.$set(aggregateTmp, element.elementView.id, element)
                        } else if (element._type == 'org.uengine.modeling.model.Event') {
                            me.$set(eventTmp, element.elementView.id, element)
                        } else if (element._type == 'org.uengine.modeling.model.Command') {
                            me.$set(commandTmp, element.elementView.id, element)
                        } else if (element._type == 'org.uengine.modeling.model.Policy') {
                            me.$set(policyTmp, element.elementView.id, element)
                        } else if (element._type == 'org.uengine.modeling.model.Actor') {
                            me.$set(actorTmp, element.elementView.id, element)
                        }
                    }
                })

                var obj = {
                    boundedContextLists: bounedTmp,
                    aggregateLists: aggregateTmp,
                    eventLists: eventTmp,
                    commandLists: commandTmp,
                    policyLists: policyTmp,
                    actorLists: actorTmp,
                }
                return obj
            },
            templateList: function () {
                var me = this
                var list = []
                Object.keys(me.$manifestsPerTemplate).forEach(function (template) {
                    var obj = {
                        display: template,
                        template: template
                    }
                    list.push(obj)
                })
                return list
            },
            // openCodeWebComputed: async function () {
            //
            // }
        },
        created: async function () {
            var me = this
            me.canvasType = 'es'
            me.isQueueModel = true
            me.clusterItems = [
                {title: 'Cluster'}
            ]
            me.track()
        },
        mounted: function () {
            var me = this

            if (window.opener) {
                me.ideWindow = window.opener
            }
            if (me.isClazzModeling) {
                var userName = localStorage.getItem("email").split('@')[0].toLowerCase();
                var userGroup = localStorage.getItem("email").split('@')[1].split('.')[0].toLowerCase();
                var lab = me.labId;
                if (me.labInfo) {
                    me.hashPath = me.getClassPath('labs/' + lab + '/' + userName);
                } else {
                    me.hashName = `ide-${me.hashCode(userGroup + "-" + userName)}`;
                    me.projectID = me.$route.params.projectId;
                }
            }

            // DeployData CallBack
            window.addEventListener('message', me.messageProcessing);

            me.$EventBus.$on('deploy', async function (boundedId) {
                await me.getListSetting();
                me.generateZipToFireBase(boundedId);
            });
            me.$EventBus.$on('downloadCode', async function () {
                await me.generateZip()
            });

            me.$EventBus.$on('elementTemplate', function (selectedObj) {
                var id = selectedObj.id
                var type = selectedObj.type

                if (selectedObj['selected']) {
                    me.selectedElementIds.push({id: id, type: type})
                } else {
                    var fidx = me.selectedElementIds.findIndex(obj => obj.id == id)
                    if (fidx != -1) {
                        me.selectedElementIds.splice(fidx, 1);
                    }
                }
            })

            if (localStorage.getItem("gitAccessToken")) {
                me.gitInfo.token = localStorage.getItem("gitAccessToken")
            }
            // me.templatePerElement();

            me.$EventBus.$on('prefferdToppings', async function (prefferdToppings) {
                var toppingList = JSON.parse(prefferdToppings)
                me.selectedVersion = 'java8'
                me.isJava15 = false
                me.selectedSecurity = null
                me.isSpringSecurity = false
                me.isKeycloakSecurity = false
                me.isServiceMesh = false
                me.isRollout = false
                me.isIngress = false
                me.isApolloGraphQL = false
                me.isJavaGraphQL = false
                if(toppingList.length<1) return false

                for(var i=0; i<toppingList.length; i++){
                    if(toppingList[i]=="apollo-graphql"){
                        me.isApolloGraphQL = true
                    }else if(toppingList[i]=="spring-security"){
                        me.selectedSecurity = "isSpringSecurity"
                        me.isKeycloakSecurity = false
                        me.isSpringSecurity = true
                    }else if(toppingList[i]=="keycloak-security"){
                        me.selectedSecurity = "isKeycloakSecurity"
                        me.isKeycloakSecurity = true
                        me.isSpringSecurity = false
                    }else if(toppingList[i]=="argo"){
                        me.isRollout = true
                    }else if(toppingList[i]=="istio"){
                        me.isServiceMesh = true
                    }else if(toppingList[i]=="ingress"){
                        me.isIngress = true
                    }else if(toppingList[i]=="java15"){
                        me.selectedVersion = "java15"
                    }
                }
            });
        },
        watch: {
            information: function () {
                var me = this
                if (me.information) {
                    if (me.information.authorEmail == me.userInfo.email) {
                        me.isMineProject = true
                    }
                    if (me.information.gitOrgName) {
                        me.gitOrgName = me.information.gitOrgName
                    } else {
                        if (me.isMineProject) {
                            if (localStorage.getItem("gitUserName")) {
                                me.gitOrgName = localStorage.getItem("gitUserName")
                            }
                        } else {
                            me.gitOrgName = null
                        }
                    }
                    if (me.information.gitRepoName) {
                        me.gitRepoName = me.information.gitRepoName
                    } else if (me.information.projectName) {
                        me.gitRepoName = me.information.projectName
                    }

                    if (!me.information.useIdeItem) {
                        me.useIdeItem = 'gitpod'
                    } else {
                        me.useIdeItem = me.information.useIdeItem
                    }
                }
            },
            "templateSendCnt": _.debounce(function () {
                if (this.templateSendCnt != -1
                    && this.toppingSendCnt != -1
                    && (this.templateSendCnt == this.templateDoneCnt)
                    && (this.toppingSendCnt == this.toppingDoneCnt)
                ) {
                    this.isListSettingDone = true
                }
            }, 500),
            oldTreeHashLists: function () {
                this.isChangedPathLists = true
            },
            changedTemplateCode: {
                handler:
                    _.debounce(function (newVal, oldVal) {
                        var me = this

                        // isClosedTemplateCode false
                        if (!me.isClosedTemplateCode || me.ideWindow) {

                            if (me.changedTemplateCode) {
                                clearTimeout(me.autoSyncTemplateId)
                                //LEEE
                                me.autoSyncTemplateId = setTimeout(function () {
                                    me.getListSetting()
                                    me.changedTemplateCode = false
                                }, 500)
                            }
                        } else if (newVal) {
                            // close code &  changed
                            me.changedTemplateCode = false
                        }
                    }, 1000)
            },
            "selectedVersion": function (newVal, oldVal) {
                if (newVal == 'java15') {
                    this.isJava15 = true
                } else {
                    this.isJava15 = false
                }
                this.changedTopping()
            },
            "selectedSecurity": function (newVal) {
                if (newVal == 'isSpringSecurity') {
                    this.isKeycloakSecurity = false
                    this.isSpringSecurity = true
                } else if (newVal == 'isKeycloakSecurity') {
                    this.isKeycloakSecurity = true
                    this.isSpringSecurity = false
                } else {
                    this.isKeycloakSecurity = false
                    this.isSpringSecurity = false
                }
                this.changedTopping()
            },
            copyValue: {
                deep: true,
                handler: function (newVal, oldVal) {
                    var me = this
                    var delta = jsondiffpatch.diff(oldVal, newVal);
                    if (me.initLoad && delta) {
                        if (me.embeddedCanvasDialog && me.embeddedCanvasType == "Domain Class Modeling") {
                            me.changedByMe = true;
                        }
                        me.modifiedElement(delta)
                    }
                }
            },
            "initLoad": async function (newVal) {
                if (newVal && !this.setTreeHashLists) {
                    await this.getListSetting();
                }
            },
            openCodeWeb() {
                // if (!this.changedModifying) {
                var localCode = this.openCode[0] && this.openCode[0].code ? this.openCode[0].code : null
                // this.MonacoEditor = localCode
                if (this.openCodeWeb[0]) {
                    var ideCode = this.openCodeWeb[0].code
                    var result = this.diff_lineMode(localCode, ideCode)
                    var tmp = JSON.parse(JSON.stringify(this.openCodeWeb))
                    var tmpCode = ""
                    result.forEach(function (data) {
                        /*
                            0: 유지 / 1: 추가 / -1: 제거
                        * */
                        tmpCode = tmpCode.concat(data[1])
                    })
                    tmp[0].code = tmpCode
                    this.openCodeMerge = tmp
                } else {
                    this.openCodeMerge = localCode
                }
            },

            changedModifying: async function (newVal) {
                var me = this

                if (newVal) {
                    var parser = new ConfigIniParser("\n")
                    var initContent = await me.getGitConfig()
                    // parser.parse(iniContent);
                    var parseConfig = parser.parse(initContent);
                    parseConfig._ini.sections.forEach(function (section) {
                        if (section.name.includes('origin')) {
                            section.options.forEach(function (option) {
                                if (option.name == 'url') {
                                    me.linkedSCM = true;
                                    me.scmUrl = option.value
                                }
                            })

                        }
                    })
                }
            },
            "projectName":
                _.debounce(function (newVal, oldVal) {
                    var me = this
                    if (me.initLoad) me.changed = true
                    if (newVal) {
                        if (me.gitRepoName == null) {
                            me.gitRepoName = newVal
                        }
                        me.gitInfo.name = newVal
                        me.projectNameHint = null
                        me.projectNameColor = null
                    } else {
                        me.projectNameHint = 'Project name is required.'
                        me.projectNameColor = 'red'
                    }
                }, 0),
            treeList: _.debounce(function () {
                var me = this
                // me.mergeTreeList = JSON.parse(JSON.stringify(me.treeList));
                me.mergeStatus = true
                // me.codeLoading = false
            }, 1000),
            fullPathList:
                function (newVal) {
                    var me = this
                    var list = newVal.reduce((children, value, idx) => {
                        value.fullPath.split('/').reduce((folder, o, i) => {
                            if (i === 0) {
                                var p = folder;
                            } else {
                                var p = folder.children = folder.children || [];
                            }
                            let f = p.find(x => x.name === o.trim());

                            if (!f) {

                                f = {
                                    bcId: value.bcId,
                                    name: o.trim(),
                                    key: me.findFile(value, o.trim()).key,
                                    file: me.findFile(value, o.trim()).file,
                                    code: me.findFile(value, o.trim()).code,
                                    hash: me.findFile(value, o.trim()).hash,
                                    // beforeFullPath: value.beforeFullPath,
                                    path: value.fullPath,
                                    changed: 0,
                                }
                                p.push(f);
                            } else {
                                var newCode = me.findFile(value, o.trim()).code;
                                var type = me.findFile(value, o.trim()).file
                                var existCode = f.code;
                                if ((newCode != undefined) && (existCode != undefined)) {
                                    f.code = me.lineTolineCheck(existCode, newCode);
                                    if (type == 'java') {
                                        f.code = me.codeAlign(f.code)
                                    }
                                    me.NewMergeCodeList[f.path] = f
                                }
                            }
                            // if (codeValue.file == 'java') {
                            //     codeValue.code = me.codeAlign(codeValue.code)
                            // }
                            return f;
                        }, children);

                        if (idx == newVal.length - 1) {
                            me.codeStatus = true;
                        }
                        return children;
                    }, []);

                    // setting preferredPlatform & Root Folder
                    list.forEach(function (tree, index) {
                        //check BC
                        var getBcId = tree.bcId
                        var getBc = getBcId ? me.value.elements[getBcId] : null

                        if (getBc) {
                            tree.preferredPlatform = getBc.preferredPlatform

                            if (!getBc.preferredPlatform) {
                                getBc.preferredPlatform = 'spring-boot'
                                tree.preferredPlatform = 'spring-boot'
                            }
                        }
                    })

                    // me.isNewTemplateCode(list)
                    me.treeList = list
                },

            async preferredToppingPlatforms() {
                var me = this
                await me.getListSetting()

                me.$nextTick(function () {
                    me.treeOpen = true
                })
            },
            async template() {
                var me = this
                if (me.template == 'GIT') {
                    /* Prompt -> Dialog  */
                    if (me.gitUrl.length < 3) {
                        if (!window.localStorage.getItem("gitAccessToken")) {
                            me.gitAccessTokenIs = false
                        } else {
                            me.gitAccessTokenIs = true
                        }
                        me.gitAccessInput = true
                        me.codeModalWidth = '90%';
                        return;
                    } else {
                        me.gitAccessInput = true
                    }


                    await me.gitTemplate().then(function () {
                        me.getListSetting()

                        me.$nextTick(function () {
                            me.treeOpen = true
                        })
                    })
                } else {
                    me.getListSetting()

                    me.$nextTick(function () {
                        me.treeOpen = true
                    })
                }
            },
        },
        methods: {
            lineTolineCheck(existCode, newCode) {
                var me = this;
                var existSplit = existCode.split("\n");
                var newSplit = newCode.split("\n");
                var resultArray = [];
                var result;
                newSplit.forEach(function (newLine, newIdx) {
                    existSplit.some(function (existLine, existIdx) {
                        var checked = false;
                        if (newLine == existLine) {
                            checked = true;
                            return true;
                        }
                        if ((existIdx == existSplit.length - 1) && (checked == false)) {
                            resultArray.push(newLine);

                        }
                    })
                    if (newIdx == newSplit.length - 1) {
                        if (resultArray.length > 0) {
                            var lastIndex = existSplit.lastIndexOf("}");
                            existSplit.splice(lastIndex, 0, ...resultArray)
                            result = existSplit.join("\n")
                        } else {
                            result = existCode
                        }
                    }
                })
                return result;
            },
            modelMigrate(value) {
                if (value.elements) {
                    Object.values(value.elements).forEach(function (element) {
                        if (element) {
                            if ((
                                    element._type.endsWith("BoundedContext")
                                    || element._type.endsWith("Command")
                                    || element._type.endsWith("Event")
                                    || element._type.endsWith("Policy")
                                )
                                && !element.hexagonalView
                            ) {
                                element.hexagonalView = {
                                    '_type': `${element._type}Hexagonal`,
                                    'id': element.elementView.id,
                                    'x': 0,
                                    'y': 0,
                                    'width': 0,
                                    'height': 0,
                                    'style': JSON.stringify({})
                                }
                            }
                        }
                    })
                }

                if (value.relations) {
                    Object.values(value.relations).forEach(function (relation) {
                        if (relation) {
                            if (relation._type.endsWith("Relation") && !relation.hexagonalView) {
                                relation.hexagonalView = {
                                    '_type': `${relation._type}Hexagonal`,
                                    'id': relation.relationView.id,
                                    'x': 0,
                                    'y': 0,
                                    'width': 0,
                                    'height': 0,
                                    'style': JSON.stringify({})
                                }
                            }
                        }
                    })
                }

                return value
            },
            onMoveElementById(id, newValueStr, isHexagonal) {
                var me = this
                if (me.value && me.value.elements && me.value.elements[id]) {
                    var newValueObj = JSON.parse(newValueStr)
                    var modifiedView = isHexagonal ? me.value.elements[id].hexagonalView : me.value.elements[id].elementView

                    modifiedView.x = newValueObj.x
                    modifiedView.y = newValueObj.y
                    modifiedView.width = newValueObj.width
                    modifiedView.height = newValueObj.height
                }
            },
            onMoveRelationById(id, newValueObj, isHexagonal) {
                var me = this
                console.log('Event- onMoveRelationById')
                var modifiedView = isHexagonal ? me.value.relations[id].hexagonalView : me.value.relations[id].relationView

                if (me.value && me.value.relations && me.value.relations[id]) {
                    modifiedView.value = newValueObj
                }
            },
            addTemplateCode() {
                var me = this
                var uuid = me.uuid();
                var addCodeObj =
                    {
                        'element': null,
                        'fileName': 'test.yml',
                        'key': uuid,
                        'hash': 11111,
                        'code': 'test  ',
                        'file': 'txt',
                        'boundedContext': 'for-model',
                        'representativeFor': null,
                        'forEach': 'for-model'
                    }

                var addFullPath = {
                    'bcId': null,
                    'element': null,
                    'key': uuid,
                    'fullPath': 'kubernetes/test.yml',
                    'hash': 11111
                }

                me.fullPathList.push(addFullPath)
                me.getCodeList.push(addCodeObj)
            },
            alertError() {
                var me = this
                me.errorCount = 0
                me.errorList = []
                Object.values(me.value.elements).forEach(element => {
                    var eventComponent = element && me.$refs[`${element.elementView.id}`] ? me.$refs[`${element.elementView.id}`][0] : null
                    if (eventComponent) {
                        if (eventComponent.elementValidationResults.length > 0) {
                            me.errorCount = me.errorCount + eventComponent.elementValidationResults.length

                            Object.values(eventComponent.elementValidationResults).forEach(error => {
                                error.eleName = element.name

                                if (error.level == 'error') {
                                    error.priority = 1
                                } else if (error.level == 'warning') {
                                    error.priority = 2
                                } else {
                                    error.priority = 3
                                }

                                me.errorList.push(error)
                            })

                        }
                    }
                })

                me.errorList.sort(function (a, b) {
                    if (a.priority > b.priority) return 1;
                    if (a.priority < b.priority) return -1;
                })
            },
            showErrSnackBar(err) {
                var me = this
                me.ideSnackBar.timeout = -1
                me.ideSnackBar.show = true
                me.ideSnackBar.Text = err
                me.ideSnackBar.Color = "error"
                me.ideSnackBar.icon = "error"
                me.ideSnackBar.title = "Error"
            },
            openIdeAccept() {
                var me = this
                me.openIde = true
            },
            validationFromCode(code) {
                if (code == null) {
                    return null
                }

                if (code == undefined) {
                    return null
                }

                var validationCode = this.validationCodeLists[code]
                if (validationCode) {
                    validationCode.code = code
                    return validationCode
                }

                return null
            },
            async postParentWindow() {
                var me = this
                me.saveComposition('save');

            },
            setBeforeCode() {
                var me = this
                try {
                    var isExistCode = localStorage.getItem('beforeCode') ? true : false

                    function saveCode() {
                        var obj = {
                            projectId: me.modelingProjectId,
                            codeLists: me.fullPathList
                        }
                        localStorage.setItem('beforeCode', JSON.stringify(obj))
                    }

                    if (isExistCode) {
                        var getBeforeCodeStr = localStorage.getItem('beforeCode')
                        var getBeforeCodeObj = JSON.parse(getBeforeCodeStr)
                        var projectId = getBeforeCodeObj.projectId

                        if (projectId != me.params.projectId) {
                            //다른 프로젝트
                            saveCode()
                        }
                    } else {
                        if (me.getCodeList.length > 0) {
                            saveCode()
                        }
                    }
                } catch (e) {
                    console.log('setBeforeCode[Error] : ', e)
                }

            },
            findBeforeCodeByPath(obj) {
                var me = this
                // var beforeFullPath = obj.beforeFullPath
                var beforeFullPath = obj.path

                try {
                    if (beforeFullPath) {
                        var getBeforeCodeStr = localStorage.getItem('beforeCode')
                        if (getBeforeCodeStr) {
                            var getBeforeCodeObj = JSON.parse(getBeforeCodeStr)
                            var getBeforeCodeLists = getBeforeCodeObj.codeLists
                            var f = getBeforeCodeLists.find(codeObj => codeObj.fullPath == beforeFullPath)
                            var fIndex = getBeforeCodeLists.findIndex(codeObj => codeObj.fullPath == beforeFullPath)
                            var after = obj

                            var setValue = {
                                bcId: after.bcId,
                                code: after.code,
                                fullPath: after.path,
                                hash: after.hash,
                                key: after.key
                            }

                            if (f && fIndex != -1) {
                                // 기존 파일 대체.
                                // var before = getBeforeCodeLists[fIndex]
                                // element: before.element,
                                getBeforeCodeLists[fIndex] = setValue
                            } else {
                                // new File
                                getBeforeCodeLists.push(setValue)
                            }
                            localStorage.setItem('beforeCode', JSON.stringify(getBeforeCodeObj))

                            return f ? f : null
                        }
                        return null;
                    }
                    return null;
                } catch (e) {
                    console.log('findBeforeCodeByPath[Error] : ', e)
                    return null;
                }
            },
            closeGitInfo() {
                this.gitInfoDialog = false
            },
            setChangedPathLists() {
                this.showChangedPathLists = !this.showChangedPathLists
            },
            getTemplatePath(item) {
                return item.path != '/' ? item.path.replace(`/${item.name}`, '/') : ''
            },
            isChangedTemplate(codeItem) {
                var me = this

                if (!codeItem) {
                    return false
                }


                if (me.getDiffTreeLists && me.getDiffTreeLists.length == 0) {
                    return false
                }

                var path = codeItem.path
                var isFolder = codeItem.children && !codeItem.code ? true : false

                if (isFolder) {
                    var pathArray = path.split('/')
                    pathArray = pathArray.slice(0, -1);
                    var folderPath = pathArray.join('/')
                    var array = me.getDiffTreeLists.filter((item) => {
                        if (item
                            && item.startsWith(folderPath)
                            && folderPath != ''
                        ) {
                            return true
                        }
                    })

                    if (array.length > 0) {
                        return true
                    }

                } else {
                    if (me.getDiffTreeLists.indexOf(path) != -1) {
                        return true
                    }
                }

                return false
            },
            selectedOpen(newVal) {
                var me = this
                var itemLists = JSON.parse(JSON.stringify(newVal))
                var filterName = JSON.parse(JSON.stringify(me.projectName))
                filterName = me.filterProjectName(filterName)

                // open 할 File Path 경로.
                var autoOpenLists = [
                    {'src': `main/java/${filterName}`}
                ]

                function children(items, subItems) {
                    if (items) {
                        if (Array.isArray(items)) {
                            // folder lists
                            items.forEach(function (item) {
                                if (item.key == item.hash && item.children) {
                                    children(item, subItems)
                                }
                            })
                        } else {
                            // folder Inner
                            items.children.forEach(function (item, index) {
                                if (item.key == item.hash && item.children) {
                                    var existOpenList = subItems.findIndex(subKey => subKey == item.name) == -1 ? false : true
                                    if (existOpenList) {
                                        if (itemLists.findIndex(i => i.hash == item.hash) == -1) {
                                            itemLists.push(item)
                                        }
                                    }
                                    children(item, subItems)
                                }
                            })
                        }
                    }
                }

                try {
                    if (itemLists.length > 0) {
                        autoOpenLists.forEach(function (openItem) {
                            var mainPathKey = Object.keys(openItem)[0]
                            var subPathKeys = openItem[mainPathKey].split('/')
                            var findItems = itemLists.filter((item) => item.name == mainPathKey)
                            if (findItems) {
                                children(findItems, subPathKeys)
                            }
                        })
                    }

                    me.getTreeOpenLists = itemLists
                } catch (e) {
                    console.log('selectedOpen[Error] : ', e)
                    me.getTreeOpenLists = newVal
                }
            },
            selectedActive(newVal) {
                var me = this
                try {
                    if (newVal && newVal.length > 0) {
                        if (me.changedPathLists && me.changedPathLists.length > 0) {
                            var findIdx = me.changedPathLists.indexOf(newVal[0].path)
                            if (findIdx != -1) {
                                me.changedPathLists.splice(findIdx, 1)
                                if (me.changedPathLists.length == 0) {
                                    me.showChangedPathLists = false
                                }
                            }
                        }
                        me.changedDiffCode = []

                        if (newVal && newVal[0]) {
                            var oldFullObj = me.findBeforeCodeByPath(newVal[0])
                            var oldVal = oldFullObj ? oldFullObj : null


                            if (oldVal) {
                                var isExistDiff = jsondiffpatch.diff(newVal[0].code, oldVal.code) ? true : false
                                if (isExistDiff) {
                                    me.changedDiffCode.push(oldVal)
                                    me.changedDiffCodeViewer = true
                                } else {
                                    // Equals File
                                    me.changedDiffCode = []
                                    me.changedDiffCodeViewer = false
                                }
                            } else {
                                console.log('Is New File.')
                                // New File
                                me.changedDiffCode = []
                                me.changedDiffCodeViewer = false
                            }
                        } else {
                            //No Selected File
                            me.changedDiffCode = []
                            me.changedDiffCodeViewer = false
                        }

                        me.openCode = newVal
                    } else if (me.changedDiffCodeViewer) {
                        // Before Diff Mode
                        me.changedDiffCode = []
                        me.changedDiffCodeViewer = false
                    } else {
                        // Just Show Code
                        me.changedDiffCode = []
                        me.changedDiffCodeViewer = false
                        me.codePreviewLeftReSize()
                    }
                } catch (e) {
                    console.log('selectedActive[Error] : ', e)
                    me.openCode = []
                }
            },
            closeSeparate() {
                this.closeCodeViewer();
            },
            releaseNewTemplate(item) {
                console.log(item)

            },
            async messageProcessing(e) {
                var me = this;
                if (e.data.message === 'changedMode') {
                    await me.getListSetting();
                } else if (e.data.message === "hello") {
                    alert("Hello world")
                } else if (e.data.message === "gitlab-login") {
                    var getUsers = e.data.data;
                    window.localStorage.setItem("gitAuthor", getUsers.data.email)
                    window.localStorage.setItem("gitUserName", getUsers.data.username)
                    window.localStorage.setItem("gitEmail", getUsers.data.email)
                    window.localStorage.setItem("gitToken", getUsers.data.accessToken)
                    me.gitUsers = getUsers;
                }
            },
            async changePreferredPlatform(item, selectedTemplate) {
                var me = this
                var eleId = item.bcId
                if (eleId && me.value.elements[eleId]) {
                    me.changedByMe = true
                    me.value.elements[eleId].preferredPlatform = selectedTemplate
                }

                if (selectedTemplate == 'Custom Template') {
                    /* Prompt -> Dialog  */
                    if (me.gitUrl.length < 3) {
                        if (!window.localStorage.getItem("gitAccessToken")) {
                            me.gitAccessTokenIs = false
                        } else {
                            me.gitAccessTokenIs = true
                        }
                        me.gitAccessInput = true
                        me.codeModalWidth = '90%';
                        return;
                    } else {
                        me.gitAccessInput = true
                    }


                    await me.gitTemplate().then(function () {
                        me.getListSetting()

                        me.$nextTick(function () {
                            me.treeOpen = true
                        })
                    })
                } else {
                    me.getListSetting()

                    me.$nextTick(function () {
                        me.treeOpen = true
                    })
                }


            },

            // Code Generate for BoundedContext
            newGenerateCode(boundedContext, element) {
                var me = this
                var pathTmp = []
                var boundedName = boundedContext;

                var data = {fullPathList: [], getCodeList: []}
                me.fullPathList.forEach(function (item) {
                    if (item.fullPath.split("/")[0] == boundedName) {
                        data.fullPathList.push(item)
                    }
                })
                me.getCodeList.forEach(function (item) {
                    if (item.boundedContext == boundedName) {
                        data.getCodeList.push(item)
                    }
                })
                var treeList = data.fullPathList.reduce((children, value) => {
                    value.fullPath.split('/').reduce((folder, o, i) => {

                        if (i === 0) {
                            var p = folder;
                        } else {
                            var p = folder.children = folder.children || [];
                        }

                        let f = p.find(x => x.name === o.trim());

                        if (!f) {
                            f = {
                                name: o.trim(),
                                key: findFile(value, o.trim()).key,
                                file: findFile(value, o.trim()).file,
                                code: findFile(value, o.trim()).code,
                                hash: findFile(value, o.trim()).hash,
                            }

                            p.push(f);
                        }

                        return f;
                    }, children);

                    return children;
                }, []);

                function reverse(item, path) {
                    var me = this
                    item.forEach(function (list) {
                        if (list.children) {
                            //폴더 생성하기
                            var tmpPath = path + '/' + list.name
                            reverse(list.children, tmpPath);
                        } else {
                            //파일생성하
                            if (list.code) {
                                pathTmp.push({path: path + '/' + list.name, code: list.code})
                            }
                        }
                    })
                };

                function findFile(value, name) {
                    var ob = null
                    var hash = value.hash ? value.hash : null

                    data.getCodeList.some(function (meta) {
                        if (meta.hash == hash && meta.fileName == name) {
                            ob = {
                                key: meta.key,
                                code: meta.code,
                                file: meta.file,
                                hash: meta.hash,
                            }
                            return true;
                        }
                    })
                    if (!ob) {
                        ob = {
                            key: hash ? hash : name,
                            hash: hash ? hash : name
                        }
                    }
                    return ob
                };

                treeList.forEach(function (list) {
                    if (list.file == undefined) {
                        reverse(list.children, list.name)
                    } else {
                        pathTmp.push({path: list.name, code: list.code})
                    }
                })

                // me.attachedLists.boundedContextLists
            },
            codePreviewLeftReSize() {
                this.codePreviewLeftReSizeNumber++

                if (this.codePreviewLeftReSizeNumber == 1) {
                    $(".code-preview-left-re-size").css("display", "none");
                } else if (this.codePreviewLeftReSizeNumber == 2) {
                    $(".code-preview-left-re-size").css("display", "block");
                    this.codePreviewLeftReSizeNumber = 0
                }
            },
            closeCodeViewer() {
                var me = this
                // this.$modal.hide('code-modal')
                localStorage.setItem('openCode', JSON.stringify(me.openCode))
                // this.openCode = []
                me.paneLengthPercent = 100
            },
            openCodeViewer() {
                var me = this
                // this.$modal.show('code-modal')
                me.paneLengthPercent = 35
            },
            closeIDEViewer() {
                this.$modal.hide('ide-modal')
            },
            openIDEViewer() {
                this.$modal.show('ide-modal')
            },
            changedTopping() {
                var list = []
                if (this.isApolloGraphQL) {
                    list.push('apollo-graphql')
                }
                if (this.isSpringSecurity) {
                    list.push('spring-security')
                }
                if (this.isKeycloakSecurity) {
                    list.push('keycloak-security')
                }
                if (this.isRollout) {
                    list.push('argo')
                }
                if (this.isServiceMesh) {
                    list.push('istio')
                }
                if (this.isIngress) {
                    list.push('ingress')
                }
                //java version
                if (this.isJava15) {
                    list.push('java15')
                }
                this.preferredToppingPlatforms = list
                this.setString('db://definitions/'+this.$route.params.projectId+'/information/prefferdToppings', JSON.stringify(this.preferredToppingPlatforms))
            },
            settingHexagonal(value) {
                var me = this
                var values = null
                if (value) {
                    values = JSON.parse(JSON.stringify(value))
                } else {
                    values = me.value
                }

                //// functions ////
                function descYPositionSort(arr) {
                    arr.sort(function (beforeElement, afterElement) {
                        return afterElement.hexagonalView.y - beforeElement.hexagonalView.y;
                    });
                    return arr
                }

                function ascYPositionSort(arr) {
                    arr.sort(function (beforeElement, afterElement) {
                        return beforeElement.hexagonalView.y - afterElement.hexagonalView.y;
                    });
                    return arr
                }

                //////////////


                var modelForElements = {
                    BoundedContext: [],
                    Aggregate: [],
                    Policy: [],
                    Event: [],
                    Command: [],
                    Relation: [],
                };

                if (values) {
                    if (values.elements) {
                        Object.keys(values.elements).forEach(function (id) {
                            var element = values.elements[id]
                            if (element) {
                                var typeSplit = element._type.split(".");
                                var type = typeSplit[typeSplit.length - 1]

                                if (!values.elements[id].hexagonalView
                                    || (values.elements[id].hexagonalView
                                        && Object.values(values.elements[id].hexagonalView).filter(x => x == 0).length >= 4
                                    )
                                ) {
                                    // 초기값 세팅.
                                    element.hexagonalView = JSON.parse(JSON.stringify(element.elementView));
                                    element.hexagonalView._type = `${element._type}Hexagonal`;
                                    values.elements[id].hexagonalView = element.hexagonalView

                                    if (!element._type.endsWith("BoundedContext")) {
                                        // 크기를 일정하게 처리.
                                        element.hexagonalView.width = 100
                                        if (element.name.length > 9)
                                            element.hexagonalView.width = 100 * (element.name.length / 9)
                                        element.hexagonalView.height = 35
                                    }

                                } else {
                                    // 기존값 세팅.
                                    element.hexagonalView = values.elements[id].hexagonalView
                                }

                                if (modelForElements[type])
                                    modelForElements[type].push(element)
                            }
                        })
                    }

                    if (values.relations) {
                        Object.keys(values.relations).forEach(function (id) {
                            var relation = values.relations[id]
                            if (relation) {
                                var typeSplit = relation._type.split(".");
                                var type = typeSplit[typeSplit.length - 1]

                                if (!values.relations[id].hexagonalView
                                    || (values.relations[id].hexagonalView && !values.relations[id].hexagonalView.value)) {
                                    // 초기값 세팅.
                                    relation.hexagonalView = JSON.parse(JSON.stringify(relation.relationView))
                                    relation.hexagonalView._type = `${relation._type}Hexagonal`
                                    values.relations[id].hexagonalView = relation.hexagonalView

                                } else {
                                    // 기존값 세팅.
                                    relation.hexagonalView = values.relations[id].hexagonalView
                                }

                                if (modelForElements[type])
                                    modelForElements[type].push(relation)
                            }
                        })
                    }

                    // BoundedContext inner setting
                    modelForElements.BoundedContext.forEach(bc => {
                            Object.values(values.elements).forEach((element, index) => {
                                if (element && element.hexagonalView && !element._type.endsWith("BoundedContext")) {

                                    var outer = {
                                        x: bc.hexagonalView.x - bc.hexagonalView.width / 2,
                                        y: bc.hexagonalView.y - bc.hexagonalView.height / 2,
                                        width: bc.hexagonalView.width,
                                        height: bc.hexagonalView.height
                                    }

                                    var inner = {
                                        x: element.hexagonalView.x - element.hexagonalView.width / 2,
                                        y: element.hexagonalView.y - element.hexagonalView.height / 2,
                                        width: element.hexagonalView.width,
                                        height: element.hexagonalView.height
                                    }


                                    if (this._isAttached(outer, inner)) {
                                        var bcElement = JSON.parse(JSON.stringify(values.elements[bc.elementView.id]))
                                        var typeSplit = element._type.split(".");
                                        var type = typeSplit[typeSplit.length - 1]
                                        if (bcElement) {
                                            if (!bcElement.innerElements) bcElement.innerElements = {}
                                            if (type == 'Command' || type == 'Policy') {
                                                //input
                                                if (!bcElement.innerElements.inputAdapters)
                                                    bcElement.innerElements.inputAdapters = []
                                                bcElement.innerElements.inputAdapters.push(element)
                                            } else if (type == 'Event') {
                                                //output
                                                if (!bcElement.innerElements.outputAdapters)
                                                    bcElement.innerElements.outputAdapters = []
                                                bcElement.innerElements.outputAdapters.push(element)
                                            } else {
                                                // etc
                                                if (!bcElement.innerElements[type]) {
                                                    bcElement.innerElements[type] = []
                                                }
                                                bcElement.innerElements[type].push(element)
                                            }
                                        }
                                    }
                                }
                            })
                        }
                    )


                    //setting BoundedContext
                    modelForElements.BoundedContext.forEach(bc => {
                        var standard = 30

                        if (bc) {
                            if (bc.hexagonalView.width < bc.hexagonalView.height) {
                                bc.hexagonalView.height = JSON.parse(JSON.stringify(bc.hexagonalView.width))
                            } else {
                                bc.hexagonalView.width = JSON.parse(JSON.stringify(bc.hexagonalView.height))
                            }
                        }


                        if (bc && bc.innerElements) {
                            //BoundedContext
                            var bcX = JSON.parse(JSON.stringify(bc.hexagonalView.x))
                            var bcY = JSON.parse(JSON.stringify(bc.hexagonalView.y))
                            var bcW = JSON.parse(JSON.stringify(bc.hexagonalView.width))
                            var bcH = JSON.parse(JSON.stringify(bc.hexagonalView.height))


                            //InputAdapters
                            if (bc.innerElements && bc.innerElements.inputAdapters) {
                                bc.innerElements.inputAdapters = descYPositionSort(bc.innerElements.inputAdapters)
                                var inputLen = bc.innerElements.inputAdapters.length
                                var xDistance = (bcW / 2) / inputLen
                                var yDistance = (bcH / 2) / inputLen

                                bc.innerElements.inputAdapters.forEach((inputAdapter, index) => {
                                    var itemH = inputAdapter.hexagonalView.height
                                    var itemW = inputAdapter.hexagonalView.width

                                    if ((standard < (bcH / 2 / inputLen)) || (standard * index) < (bcH / 2.2)) {
                                        // top
                                        if (yDistance < standard) {
                                            yDistance = standard
                                        } else if (yDistance > 65) {
                                            yDistance = 60
                                            xDistance = 60
                                        }

                                        inputAdapter.hexagonalView.y = (bcY - (itemH / 2)) - ((yDistance * index))
                                        inputAdapter.hexagonalView.x = (bcX - (bcW / 2)) - (itemW / 3) - (xDistance * 0.4 * index) + (xDistance * index)
                                    } else {
                                        // bottom
                                        inputAdapter.hexagonalView.y = (bcY - (itemH / 2)) + ((yDistance * (inputLen - index))) + 10
                                        inputAdapter.hexagonalView.x = (bcX - (bcW / 2)) - (itemW / 3) + (xDistance * (inputLen - index)) - (xDistance * 0.4 * (inputLen - index))
                                    }
                                })
                            }

                            //OutputAdapters
                            if (bc.innerElements && bc.innerElements.outputAdapters) {
                                var outputLen = bc.innerElements.outputAdapters.length
                                var xDistance = (bcW / 2) / bc.innerElements.outputAdapters.length
                                var yDistance = (bcH / 2) / bc.innerElements.outputAdapters.length

                                bc.innerElements.outputAdapters = ascYPositionSort(bc.innerElements.outputAdapters)
                                bc.innerElements.outputAdapters.forEach((outputAdapter, index) => {
                                    var itemH = outputAdapter.hexagonalView.height
                                    var itemW = outputAdapter.hexagonalView.width

                                    if ((standard < (bcH / 2 / outputLen)) || (standard * index) < (bcH / 2.2)) {
                                        // bottom
                                        if (yDistance < standard) {
                                            yDistance = standard
                                        } else if (yDistance > 65) {
                                            yDistance = 60
                                            xDistance = 60
                                        }
                                        outputAdapter.hexagonalView.y = (bcY + (itemH / 2)) + ((yDistance * index))
                                        outputAdapter.hexagonalView.x = (bcX + (bcW / 2)) + (itemW / 3) + (xDistance * 0.4 * index) - (xDistance * index)
                                    } else {
                                        // top
                                        outputAdapter.hexagonalView.y = (bcY + (itemH / 2)) - ((yDistance * (outputLen - index))) - 5
                                        outputAdapter.hexagonalView.x = (bcX + (bcW / 2)) + (itemW / 3) - (xDistance * (outputLen - index)) + (xDistance * 0.4 * (outputLen - index))
                                    }
                                })
                            }
                        }
                    })
                    //end BoundedContext

                    // setting Relation
                    modelForElements.Relation.forEach(relation => {
                        if (relation && relation.hexagonalView.value) {
                            // 직선 연결.
                            // var vertices = JSON.parse(relation.hexagonalView.value)
                            // var start = vertices[0]
                            // var end = vertices[vertices.length - 1]
                            // var newVertices = JSON.stringify([start, end])
                            //기존 연결
                            var newVertices = relation.hexagonalView.value

                            relation.hexagonalView.value = newVertices
                            relation.hexagonalView.style = null
                        }
                    })
                    // end Relation
                }
                return values
            },
            generateHexagonal(value) {
                var me = this
                me.hexagonalValue = me.settingHexagonal(value)
                if (me.hexagonalValue)
                    me.isHexagonal = true
            },
            generateModel() {
                var me = this
                me.isHexagonal = false
            },
            getGitConfig() {
                var me = this
                return new Promise(function (resolve, reject) {
                    var gitParams = new URLSearchParams();
                    var projectId = 'untitled'
                    if (me.isClazzModeling) {
                        projectId = me.$route.params.labId
                    } else {
                        projectId = me.$route.params.projectId;
                    }
                    var userName = localStorage.getItem("email").split('@')[0].toLowerCase();
                    var userGroup = localStorage.getItem("email").split('@')[1].split('.')[0].toLowerCase();
                    gitParams.append('filePath', `labs-eventstorming/running/${userGroup}/classes/users/labs/${localStorage.getItem("author")}`);
                    gitParams.append('lab', `${projectId}`);
                    var hashName;
                    if (me.$route.params.labId) {
                        if (me.$parent.labInfo.independent) {
                            var hashPath = me.getClassPath('labs/' + me.$route.params.labId + '/' + me.$route.params.userId);
                        } else {
                            var hashPath = me.getClassPath(me.$route.params.userId);
                        }
                        hashName = "labs-" + me.hashCode(hashPath);
                    } else {
                        hashName = `ide-${me.hashCode(userGroup + "-" + userName)}`
                    }

                    me.$http.get(`${me.getProtocol()}//file.kuberez.io/api/getGitConfig`, {
                        params: {
                            "hashName": hashName,
                            "filePath": `labs-eventstorming/running/${userGroup}/classes/users/labs/${localStorage.getItem("author")}`,
                            'lab': `${projectId}`
                        }
                    }).then(function (result) {
                        resolve(result.data)
                    }).catch(error => alert(error))
                })
            },
            closeCodeModal() {
                // this.openCode = [];
                this.changedModifying = false;
            },
            closeResourceQuota(ide, tool) {
                if (ide) {
                    //ide
                    this.resourceQuota = ide.resourceQuota
                    this.resourceType = ide.resourceType
                    //tool
                    this.toolResourceQuota = tool.resourceQuota
                    this.toolResourceType = tool.resourceType
                    //status
                    this.setResourceQuota = true
                }
                this.resourceQuotaDialog = false
            },
            updatePathTmp(update) {
                var me = this
                // if (me.ideWindow) {
                //     console.log(postMessage);
                //     me.ideWindow.postMessage({
                //         "message": "code",
                //         "type": "update",
                //         "path": update.path,
                //         "content": update.code
                //     });
                // }
                me.pathTmp.forEach(function (item) {
                    if (item.hash == update.hash) {
                        item.code = update.code
                    }
                })
            },
            cancelModify() {
                var me = this
                this.cancelModifying = false
                me.$EventBus.$emit("openProgressing");
                me.closeCodeViewer()
                // this.$modal.hide('code-modal')
                // this.openCode = []
            },
            endModify() {
                var me = this
                this.changedModifying = false
                me.$EventBus.$emit("openProgressing");
                me.closeCodeViewer()
            },
            async checkedPaidItem() {
                var me = this
                me.isDownloading = true

                if (window.MODE == "onprem") {
                    return await me.generateZip()
                } else {
                    if (me.isLogin) {
                        var convertEmail = me.userInfo.email.replace(/\./gi, '_')
                        var getItemId = null
                        var isPaid = false
                        // var isPaid = true // free

                        if (me.isClazzModeling) {
                            var classInfo = await this.getClassInfo()
                            var labInfo = await this.getLabInfo()
                            getItemId = `${me.canvasType}_${classInfo.courseId}@${classInfo.classId}@${labInfo.labId}`
                            me.purchaseItemDialogInfo.className = classInfo.className
                            me.purchaseItemDialogInfo.labName = labInfo.labName
                            if (classInfo && !classInfo.openClass && classInfo.connectionKey) {
                                isPaid = true
                            }
                        } else {
                            getItemId = `${me.canvasType}_${me.modelingProjectId}`
                        }

                        if (!isPaid) {
                            var checkSubscription = await me.getObject(`db://enrolledUsers/${convertEmail}/purchaseItemSnapshots/subscription`)
                            if (checkSubscription) {
                                var checkExpired = checkSubscription.expiredDate ? checkSubscription.expiredDate : 0
                                if (typeof checkExpired == 'string') checkExpired = Number(checkExpired)
                                if (checkExpired == 0 || Date.now() < checkExpired) {
                                    if (checkSubscription.downloadCode != 0) {
                                        isPaid = true
                                    }
                                }
                            } else {
                                var checkItem = await me.getObject(`db://enrolledUsers/${convertEmail}/purchaseItemSnapshots/${getItemId}`)
                                if (checkItem) {
                                    var checkExpired = checkItem.expiredDate ? checkItem.expiredDate : 0
                                    if (typeof checkExpired == 'string') checkExpired = Number(checkExpired)
                                    if (checkExpired == 0 || Date.now() < checkExpired) {
                                        isPaid = true
                                    }
                                }
                            }
                        }

                        if (isPaid || me.isForeign) {
                            await me.generateZip()
                        } else {
                            me.purchaseItemDialogOpen(getItemId)
                        }

                    } else {
                        me.$EventBus.$emit('showLoginDialog', true)
                    }
                }

            },

            async purchaseItemDialogSubmit(result) {
                var me = this
                try {
                    if (result) {
                        var returnResult = false
                        var type = me.purchaseItemDialogInfo.resourceType
                        if (type == 'codeView') {
                            returnResult = await me.codeModalShow()
                        } else if (type == 'downloadCode') {
                            returnResult = await me.generateZip()
                        }

                        if (returnResult) {
                            alert(`'${type}' 를 성공 하였습니다.`)
                        } else if (returnResult == false) {
                            me.purchaseItemDialogClose(false)
                            alert(`'${type}' 를 실패 하였습니다.`)
                        }
                    } else {
                        alert('결제를 실패했습니다.')
                    }
                    me.purchaseItemDialogClose()
                } catch (e) {
                    me.purchaseItemDialogClose()
                }
            },
            diff_lineMode(text1, text2) {
                var dmp = new DiffMatchPatch();
                var a = dmp.diff_linesToChars_(text1, text2);
                var lineText1 = a.chars1;
                var lineText2 = a.chars2;
                var lineArray = a.lineArray;
                var diffs = dmp.diff_main(lineText1, lineText2, false);
                dmp.diff_charsToLines_(diffs, lineArray);
                return diffs;
            },
            connectableType(source, target) {
                var me = this
                if (source._type.endsWith('Event') &&
                    (target._type.endsWith('Policy') || target._type.endsWith('Command') || target._type.endsWith('External'))) {
                    return true
                } else if (source._type.endsWith('Policy') && target._type.endsWith('Event')) {
                    return true
                } else if (source._type.endsWith('View') && target._type.endsWith('Aggregate')) {
                    return true
                } else if (
                    source._type.endsWith('External') &&
                    (target._type.endsWith('Policy') || target._type.endsWith('Command'))
                ) {
                    return true
                } else if (
                    source._type.endsWith('Aggregate') &&
                    (target._type.endsWith('External'))
                ) {
                    return true
                } else if (
                    source._type.endsWith('Command') &&
                    (target._type.endsWith('View') || target._type.endsWith('Aggregate'))
                ) {
                    return true
                } else if (
                    source._type.endsWith('Command') && target._type.endsWith('Event')) {
                    if (!source.boundedContext && !target.boundedContext) {
                        // same
                        return true
                    } else if (source.boundedContext.id == target.boundedContext.id) {
                        return true
                    } else {
                        me.alertInfo.show = true
                        me.alertInfo.text = '동일 BoundedContext만 연결 가능 합니다.'
                    }
                } else if (
                    source._type.endsWith('Command') &&
                    (target._type.endsWith('View') || target._type.endsWith('Aggregate'))
                ) {
                    if (source.boundedContext.id == target.boundedContext.id) {
                        me.alertInfo.show = true
                        me.alertInfo.text = '같은 BoundedContext로 연결 불가능 합니다.'
                    } else {
                        if (source.restRepositoryInfo.method == "POST" || source.restRepositoryInfo.method == "DELETE" || source.restRepositoryInfo.method == "PATCH") {
                            if (!source.trigger || source.trigger == undefined) {
                                if (source.restRepositoryInfo.method == "POST") {
                                    source.trigger = "@PrePersist"
                                } else if (source.restRepositoryInfo.method == "DELETE") {
                                    source.trigger = "@PreRemove"
                                } else if (source.restRepositoryInfo.method == "PATCH") {
                                    source.trigger = "@PreUpdate"
                                }
                            }
                            var targetCamelCase = _.camelCase(target.name)
                            source.connectedName = {
                                name: target.name,
                                namePascalCase: targetCamelCase.substring(0, 1).toUpperCase() + targetCamelCase.substring(1),
                                namePlural: pluralize(targetCamelCase)
                            }
                            return true
                        } else {
                            me.alertInfo.show = true
                            me.alertInfo.text = '지원하지 않는 Methods 타입 입니다.'
                        }
                    }
                } else if (
                    source._type.endsWith('Policy') &&
                    (target._type.endsWith('View') || target._type.endsWith('Aggregate'))
                ) {
                    if (source.boundedContext.id == target.boundedContext.id) {
                        me.alertInfo.show = true
                        me.alertInfo.text = '같은 BoundedContext로 연결 불가능 합니다.'
                    } else {
                        return true
                        if (source.restRepositoryInfo.method == "POST" || source.restRepositoryInfo.method == "DELETE" || source.restRepositoryInfo.method == "PATCH") {
                            if (!source.trigger || source.trigger == undefined) {
                                if (source.restRepositoryInfo.method == "POST") {
                                    source.trigger = "@PrePersist"
                                } else if (source.restRepositoryInfo.method == "DELETE") {
                                    source.trigger = "@PreRemove"
                                } else if (source.restRepositoryInfo.method == "PATCH") {
                                    source.trigger = "@PreUpdate"
                                }
                            }
                            var targetCamelCase = _.camelCase(target.name)
                            source.connectedName = {
                                name: target.name,
                                namePascalCase: targetCamelCase.substring(0, 1).toUpperCase() + targetCamelCase.substring(1),
                                namePlural: pluralize(targetCamelCase)
                            }

                        } else {
                            me.alertInfo.show = true
                            me.alertInfo.text = '지원하지 않는 Methods 타입 입니다.'
                        }
                    }
                } else if (source._type.endsWith('Aggregate') && target._type.endsWith('Aggregate')) {
                    // if (source.boundedContext.id == target.boundedContext.id) {
                    //     return false
                    // }
                    return true
                }

                return false
            },
            onConnectShape: function (edge, from, to) {
                var me = this;
                //존재하는 릴레이션인 경우 (뷰 ��포넌트), 데이터 매핑에 의해 자동으로 from, to 가 변경되어있기 때문에 따로 로직은 필요없음.
                //=> 바뀌어야 함.
                //신규 릴레이션인 경우에는 릴레이션 생성
                var edgeElement, originalData;
                var isComponent = false;
                if (edge.shape) {
                    edgeElement = edge;
                }
                // else {
                //     isComponent = true;
                //     edgeElement = edge.element;
                // }

                if (edgeElement && from && to) {
                    var vertices = '[' + edgeElement.shape.geom.vertices.toString() + ']';
                    var componentInfo = {
                        component: 'class-relation',
                        sourceElement: from.$parent,
                        targetElement: to.$parent,
                        vertices: vertices,
                        isFilled: true,
                        isRelation: true,
                        relationView: {
                            style: JSON.stringify({}),
                            value: vertices,
                        }
                    }

                    from.$parent.value.elementView.id = from.id;
                    to.$parent.value.elementView.id = to.id;

                    // if (isComponent) {
                    //     me.canvas.removeShape(edgeElement, true);
                    //     //this.removeComponentByOpenGraphComponentId(edgeElement.id);
                    //     //기존 컴포넌트가 있는 경우 originalData 와 함께 생성
                    //
                    //     if (me.connectableType(componentInfo.sourceElement.value, componentInfo.targetElement.value))
                    //         this.addElement(componentInfo)
                    // } else {
                    me.canvas.removeShape(edgeElement, true);
                    //기존 컴포넌트가 없는 경우 신규 생성
                    if (me.connectableType(componentInfo.sourceElement.value, componentInfo.targetElement.value) && me.validateRelation(from.id, to.id)) {
                        this.addElement(componentInfo);
                    }


                    // }
                }
            },
            addElement: function (componentInfo, bounded) {
                // console.log("추가");
                this.enableHistoryAdd = true;
                var me = this;
                var additionalData = {};
                var vueComponent = me.getComponentByName(componentInfo.component);
                var element;

                if (componentInfo.isRelation && componentInfo.component.includes('relation')) {
                    /* make Relation */
                    element = vueComponent.computed.createNew(
                        this.uuid(),
                        componentInfo.sourceElement.value,
                        componentInfo.targetElement.value,
                        componentInfo.vertices,
                    );

                } else if (componentInfo.component.includes('line')) {
                    var vertices = [[componentInfo.x, componentInfo.y], [componentInfo.x + 200, componentInfo.y]]
                    vertices = JSON.stringify(vertices)

                    element = vueComponent.computed.createNew(
                        this.uuid(),
                        vertices
                    );

                } else {
                    /* make Element */
                    element = vueComponent.computed.createNew(
                        this.uuid(),
                        componentInfo.x,
                        componentInfo.y,
                        componentInfo.width,
                        componentInfo.height,
                        componentInfo.description,
                        componentInfo.label
                    );
                }

                me.addElementPush(element)

                return element;
            },
            filterProjectName(projectName) {
                var filterName = ''
                var pattern1 = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi; //특수문자 제거
                var pattern2 = /[0-9ㄱ-ㅎ|ㅏ-ㅣ|가-힣~!@#$%^&*()_+|-|<>?:{}]/gi; // 한글 제거


                if (projectName) {
                    filterName = projectName

                    if (pattern1.test(filterName)) {
                        filterName = filterName.replace(pattern1, '');
                    }
                    if (pattern2.test(filterName)) {
                        filterName = filterName.replace(pattern2, '');
                    }
                    filterName = filterName.toLowerCase()
                    return filterName == '' ? 'untitled' : filterName
                }
                return filterName
            },
            // getCode(path, code) {
            //     var me = this
            //     return new Promise(async function (resolve, reject) {
            //         if (!me.myId || me.myId == null) {
            //             me.myId = localStorage.getItem('email')
            //         }
            //         var getCodeUrl = await me.getURL(`cluster://running/${me.myId.split('@')[1].split('.')[0].toLowerCase()}/classes/users/labs/${me.myId}/${me.$route.params.projectId}/` + path, 'eventstorming')
            //         me.$http.defaults.headers = {
            //             'Cache-Control': 'no-cache',
            //             'Pragma': 'no-cache',
            //             'Expires': '0',
            //         };
            //         me.$http.get(getCodeUrl).then(function (data) {
            //             resolve(data.data)
            //         }).catch((e) => {
            //             if (e.response)
            //                 if (e.response.status == 404) {
            //                     // 404 Error -> 파일이 없을 시에 파일을 Upload 처리함
            //                     if (me.ideWindow) {
            //                         var projectId
            //                         if (me.information && me.information.projectId) {
            //                             projectId = me.information.projectId
            //                         } else {
            //                             projectId = me.params.projectId
            //                         }
            //                         me.ideWindow.postMessage({
            //                             "message": "code",
            //                             "type": "create",
            //                             "path": projectId + "/" + path,
            //                             "content": code
            //                         });
            //                     }
            //                 }
            //             resolve(null);
            //         })
            //         // var result = await me.getString(`cluster://${me.myId.split('@')[1].split('.')[0].toLowerCase()}/classes/running/users/labs/${me.myId}/${me.$route.params.projectId}/` + path, 'eventstorming');
            //         // resolve(getCodeUrl)
            //     })
            // },
            getComponentByClassName: function (className) {
                var componentByClassName;
                var hexagonalElements = ['domain-event-definition', 'command-definition', 'policy-definition', 'bounded-context-definition',]
                var me = this



                $.each(window.Vue.eventStormingModelingComponents, function (i, component) {
                    if (component.default.computed
                        && component.default.computed.className
                        && component.default.computed.className() == className
                    ) {
                        componentByClassName = component.default;
                        if(me.isHexagonalModeling && !hexagonalElements.includes(component.default.name) ){
                            componentByClassName = null
                        }
                    }
                });

                return componentByClassName;
            },
            changeUrl(state, title, url) {
                if (typeof (history.pushState) != "undefined") { //브라우저가 지원하는 경우
                    history.pushState(state, title, url);
                } else {
                    location.href = url; //브라우저가 지원하지 않는 경우 페이지 이동처리
                }
            },
            tokenSave() {
                var me = this
                localStorage.setItem('kubernetesToken', me.kubernetesToken);
                localStorage.setItem('clusterAddress', me.clusterAddress);
                me.tokenDialog = false
            },
            logEvent(event) {
                console.log('Event : ', event);
            },
            onError(error, stream) {
                console.log('On Error Event', error, stream);
            },
            applyChange(target, source, change) {
                if (typeof change === 'undefined' && source && ~validKinds.indexOf(source.kind)) {
                    change = source;
                }
                if (target && change && change.kind) {
                    var it = target,
                        i = -1,
                        last = change.path ? change.path.length - 1 : 0;
                    while (++i < last) {
                        if (typeof it[change.path[i]] === 'undefined') {
                            it[change.path[i]] = (typeof change.path[i + 1] !== 'undefined' && typeof change.path[i + 1] === 'number') ? [] : {};
                        }
                        it = it[change.path[i]];
                    }
                    switch (change.kind) {
                        case 'A':
                            if (change.path && typeof it[change.path[i]] === 'undefined') {
                                it[change.path[i]] = [];
                            }
                            applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
                            break;
                        case 'D':
                            delete it[change.path[i]];
                            break;
                        case 'E':
                        case 'N':
                            it[change.path[i]] = change.rhs;
                            break;
                    }
                }
            },
            difference(object, base) {
                function changes(object, base) {
                    return _.transform(object, function (result, value, key) {
                        if (!_.isEqual(value, base[key])) {
                            result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
                        }
                    });
                }

                return changes(object, base);
            },

            showReplay() {
                var me = this
                if (false) {
                    alert('준비중 입니다.')
                } else {
                    var proId = me.information.projectId ? me.information.projectId : me.modelingProjectId
                    var author = me.information.author ? me.information.author : me.params.userUid
                    let route = me.$router.resolve({path: `/replay/${proId}/last/last`});
                    window.open(route.href, '_blank');
                }

            },
            async functionSelect(title) {
                var me = this
                if (title == 'Save to Server') {
                    if (me.isClazzModeling) {
                        me.uploadMinio();
                    } else {
                        me.saveComposition('save')
                    }
                } else if (title == 'Duplicate') {
                    me.saveComposition('duplicate')
                    // me.storageDialogReady('duplicate')
                } else if (title == 'Git URL for Model') {
                    me.gitInfoDialog = true
                } else if (title == 'Download model File') {
                    me.downloadModelToJson()
                } else if (title == 'Code Preview') {
                    me.codeModalShow()
                } else if (title == 'Download Archive') {
                    me.generateZipDialog = true
                    me.isDownloading = false
                } else if (title == 'Share') {
                    // me.openEventShareDialog()
                    me.openInviteUsers()
                } else if (title == 'Reset Config') {
                    var hashName, userGroup, userName, projectId;
                    userName = localStorage.getItem("email").split('@')[0].toLowerCase();
                    userGroup = localStorage.getItem("email").split('@')[1].split('.')[0].toLowerCase();
                    if (me.isClazzModeling) {
                        projectId = me.$route.params.labId
                    } else {
                        projectId = me.$route.params.projectId;
                    }
                    if (me.$route.params.labId) {
                        if (me.$parent.labInfo.independent) {
                            var hashPath = me.getClassPath('labs/' + me.$route.params.labId + '/' + me.$route.params.userId);
                        } else {
                            var hashPath = me.getClassPath(me.$route.params.userId);
                        }
                        hashName = "labs-" + me.hashCode(hashPath);
                    } else {
                        hashName = `ide-${me.hashCode(userGroup + "-" + userName)}`
                    }
                    var obj = {
                        "course": `${userGroup}`,
                        "lab": `${userName}`,
                        "clazz": `${projectId}`,
                        "userId": localStorage.getItem("author").replace("@", "_")
                    }
                    await me.deleteConfig(hashName, obj);
                    await me.makeConfig(hashName, obj);
                } else if (title == 'Project IDE' || title == 'opentheiaIDE') {
                    // build에 영향을 주는 에러가 있다고 알림
                    me.alertError()
                    if (me.errorCount > 0) {
                        if (!me.openIde) {
                            me.projectIdeAlertDialog = true
                            return false
                        } else {
                            me.projectIdeAlertDialog = false
                        }
                    }

                    if (me.isLogin) {
                        me.ideSnackBar.wrongGitInfo = false
                        if (me.useIdeItem == 'gitpod' && title != 'opentheiaIDE' && window.MODE != "onprem") {
                            if (me.gitOrgName && me.gitRepoName) {
                                if(me.information){
                                    if(me.information.firstCommit == 'false'){
                                        window.open(`https://gitpod.io/#https://github.com/${me.gitOrgName}/${me.gitRepoName}/tree/main`, '_blank');
                                    } else {
                                        if(!this.information.forkedByModelGitOrgName || !this.information.forkedByModelGitRepoName){
                                            window.open(`https://gitpod.io/#https://github.com/${me.gitOrgName}/${me.gitRepoName}/tree/main`, '_blank');
                                        } else {
                                            window.open(`https://gitpod.io/#https://github.com/${me.information.forkedByModelGitOrgName}/${me.information.forkedByModelGitRepoName}/tree/main`, '_blank');
                                        }
                                    }
                                }
                            } else {
                                me.ideSnackBar.wrongGitInfo = true
                                me.showErrSnackBar("Gitpod로 실행시키려면 Git 로그인 또는 정보입력이 필요합니다.")
                            }
                        } else {
                            if (window.MODE == "onprem") {
                                me.openProjectIDE();
                            } else {
                                var idePrice = await this.getString(`db://pricing/ide`)
                                if (!idePrice) idePrice = 1000
                                if (me.getUserToolTime > 0) {
                                    me.openProjectIDE()
                                } else if (me.getUserCoin >= idePrice / 100) {
                                    me.$EventBus.$emit('autoToolPay');
                                    me.openProjectIDE()
                                } else {
                                    me.$EventBus.$emit('openPaymentTime', true)
                                }
                            }
                        }
                        me.openIde = false
                        // if (me.getUserToolTime > 0) {
                        // me.ideStartValidation()
                        // Todo: 파일을 변경 할 것 인지 체크 후 띄우기
                        // } else {
                        //     this.$EventBus.$emit('openPaymentTime', true)
                        // }
                    } else {
                        me.$EventBus.$emit('showLoginDialog')

                    }

                }
            },
            async saveGitToken() {
                var me = this
                if (me.gitAccessToken.length > 1) {
                    me.$http.defaults.headers.common['Authorization'] = `token ${me.gitAccessToken}`;
                    localStorage.setItem('gitAccessToken', me.gitAccessToken);
                    me.gitAccessInput = false;
                    me.codeModalWidth = '80%';
                    me.gitTemplate().then(function () {
                        me.getListSetting();
                    });
                } else {
                    me.codeModalhide();
                    me.alertInfo.show = true
                    me.alertInfo.text = "Github Persenal Access Token을 입력해주세요."
                    me.alertInfo.link = "https://github.com/TheOpenCloudEngine/msaschool/wiki/Github-Personal-Access-Token-%EB%B0%9C%ED%96%89-%EB%B0%A9%EB%B2%95"
                }


            },
            gitTemplate() {
                var me = this
                return new Promise(function (resolve, reject) {

                    me.$manifestsPerTemplate["Custom Template"] = [];

                    me.gitRepository = me.gitUrl.split('/')[me.gitUrl.split('/').length - 2]
                    me.gitProject = me.gitUrl.split('/')[me.gitUrl.split('/').length - 1]

                    me.$http.get(`https://api.github.com/repos/` + me.gitRepository + '/' + me.gitProject + `/commits`).then(function (result) {
                        me.$http.get(`https://api.github.com/repos/` + me.gitRepository + '/' + me.gitProject + `/git/trees/` + result.data[0].sha).then(async function (test) {
                            await me.setGitList(test.data, me.gitRepository)
                            resolve()
                        })
                    }).catch(error => alert('gitTemplate:', error))
                })
            },
            setGitList(element, repository) {
                var me = this
                me.fullPathList = []
                me.getCodeList = []
                me.gitPath = []
                me.gitCode = []
                return new Promise(function (resolve) {
                    try {
                        me.$http.get(element.url + '?recursive=1').then(function (result) {
                            result.data.tree.forEach(function (ele, idx) {

                                var fileName = ele.path.split('/')[ele.path.split('/').length - 1]
                                if (ele.type != 'tree') {
                                    me.$manifestsPerTemplate["Custom Template"].push('./' + ele.path)
                                    me.gitCodeUrl[ele.path] = ele.url;
                                }
                                if (result.data.tree.length - 1 == idx) {
                                    resolve()
                                }
                            })
                        }).catch(error => console.log(error))
                    } catch (e) {
                        // console.log(e)
                    }
                })

            },

            _isAttached(outer, inner) {
                if (
                    //왼쪽 상단 모서리에 걸린 경우
                    (outer.x < inner.x + inner.width &&
                        outer.y < inner.y + inner.height)

                    &&

                    //우측 하단 모서리에 걸린 경우
                    (inner.x < outer.x + outer.width &&
                        inner.y < outer.y + outer.height)

                    &&

                    //오른쪽 상단 모서리에 걸린 경우
                    (inner.x < outer.x + outer.width &&
                        outer.y < inner.y + inner.height)

                    &&

                    //왼쪽 하단 모서리에 걸린 경우
                    (outer.x < inner.x + inner.width &&
                        inner.y < outer.y + outer.height)
                ) return true;

                return false;
            },
            changeCaseforView(item, eventName, viewName) {
                item.eventField.namePascalCase = changeCase.pascalCase(eventName)
                item.eventField.nameCamelCase = changeCase.camelCase(eventName)
                item.viewField.namePascalCase = changeCase.pascalCase(viewName)
                item.viewField.nameCamelCase = changeCase.camelCase(viewName)

                return item
            },
            convertModelForCodeGen(flatModel, projectName) {

                //projectName 소문자
                var me = this
                var filterName = JSON.parse(JSON.stringify(projectName))
                filterName = this.filterProjectName(filterName)

                // var pattern1 = /[0-9ㄱ-ㅎ|ㅏ-ㅣ|가-힣~!@#$%^&*()_+|<>?:{}]/gi; // 영어 소문자
                //
                // if (filterName) {
                //     if (pattern1.test(filterName)) {
                //         filterName = filterName.replace(pattern1, '');
                //     }
                //     filterName = filterName.toLowerCase()
                // }

                var rootModel = {
                    _type: "org.uengine.modeling.model.Model",
                    boundedContexts: [],
                    projectName: filterName,
                    URL: window.location.hash,
                    gitURL: me.gitURLforModel,
                    actors: [],
                    toppings: [],
                }

                var modelForElements = {
                    BoundedContext: [],
                    AggregateRoot: [],
                    Aggregate: [],
                    Entity: [],
                    ValueObject: [],
                    Enumeration: [],
                    Exception: [],
                    ModelElements: [],
                    Policy: [],
                    Event: [],
                    Command: [],
                    View: [],
                    RelationEventInfo: [],
                    RelationCommandInfo: [],
                    RelationViewInfo: [],
                    ViewEventInfo: [],
                    RelationExampleEventInfo: [],
                    Rules: [],
                    Actor: [],
                };

                // setting modelElements
                var modelElements = {
                    aggregates: [],
                    boundedContextes: []
                }
                var selectedTemplate = []

                if (me.template) {
                    selectedTemplate.push(me.template)
                }


                // var modelCopy = JSON.parse(JSON.stringify(flatModel.elements));
                // var modelCopy = []

                var elementsCopy = JSON.parse(JSON.stringify(flatModel.elements))
                var modelCopy = Object.values(elementsCopy)


                modelCopy.forEach(function (item) {
                    if (item) {
                        // 이름 없는 객체는 생성 안함
                        if (item.name.length === 0) {
                            return;
                        }

                        if (item.name) {
                            item.namePascalCase = changeCase.pascalCase(item.name)
                            item.nameCamelCase = changeCase.camelCase(item.name)
                            item.namePlural = pluralize(item.nameCamelCase);
                        }
                        if (item.fieldDescriptors) {
                            item.fieldDescriptors.forEach(function (val) {
                                val.namePascalCase = changeCase.pascalCase(val.name)
                                val.nameCamelCase = changeCase.camelCase(val.name)
                            })
                        }
                        if (item._type == 'org.uengine.modeling.model.BoundedContext') {
                            if (item.preferredPlatform) {
                                selectedTemplate.push(item.preferredPlatform)
                            } else {
                                item.preferredPlatform = me.template
                            }
                            modelForElements.BoundedContext.push(item)
                        } else if (item._type == 'org.uengine.modeling.model.Aggregate') {
                            modelForElements.Aggregate.push(item)
                            modelForElements.AggregateRoot.push(item.aggregateRoot);
                        } else if (item._type == 'org.uengine.modeling.model.Event') {
                            modelForElements.Event.push(item)
                        } else if (item._type == 'org.uengine.modeling.model.Policy') {
                            modelForElements.Policy.push(item)
                            item.relationEventInfo = null;
                        } else if (item._type == 'org.uengine.modeling.model.Command') {
                            modelForElements.Command.push(item)
                        } else if (item._type == 'org.uengine.modeling.model.Actor') {
                            modelForElements.Actor.push(item)
                        } else if (item._type == 'org.uengine.modeling.model.View') {
                            if (item.dataProjection == 'cqrs') {
                                if (item.createRules) {
                                    for (var i = 0; i < item.createRules.length; i++) {
                                        if (item.createRules[i].fieldMapping) {
                                            for (var j = 0; j < item.createRules[i].fieldMapping.length; j++) {
                                                if (!item.createRules[i].fieldMapping[j].eventField || !item.createRules[i].fieldMapping[j].viewField)
                                                    continue
                                                var eventName = item.createRules[i].fieldMapping[j].eventField.name
                                                var viewName = item.createRules[i].fieldMapping[j].viewField.name
                                                item.createRules[i].fieldMapping[j].eventField.namePascalCase = changeCase.pascalCase(eventName)
                                                item.createRules[i].fieldMapping[j].eventField.nameCamelCase = changeCase.camelCase(eventName)
                                                item.createRules[i].fieldMapping[j].viewField.namePascalCase = changeCase.pascalCase(viewName)
                                                item.createRules[i].fieldMapping[j].viewField.nameCamelCase = changeCase.camelCase(viewName)
                                                // item.createRules[i].fieldMapping[j] = changeCaseforView(item.createRules[i].fieldMapping[j], eventName, viewName)
                                                // console.log(item.createRules[i].fieldMapping[j])
                                            }
                                        }
                                    }
                                }
                                if (item.deleteRules) {
                                    for (var i = 0; i < item.deleteRules.length; i++) {
                                        if (item.deleteRules[i].fieldMapping) {
                                            for (var j = 0; j < item.deleteRules[i].fieldMapping.length; j++) {
                                                if (!item.deleteRules[i].fieldMapping[j].eventField || !item.deleteRules[i].fieldMapping[j].viewField)
                                                    continue
                                                var eventName = item.deleteRules[i].fieldMapping[j].eventField.name
                                                var viewName = item.deleteRules[i].fieldMapping[j].viewField.name
                                                item.deleteRules[i].fieldMapping[j].eventField.namePascalCase = changeCase.pascalCase(eventName)
                                                item.deleteRules[i].fieldMapping[j].eventField.nameCamelCase = changeCase.camelCase(eventName)
                                                item.deleteRules[i].fieldMapping[j].viewField.namePascalCase = changeCase.pascalCase(viewName)
                                                item.deleteRules[i].fieldMapping[j].viewField.nameCamelCase = changeCase.camelCase(viewName)
                                                // item.deleteRules[i].fieldMapping[j] = changeCaseforView(item.deleteRules[i].fieldMapping[j], eventName, viewName)
                                            }
                                        }
                                    }
                                }
                                if (item.updateRules) {
                                    for (var i = 0; i < item.updateRules.length; i++) {
                                        if (item.updateRules[i].fieldMapping) {
                                            for (var j = 0; j < item.updateRules[i].fieldMapping.length; j++) {
                                                if (!item.updateRules[i].fieldMapping[j].eventField || !item.updateRules[i].fieldMapping[j].viewField)
                                                    continue
                                                var eventName = item.updateRules[i].fieldMapping[j].eventField.name
                                                var viewName = item.updateRules[i].fieldMapping[j].viewField.name
                                                item.updateRules[i].fieldMapping[j].eventField.namePascalCase = changeCase.pascalCase(eventName)
                                                item.updateRules[i].fieldMapping[j].eventField.nameCamelCase = changeCase.camelCase(eventName)
                                                item.updateRules[i].fieldMapping[j].viewField.namePascalCase = changeCase.pascalCase(viewName)
                                                item.updateRules[i].fieldMapping[j].viewField.nameCamelCase = changeCase.camelCase(viewName)
                                                // item.updateRules[i].fieldMapping[j] = changeCaseforView(item.updateRules[i].fieldMapping[j], eventName, viewName)
                                            }
                                        }
                                    }
                                }
                                modelForElements.View.push(item)
                            }
                        }
                    }
                })

                // load boundedContexts
                var boundedContextByIds = {};
                modelForElements.BoundedContext.forEach(bc => {

                    Object.values(modelCopy).forEach((element, index) => {
                        if (element && element.elementView && !element._type.endsWith("BoundedContext")) {

                            var outer = {
                                x: bc.elementView.x - bc.elementView.width / 2,
                                y: bc.elementView.y - bc.elementView.height / 2,
                                width: bc.elementView.width,
                                height: bc.elementView.height
                            }

                            var inner = {
                                x: element.elementView.x - element.elementView.width / 2,
                                y: element.elementView.y - element.elementView.height / 2,
                                width: element.elementView.width,
                                height: element.elementView.height
                            }


                            if (this._isAttached(outer, inner)) {
                                element.boundedContext = bc;
                                element.preferredPlatform = bc.preferredPlatform ? bc.preferredPlatform : me.template
                            }
                        }
                    })

                    boundedContextByIds[bc.elementView.id] = bc
                    rootModel.boundedContexts.push(bc)
                });

                var aggregateByIds = {};
                modelForElements.Aggregate.forEach(item => {
                    aggregateByIds[item.elementView.id] = item

                    // if (item.boundedContext && item.boundedContext.id) {
                    //     item.boundedContext = boundedContextByIds[item.boundedContext.id];
                    // }
                    if (item.boundedContext && item.boundedContext.aggregates)
                        item.boundedContext.aggregates.push(item)

                    if (item.aggregateRoot && item.aggregateRoot.entities) {
                        var entities = Object.values(item.aggregateRoot.entities.elements)
                        entities.forEach(entity => {
                            if (entity) {
                                if (entity._type != 'ClassGroup') {
                                    entity.preferredPlatform = item.preferredPlatform
                                    entity.boundedContext = item.boundedContext

                                    if (entity._type.includes('vo.')) {
                                        var res = false
                                        modelForElements.ValueObject.forEach(function (el) {
                                            if (el.name == entity.name && el.boundedContext.name == entity.boundedContext.name) {
                                                res = true
                                            }
                                        })
                                        if (!res) {
                                            modelForElements.ValueObject.push(entity)
                                        }
                                    } else if (entity._type.includes('enum')) {
                                        var res = false
                                        modelForElements.Enumeration.forEach(function (el) {
                                            if (el.name == entity.name && el.boundedContext.name == entity.boundedContext.name) {
                                                res = true
                                            }
                                        })
                                        if (!res) {
                                            modelForElements.Enumeration.push(entity)
                                        }
                                    } else if (entity._type.includes('Exception')) {
                                        var res = false
                                        modelForElements.Exception.forEach(function (el) {
                                            if (el.name == entity.name && el.boundedContext.name == entity.boundedContext.name) {
                                                res = true
                                            }
                                        })
                                        if (!res) {
                                            modelForElements.Exception.push(entity)
                                        }
                                    } else {
                                        var res = entity.isAggregateRoot ? entity.isAggregateRoot : false
                                        modelForElements.Entity.forEach(function (el) {
                                            if (el.name == entity.name && el.boundedContext.name == entity.boundedContext.name) {
                                                res = true
                                            }
                                        })
                                        if (!res) {
                                            modelForElements.Entity.push(entity)
                                        }
                                    }
                                }
                            }
                        })

                        item.aggregateRoot.entities.relations = Object.values(item.aggregateRoot.entities.relations)
                        // console.log(modelForElements)
                    }
                })
                //////// event.aggregate 가 값참조로 되어있는 관계로 본래 aggregate 에서 연결하는 코드 작성 //////
                var eventByIds = {};
                modelForElements.Event.forEach(item => {

                    /* connect aggregate*/
                    if (modelForElements.Aggregate.length > 0) {
                        modelForElements.Aggregate.forEach(aggregateElement => {
                            if (aggregateElement) {
                                var outer = {
                                    x: (aggregateElement.elementView.x - aggregateElement.elementView.width / 2) - 10,
                                    y: (aggregateElement.elementView.y - aggregateElement.elementView.height / 2) - 10,
                                    width: aggregateElement.elementView.width + 20,
                                    height: aggregateElement.elementView.height + 20
                                }

                                var inner = {
                                    x: item.elementView.x - item.elementView.width / 2,
                                    y: item.elementView.y - item.elementView.height / 2,
                                    width: item.elementView.width,
                                    height: item.elementView.height
                                }


                                if (this._isAttached(outer, inner)) {
                                    item.aggregate = aggregateElement
                                }
                            }
                        })
                    }


                    if (item.boundedContext && Object.keys(item.boundedContext).length > 0) {
                        if (item.boundedContext && item.boundedContext.elementView)
                            item.boundedContext = boundedContextByIds[item.boundedContext.elementView.id]
                    }
                    eventByIds[item.elementView.id] = item
                    // if ((!item.boundedContext || !item.boundedContext.id) && item.aggregate) { //if the event have never associated with any BoundedContext but, it is attached to an aggregate, reference the aggregate's boundedContext as its bc
                    //     item.boundedContext = item.aggregate.boundedContext
                    // }
                })

                // modelForElements.Aggregate.forEach(item=>{
                //     if(modelForElements.Policy.length >0 ){
                //         modelForElements.Policy.forEach(policy =>{
                //             if(policy){
                //                 var outer = {
                //                     x: (policy.elementView.x - policy.elementView.width / 2) - 10,
                //                     y: (policy.elementView.y - policy.elementView.height / 2) - 10,
                //                     width: policy.elementView.width + 20,
                //                     height: policy.elementView.height + 20
                //                 }

                //                 var inner = {
                //                     x: item.elementView.x - item.elementView.width / 2,
                //                     y: item.elementView.y - item.elementView.height / 2,
                //                     width: item.elementView.width,
                //                     height: item.elementView.height
                //                 }


                //                 if (this._isAttached(outer, inner)) {
                //                     if (!item.aggregateList)
                //                         item.policyList = []
                //                     item.policyList.push(policy)
                //                 }
                //             }
                //         })
                //     }
                // })

                var policyByIds = {};
                modelForElements.Policy.forEach(item => {

                    if (modelForElements.Aggregate.length > 0) {
                        modelForElements.Aggregate.forEach(aggregateElement => {
                            if (aggregateElement) {
                                var outer = {
                                    x: (aggregateElement.elementView.x - aggregateElement.elementView.width / 2) - 10,
                                    y: (aggregateElement.elementView.y - aggregateElement.elementView.height / 2) - 10,
                                    width: aggregateElement.elementView.width + 20,
                                    height: aggregateElement.elementView.height + 20
                                }

                                var inner = {
                                    x: item.elementView.x - item.elementView.width / 2,
                                    y: item.elementView.y - item.elementView.height / 2,
                                    width: item.elementView.width,
                                    height: item.elementView.height
                                }


                                if (this._isAttached(outer, inner)) {
                                    if (!item.aggregateList)
                                        item.aggregateList = []
                                    item.aggregateList.push(aggregateElement)
                                }
                            }
                        })
                    }

                    policyByIds[item.elementView.id] = item
                    // if (item.boundedContext && item.boundedContext.id)
                    //     boundedContextByIds[item.boundedContext.id].policies.push(item)

                    if (item.boundedContext && item.boundedContext.policies)
                        item.boundedContext.policies.push(item)
                })

                var commandByIds = {};
                modelForElements.Command.forEach(item => {
                    /* connect aggregate*/
                    if (modelForElements.Aggregate.length > 0) {
                        modelForElements.Aggregate.forEach(aggregateElement => {
                            if (aggregateElement) {
                                var outer = {
                                    x: (aggregateElement.elementView.x - aggregateElement.elementView.width / 2) - 10,
                                    y: (aggregateElement.elementView.y - aggregateElement.elementView.height / 2) - 10,
                                    width: aggregateElement.elementView.width + 20,
                                    height: aggregateElement.elementView.height + 20
                                }

                                var inner = {
                                    x: item.elementView.x - item.elementView.width / 2,
                                    y: item.elementView.y - item.elementView.height / 2,
                                    width: item.elementView.width,
                                    height: item.elementView.height
                                }


                                if (this._isAttached(outer, inner)) {
                                    item.aggregate = aggregateElement
                                }
                            }
                        })
                    }

                    commandByIds[item.elementView.id] = item
                })

                var actorByIds = {};
                modelForElements.Actor.forEach(item => {
                    /* connect command*/
                    if (modelForElements.Command.length > 0) {
                        modelForElements.Command.forEach(aggregateElement => {
                            if (aggregateElement) {
                                var outer = {
                                    x: (aggregateElement.elementView.x - aggregateElement.elementView.width / 2) - 10,
                                    y: (aggregateElement.elementView.y - aggregateElement.elementView.height / 2) - 10,
                                    width: aggregateElement.elementView.width + 20,
                                    height: aggregateElement.elementView.height + 20
                                }

                                var inner = {
                                    x: item.elementView.x - item.elementView.width / 2,
                                    y: item.elementView.y - item.elementView.height / 2,
                                    width: item.elementView.width,
                                    height: item.elementView.height
                                }


                                if (this._isAttached(outer, inner)) {
                                    item.aggregate = aggregateElement
                                    aggregateElement.actorName = item.name
                                }
                            }
                        })
                    }

                    actorByIds[item.elementView.id] = item

                })


                // re-link boundedcontexts and the real aggregates    //need to refactor
                // modelForElements.BoundedContext.forEach(item => {

                //     if (item.aggregates.length > 0)
                //         for (var i = 0; i < item.aggregates.length; i++) {
                //             item.aggregates[i] = aggregateByIds[item.aggregates[i].elementView.id]
                //         }

                //     if (item.policies.length > 0)
                //         for (var i = 0; i < item.policies.length; i++) {
                //             item.policies[i] = policyByIds[item.policies[i].elementView.id]
                //         }

                // });

                modelForElements.Aggregate.forEach(item => {
                    if (item.aggregateRules) {
                        for (var i = 0; i < item.aggregateRules.length; i++) {
                            var rule = {}

                            if (!item.aggregateRules[i].givenValue || !item.aggregateRules[i].whenValue || !item.aggregateRules[i].thenValue)
                                continue;

                            if (item.aggregateRules[i].givenValue.elementView._type == "org.uengine.modeling.model.Event") {
                                rule.givenValue = eventByIds[item.aggregateRules[i].givenValue.elementView.id];
                                rule.whenValue = policyByIds[item.aggregateRules[i].whenValue.elementView.id];
                            }
                            rule.ruleName = item.aggregateRules[i].ruleName.replace(/(\s*)/g, "")
                            rule.thenValue = eventByIds[item.aggregateRules[i].thenValue.elementView.id];
                            rule.aggregate = eventByIds[item.aggregateRules[i].thenValue.elementView.id].aggregate;
                            rule.boundedContext = eventByIds[item.aggregateRules[i].thenValue.elementView.id].boundedContext;
                            rule.preferredPlatform = eventByIds[item.aggregateRules[i].thenValue.elementView.id].boundedContext.preferredPlatform;
                            rule.attributes = item.aggregateRules[i].attributes
                            modelForElements.Rules.push(rule);
                        }
                    }
                });

                // re-link events to it's parent aggregates
                modelForElements.Event.forEach(item => {
                    if (item.aggregate && (item.aggregate.elementView || item.aggregate.id)) {
                        var aggregate = aggregateByIds[item.aggregate.elementView ? item.aggregate.elementView.id : item.aggregate.id] // 이 부분은 item.aggregate 로 바뀌어야 함
                        // var aggregate = aggregateByIds[item.aggregate.elementView.id]

                        if (aggregate) {
                            if (!aggregate.events) aggregate.events = [];
                            aggregate.events.push(item);
                        }
                    }

                });

                // 객체참조구조가 완전히 이상함.. 이게 뭡니까 대체????
                modelForElements.Command.forEach(item => {
                    if (item.aggregate && (item.aggregate.elementView || item.aggregate.id)) {
                        var aggregate = aggregateByIds[item.aggregate.elementView ? item.aggregate.elementView.id : item.aggregate.id] // 이 부분은 item.aggregate 로 바뀌어야 함
                        // var aggregate = aggregateByIds[item.aggregate.elementView.id]

                        if (aggregate) {
                            if (!aggregate.commands) aggregate.commands = [];
                            aggregate.commands.push(item);
                        }
                    }
                });

                modelForElements.Actor.forEach(item => {
                    if (item.aggregate && (item.aggregate.elementView || item.aggregate.id)) {
                        var aggregate = aggregateByIds[item.aggregate.elementView ? item.aggregate.elementView.id : item.aggregate.id] // 이 부분은 item.aggregate 로 바뀌어야 함
                        // var aggregate = aggregateByIds[item.aggregate.elementView.id]

                        if (aggregate) {
                            if (!aggregate.actors) aggregate.actors = [];
                            aggregate.actors.push(item);
                        }
                    }
                });
                rootModel.actors.push(modelForElements.Actor)

                //빈 값 전처리후에 진행.
                modelForElements.View.forEach(function (item, viewIndex) {
                    item.createRules.forEach(function (createRule, createIndex) {
                        if (createRule.when == null ? true : (Object.keys(createRule.when).length == 0 ? true : false)) {
                            createRule.when = null
                        } else {
                            createRule.fieldMapping.forEach(function (item, fieldMappingIndex) {

                                if (!item.operator) {
                                    item.operator = '='
                                }
                                if (item.eventField == null ? true : (Object.keys(item.eventField).length == 0 ? true : false)
                                || item.viewField == null ? true : (Object.keys(item.viewField).length == 0 ? true : false)) {
                                    item.eventField = null
                                    item.viewField = null
                                }

                            })
                        }
                    })

                    item.updateRules.forEach(function (updateRule, updateIndex) {
                        if (updateRule.when == null ? true : (Object.keys(updateRule.when).length == 0 ? true : false)) {
                            updateRule.when = null
                        } else {
                            updateRule.fieldMapping.forEach(function (item, fieldMappingIndex) {
                                if (!item.operator) {
                                    item.operator = '='
                                }

                                if (item.eventField == null ? true : (Object.keys(item.eventField).length == 0 ? true : false)
                                || item.viewField == null ? true : (Object.keys(item.viewField).length == 0 ? true : false)) {
                                    item.eventField = null
                                    item.viewField = null
                                }
                            })
                            updateRule.where.forEach(function (item, whereIndex) {
                                if (item.eventField == null ? true : (Object.keys(item.eventField).length == 0 ? true : false)
                                || item.viewField == null ? true : (Object.keys(item.viewField).length == 0 ? true : false)) {
                                    item.eventField = null
                                    item.viewField = null
                                }
                            })
                        }
                    })


                    item.deleteRules.forEach(function (deleteRule, deleteIndex) {
                        if (deleteRule.when == null ? true : (Object.keys(deleteRule.when).length == 0 ? true : false)) {
                            deleteRule.when = null
                        } else {
                            deleteRule.where.forEach(function (item, whereIndex) {
                                if (item.eventField == null ? true : (Object.keys(item.eventField).length == 0 ? true : false)
                                || item.viewField == null ? true : (Object.keys(item.viewField).length == 0 ? true : false)) {
                                    item.eventField = null
                                    item.viewField = null
                                }
                            })
                        }
                    })
                })


                var viewByIds = {};
                modelForElements.View.forEach(function (item, viewIndex) {

                    if (item.createRules) {
                        item.createRules.forEach(function (createRule, createIndex) {
                            if (!createRule.when) {
                                modelForElements.View[viewIndex].createRules.splice(createIndex, 1)
                            } else {
                                if (eventByIds[createRule.when.elementView.id]) {
                                    createRule.when = _.cloneDeep(eventByIds[createRule.when.elementView.id])
                                    createRule.when.boundedContext = item.boundedContext

                                    createRule.fieldMapping.forEach(function (item, fieldMappingIndex) {
                                        if (!item.eventField || !item.viewField) {
                                            createRule.fieldMapping.splice(fieldMappingIndex, 1)
                                        }
                                    })

                                    createRule._index = createIndex + 1

                                    if (modelForElements.ViewEventInfo.indexOf(createRule.when) == -1) {
                                        modelForElements.ViewEventInfo.push(createRule.when)
                                    }
                                }

                            }
                        })
                    }

                    if (item.updateRules) {
                        item.updateRules.forEach(function (updateRule, updateIndex) {
                            if (!updateRule.when) {
                                modelForElements.View[viewIndex].updateRules.splice(updateIndex, 1)
                            } else {
                                if (eventByIds[updateRule.when.elementView.id]) {
                                    updateRule.when = _.cloneDeep(eventByIds[updateRule.when.elementView.id])
                                    updateRule.when.boundedContext = item.boundedContext

                                    updateRule.fieldMapping.forEach(function (item, fieldMappingIndex) {
                                        if (!item.eventField || !item.viewField) {
                                            updateRule.fieldMapping.splice(fieldMappingIndex, 1)
                                        }
                                    })

                                    updateRule.where.forEach(function (item, whereIndex) {
                                        if (!item.eventField || !item.viewField) {
                                            updateRule.where.splice(whereIndex, 1)
                                        }
                                    })

                                    updateRule._index = updateIndex + 1

                                    if (modelForElements.ViewEventInfo.indexOf(updateRule.when) == -1) {
                                        modelForElements.ViewEventInfo.push(updateRule.when)
                                    }
                                }

                            }
                        })
                    }


                    if (item.deleteRules) {
                        item.deleteRules.forEach(function (deleteRule, deleteIndex) {
                            // createRule.when = _.cloneDeep(eventByIds[createRule.when.elementView.id])
                            // createRule.when.boundedContext = item.boundedContext
                            if (!deleteRule.when) {
                                modelForElements.View[viewIndex].deleteRules.splice(deleteIndex, 1)
                            } else {

                                if (eventByIds[deleteRule.when.elementView.id]) {
                                    deleteRule.when = _.cloneDeep(eventByIds[deleteRule.when.elementView.id])
                                    deleteRule.when.boundedContext = item.boundedContext

                                    deleteRule.where.forEach(function (item, whereIndex) {
                                        if (!item.eventField || !item.viewField) {
                                            deleteRule.where.splice(whereIndex, 1)
                                        }
                                    })

                                    deleteRule._index = deleteIndex + 1

                                    if (modelForElements.ViewEventInfo.indexOf(deleteRule.when) == -1) {
                                        modelForElements.ViewEventInfo.push(deleteRule.when)
                                    }
                                }

                            }
                        })
                    }

                    viewByIds[item.elementView.id] = item
                    if (item.boundedContext && item.boundedContext.viewes) {
                        item.boundedContext.viewes.push(item)
                    }
                })

                // var modelRelationCopy = JSON.parse(JSON.stringify(flatModel.relations));


                var modelRelationCopy = Object.values(JSON.parse(JSON.stringify(flatModel.relations)))

                // var triggerByCommand = []
                // var triggerByPolicy = []
                var triggerType = false
                modelRelationCopy.forEach(item => {
                    if (item != null) {
                        if (item._type == 'org.uengine.modeling.model.Line') {
                            return
                        }
                        if (item.sourceElement._type == "org.uengine.modeling.model.Event" &&
                            item.targetElement._type == "org.uengine.modeling.model.Policy") {
                            if (eventByIds[item.sourceElement.elementView.id] && policyByIds[item.targetElement.elementView.id]) {
                                var relationEventInfo = {
                                    eventValue: eventByIds[item.sourceElement.elementView.id],
                                    relationId: item.relationView.id,
                                    boundedContext: policyByIds[item.targetElement.elementView.id].boundedContext,
                                    elementView: {
                                        id: eventByIds[item.sourceElement.elementView.id].elementView.id
                                    }
                                }

                                // add preferredPlatform
                                // var getPreferredPlatform = policyByIds[item.targetElement.elementView.id].preferredPlatform
                                var getPreferredPlatform = relationEventInfo.boundedContext ? relationEventInfo.boundedContext.preferredPlatform : policyByIds[item.targetElement.elementView.id].preferredPlatform
                                relationEventInfo.preferredPlatform = getPreferredPlatform

                                if (!policyByIds[item.targetElement.elementView.id].relationEventInfo)
                                    policyByIds[item.targetElement.elementView.id].relationEventInfo = [];
                                policyByIds[item.targetElement.elementView.id].relationEventInfo.push(relationEventInfo);


                                modelForElements.RelationEventInfo.push(relationEventInfo);
                            }
                        } else if (item.sourceElement._type == "org.uengine.modeling.model.Policy" &&
                            item.targetElement._type == "org.uengine.modeling.model.Event") {
                            if (eventByIds[item.targetElement.elementView.id] && policyByIds[item.sourceElement.elementView.id]) {
                                var relationExampleEventInfo = {
                                    eventValue: eventByIds[item.targetElement.elementView.id],
                                    relationId: item.relationView.id,
                                    boundedContext: policyByIds[item.sourceElement.elementView.id].boundedContext,
                                }

                                if (!policyByIds[item.sourceElement.elementView.id].relationExampleEventInfo)
                                    policyByIds[item.sourceElement.elementView.id].relationExampleEventInfo = [];
                                policyByIds[item.sourceElement.elementView.id].relationExampleEventInfo.push(relationExampleEventInfo);
                                // triggerByPolicy.push(relationExampleEventInfo)

                                modelForElements.RelationExampleEventInfo.push(relationExampleEventInfo);
                            }
                        } else if (item.sourceElement._type == "org.uengine.modeling.model.Command" &&
                            item.targetElement._type == "org.uengine.modeling.model.Event") {
                            if (commandByIds[item.sourceElement.elementView.id] && eventByIds[item.targetElement.elementView.id]) {
                                var triggerByCommand = {
                                    eventValue: eventByIds[item.targetElement.elementView.id],
                                    relationsId: item.relationView.id,
                                    boundedContext: commandByIds[item.sourceElement.elementView.id].boundedContext,

                                    elementView: {
                                        id: eventByIds[item.targetElement.elementView.id].elementView.id
                                    }
                                }
                                if (!commandByIds[item.sourceElement.elementView.id].triggerByCommand) {
                                    commandByIds[item.sourceElement.elementView.id].triggerByCommand = []
                                }

                                if (eventByIds[item.targetElement.elementView.id].triggerShouldExist == undefined) {
                                    if (commandByIds[item.sourceElement.elementView.id].isRestRepository) {
                                        eventByIds[item.targetElement.elementView.id].triggerShouldExist = true;
                                    } else {
                                        eventByIds[item.targetElement.elementView.id].triggerShouldExist = false;
                                    }
                                } else {
                                    if (!eventByIds[item.targetElement.elementView.id].triggerShouldExist && commandByIds[item.sourceElement.elementView.id].isRestRepository) {
                                        eventByIds[item.targetElement.elementView.id].triggerShouldExist = true;
                                    }
                                }

                                if (!commandByIds[item.sourceElement.elementView.id].triggerByCommand) {
                                    commandByIds[item.sourceElement.elementView.id].triggerByCommand = []
                                }
                                commandByIds[item.sourceElement.elementView.id].triggerByCommand.push(triggerByCommand);
                            }
                        } else if (item.sourceElement._type == "org.uengine.modeling.model.Event" &&
                            item.targetElement._type == "org.uengine.modeling.model.Command") {

                            if (commandByIds[item.targetElement.elementView.id] && eventByIds[item.sourceElement.elementView.id]) {
                                var relationCommandInfo = {
                                    commandValue: commandByIds[item.targetElement.elementView.id],
                                    relationId: item.relationView.id,
                                    boundedContext: eventByIds[item.sourceElement.elementView.id].boundedContext,
                                    elementView: {
                                        id: commandByIds[item.targetElement.elementView.id].elementView.id
                                    }
                                }

                                // add preferredPlatform
                                // var getPreferredPlatform = eventByIds[item.sourceElement.elementView.id].preferredPlatform
                                var getPreferredPlatform = relationCommandInfo.boundedContext ? relationCommandInfo.boundedContext.preferredPlatform : eventByIds[item.sourceElement.elementView.id].preferredPlatform
                                relationCommandInfo.preferredPlatform = getPreferredPlatform

                                eventByIds[item.sourceElement.elementView.id].relationCommandInfo = relationCommandInfo
                                modelForElements.RelationCommandInfo.push(relationCommandInfo);
                            }
                        } else if (item.sourceElement._type == "org.uengine.modeling.model.Command" &&
                            item.targetElement._type == "org.uengine.modeling.model.View") {

                            if (commandByIds[item.sourceElement.elementView.id] && viewByIds[item.targetElement.elementView.id]) {
                                commandByIds[item.sourceElement.elementView.id].aggregate = me.viewToAggregate(viewByIds[item.targetElement.elementView.id])

                                var relationCommandInfo = {
                                    commandValue: commandByIds[item.sourceElement.elementView.id],
                                    relationId: item.relationView.id,
                                    boundedContext: commandByIds[item.sourceElement.elementView.id].boundedContext,
                                    elementView: {
                                        id: commandByIds[item.sourceElement.elementView.id].elementView.id
                                    }
                                }
                                commandByIds[item.sourceElement.elementView.id].boundedContext.circuitBreaker = item.circuitBreaker;
                                commandByIds[item.sourceElement.elementView.id].boundedContext.fallback = item.fallback;
                                relationCommandInfo.commandValue.boundedContext = viewByIds[item.targetElement.elementView.id].boundedContext;
                                relationCommandInfo.commandValue.restRepositoryInfo.getMethod = true
                                commandByIds[item.sourceElement.elementView.id].relationCommandInfo = relationCommandInfo;

                                // add preferredPlatform
                                // var getPreferredPlatform = viewByIds[item.targetElement.elementView.id].preferredPlatform
                                var getPreferredPlatform = relationCommandInfo.boundedContext ? relationCommandInfo.boundedContext.preferredPlatform : viewByIds[item.targetElement.elementView.id].preferredPlatform
                                relationCommandInfo.preferredPlatform = getPreferredPlatform

                                modelForElements.RelationCommandInfo.push(relationCommandInfo);
                            }
                        } else if (item.sourceElement._type == "org.uengine.modeling.model.Command" &&
                            item.targetElement._type == "org.uengine.modeling.model.Aggregate") {

                            if (commandByIds[item.sourceElement.elementView.id] && aggregateByIds[item.targetElement.elementView.id]) {

                                var targetCamelCase = _.camelCase(aggregateByIds[item.targetElement.elementView.id].name)
                                if (aggregateByIds[item.targetElement.elementView.id].namePascalCase.length == 0) {
                                    aggregateByIds[item.targetElement.elementView.id].namePascalCase = targetCamelCase.substring(0, 1).toUpperCase() + targetCamelCase.substring(1);
                                }
                                if (aggregateByIds[item.targetElement.elementView.id].namePlural.length == 0) {
                                    aggregateByIds[item.targetElement.elementView.id].namePlural = pluralize(targetCamelCase);
                                }

                                commandByIds[item.sourceElement.elementView.id].aggregate = aggregateByIds[item.targetElement.elementView.id];
                                var relationCommandInfo = {
                                    commandValue: commandByIds[item.sourceElement.elementView.id],
                                    relationId: item.relationView.id,
                                    boundedContext: commandByIds[item.sourceElement.elementView.id].boundedContext,
                                    elementView: {
                                        id: commandByIds[item.sourceElement.elementView.id].elementView.id
                                    }
                                }
                                commandByIds[item.sourceElement.elementView.id].boundedContext.circuitBreaker = item.circuitBreaker;
                                commandByIds[item.sourceElement.elementView.id].boundedContext.fallback = item.fallback;
                                relationCommandInfo.commandValue.boundedContext = aggregateByIds[item.targetElement.elementView.id].boundedContext;
                                // relationCommandInfo.commandValue.restRepositoryInfo.method = null
                                relationCommandInfo.commandValue.restRepositoryInfo.getMethod = true
                                commandByIds[item.sourceElement.elementView.id].relationCommandInfo = relationCommandInfo;

                                // add preferredPlatform
                                // var getPreferredPlatform = aggregateByIds[item.targetElement.elementView.id].preferredPlatform
                                var getPreferredPlatform = relationCommandInfo.boundedContext ? relationCommandInfo.boundedContext.preferredPlatform : aggregateByIds[item.targetElement.elementView.id].preferredPlatform
                                relationCommandInfo.preferredPlatform = getPreferredPlatform

                                modelForElements.RelationCommandInfo.push(relationCommandInfo);
                            }
                        } else if (item.sourceElement._type == "org.uengine.modeling.model.Policy" &&
                            item.targetElement._type == "org.uengine.modeling.model.Aggregate") {
                            var relationAggregateInfo = {
                                aggregateValue: aggregateByIds[item.targetElement.elementView.id],
                                relationId: item.relationView.id,
                                boundedContext: aggregateByIds[item.targetElement.elementView.id].boundedContext,
                                elementView: {
                                    id: aggregateByIds[item.targetElement.elementView.id].elementView.id
                                }
                            }

                            var relationCommandInfo = {
                                commandValue: policyByIds[item.sourceElement.elementView.id].boundedContext,
                                relationId: item.relationView.id,
                                boundedContext: policyByIds[item.sourceElement.elementView.id].boundedContext,
                                elementView: {
                                    id: aggregateByIds[item.targetElement.elementView.id].elementView.id
                                }
                            }

                            if (!policyByIds[item.sourceElement.elementView.id].relationAggregateInfo)
                                policyByIds[item.sourceElement.elementView.id].relationAggregateInfo = [];
                            policyByIds[item.sourceElement.elementView.id].boundedContext.circuitBreaker = item.circuitBreaker;
                            policyByIds[item.sourceElement.elementView.id].boundedContext.fallback = item.fallback;
                            relationCommandInfo.commandValue.boundedContext = aggregateByIds[item.targetElement.elementView.id].boundedContext;
                            relationCommandInfo.commandValue.aggregate = aggregateByIds[item.targetElement.elementView.id]

                            // add preferredPlatform
                            // var getPreferredPlatform = aggregateByIds[item.targetElement.elementView.id].preferredPlatform
                            var getPreferredPlatform = relationCommandInfo.boundedContext ? relationCommandInfo.boundedContext.preferredPlatform : aggregateByIds[item.targetElement.elementView.id].preferredPlatform
                            relationCommandInfo.preferredPlatform = getPreferredPlatform

                            policyByIds[item.sourceElement.elementView.id].relationAggregateInfo.push(relationAggregateInfo);
                            modelForElements.RelationCommandInfo.push(relationCommandInfo);
                        } else if (item.sourceElement._type == "org.uengine.modeling.model.Policy" &&
                            item.targetElement._type == "org.uengine.modeling.model.View") {
                            var parseView = me.viewToAggregate(viewByIds[item.targetElement.elementView.id])
                            var relationAggregateInfo = {
                                aggregateValue: parseView,
                                relationId: item.relationView.id,
                                boundedContext: parseView.boundedContext,
                                elementView: {
                                    id: viewByIds[item.targetElement.elementView.id].elementView.id
                                }
                            }

                            var relationCommandInfo = {
                                commandValue: parseView,
                                relationId: item.relationView.id,
                                boundedContext: policyByIds[item.sourceElement.elementView.id].boundedContext,
                                elementView: {
                                    id: parseView.elementView.id
                                }
                            }

                            if (!policyByIds[item.sourceElement.elementView.id].relationAggregateInfo)
                                policyByIds[item.sourceElement.elementView.id].relationAggregateInfo = [];
                            policyByIds[item.sourceElement.elementView.id].boundedContext.circuitBreaker = item.circuitBreaker;
                            policyByIds[item.sourceElement.elementView.id].boundedContext.fallback = item.fallback;
                            relationCommandInfo.commandValue.boundedContext = viewByIds[item.targetElement.elementView.id].boundedContext;
                            relationCommandInfo.commandValue.aggregate = parseView

                            // add preferredPlatform
                            // var getPreferredPlatform = viewByIds[item.targetElement.elementView.id].preferredPlatform
                            var getPreferredPlatform = relationCommandInfo.boundedContext ? relationCommandInfo.boundedContext.preferredPlatform : viewByIds[item.targetElement.elementView.id].preferredPlatform
                            relationCommandInfo.preferredPlatform = getPreferredPlatform

                            policyByIds[item.sourceElement.elementView.id].relationAggregateInfo.push(relationAggregateInfo);
                            modelForElements.RelationCommandInfo.push(relationCommandInfo);
                        }
                    }
                });

                if (Object.values(eventByIds).length > 0) {
                    Object.values(eventByIds).forEach(function (item, idx) {
                        if (item.triggerShouldExist != undefined || item.tirggerShouldExist != null) {
                            if (!item.triggerShouldExist) {
                                item.trigger = ''
                            }
                        }
                    })
                }

                modelForElements.Command.forEach(item => {
                    if (item.triggerByCommand) {
                        for (var i = 0; i < item.triggerByCommand.length; i++) {
                            var tbc = item.triggerByCommand[i]
                            tbc.relationCommandInfo = eventByIds[tbc.eventValue.elementView.id].relationCommandInfo
                        }
                    }
                })


                modelForElements.Aggregate.forEach(item => {
                    if (modelForElements.Policy.length > 0) {
                        modelForElements.Policy.forEach(policy => {
                            if (policy) {
                                var outer = {
                                    x: (policy.elementView.x - policy.elementView.width / 2) - 10,
                                    y: (policy.elementView.y - policy.elementView.height / 2) - 10,
                                    width: policy.elementView.width + 20,
                                    height: policy.elementView.height + 20
                                }

                                var inner = {
                                    x: item.elementView.x - item.elementView.width / 2,
                                    y: item.elementView.y - item.elementView.height / 2,
                                    width: item.elementView.width,
                                    height: item.elementView.height
                                }


                                if (this._isAttached(outer, inner)) {
                                    if (!item.policyList)
                                        item.policyList = []
                                    item.policyList.push(policyByIds[policy.elementView.id])
                                }
                            }
                        })
                    }
                })

                modelForElements.RelationCommandInfo.forEach(item => {
                    if (item.boundedContext && Object.keys(item.boundedContext).length != 0) {
                        if (!boundedContextByIds[item.boundedContext.elementView.id].relationCommandInfo) {
                            boundedContextByIds[item.boundedContext.elementView.id].relationCommandInfo = []
                        }
                        boundedContextByIds[item.boundedContext.elementView.id].relationCommandInfo.push(item)
                    }
                })

                // setting modelElements
                if (modelForElements.Aggregate) {
                    modelForElements.Aggregate.forEach(function (agg) {
                        modelElements.aggregates.push(agg)
                    })
                }
                if (modelForElements.BoundedContext) {
                    modelForElements.BoundedContext.forEach(function (bc) {
                        modelElements.boundedContextes.push(bc)
                    })
                }
                modelForElements.ModelElements = modelElements


                selectedTemplate = [...new Set(selectedTemplate)];
                return {
                    rootModel: rootModel,
                    modelForElements: modelForElements,
                    preferredPlatforms: selectedTemplate
                }
            },
            arrayToObject(array) {
                var tmp = {};
                array.forEach(function (data) {
                    eval("tmp['" + data.key + "']= data")
                })
                return tmp
            },
            viewToAggregate(view) {
                var tmp = view.fieldDescriptors;

                view.elementView._type == "org.uengine.modeling.model.Aggregate";
                view["aggregateRoot"] = {
                    _type: "org.uengine.modeling.model.AggregateRoot",
                    fieldDescriptors: tmp
                }
                return view
            },
            getTemplateSetting(rootModel, modelForElements, preferredPlatforms) {
                var me = this
                console.log("Generate Start");

                return new Promise(async function (resolve, reject) {
                    try {
                        me.completedSourceCount = 0;
                        var filterName = JSON.parse(JSON.stringify(me.projectName))
                        filterName = me.filterProjectName(filterName)
                        // if(preferredPlatforms == null) {
                        //     preferredPlatforms = [];
                        // }
                        if (preferredPlatforms.length == 0) {
                            preferredPlatforms.push(me.template)
                        }


                        //Hash
                        if (!me.newTreeHashLists) me.newTreeHashLists = {}
                        me.oldTreeHashLists = JSON.parse(JSON.stringify(me.newTreeHashLists))
                        me.newTreeHashLists = {}

                        preferredPlatforms.forEach(function (preferredPlatform) {
                            var template = preferredPlatform

                            // 아래 데이터는 npm 빌드때 파일시스템 tree 탐색을 통해 자동으로 생성하거나 일일이 작업해줘야 한다.
                            var lastIndex = me.$manifestsPerTemplate[template].length - 1

                            // 템플릿별 파일목록들
                            me.$manifestsPerTemplate[template].forEach(function (element, index) {
                                element = element.replace('./', '')
                                var doit = function (content) {
                                    if (element.includes('for-model')) {
                                    }
                                    var test = ''
                                    var count = 0
                                    var optionsCheck = content.split('---')[0];
                                    if (!optionsCheck.includes('forEach:')) {
                                        count = count + 1
                                        if (element.includes('for-model')) {
                                            var forEach = 'Model'
                                            test = test.concat('forEach: ' + forEach)
                                        } else {
                                            var forEach = 'BoundedContext'
                                            test = test.concat('forEach: ' + forEach)
                                        }
                                    } else {
                                        var forEach = optionsCheck.split("forEach:")[1].split("\n")[0].trim();
                                    }

                                    if (!optionsCheck.includes('fileName:')) {
                                        count = count + 1
                                        if (element.split('/')) {
                                            var fileName = element.substring(element.lastIndexOf("/") + 1);
                                            test = test.concat('\n')
                                            if (fileName == 'gitignore') {
                                                fileName = '.gitignore'
                                            }
                                            if (fileName == 'msaez') {
                                                fileName = '.msaez'
                                            }
                                            test = test.concat('fileName: ' + fileName)
                                        }
                                    }
                                    if (!optionsCheck.includes('path:')) {
                                        var pathData = element.substring(0, element.lastIndexOf("/") + 1);
                                        count = count + 1
                                        if (element.includes('for-model')) {
                                            test = test.concat('\n')
                                            test = test.concat(`path: ${path.dirname(element).replace('./', '')}`)
                                        } else if (optionsCheck.includes('forEach:')) {
                                            test = test.concat('\n')
                                            test = test.concat(`path: {{boundedContext.name}}/${path.dirname(element).replace('./', '')}`)
                                        } else {
                                            test = test.concat('\n')
                                            test = test.concat(`path: {{name}}/${path.dirname(element).replace('./', '')}`)
                                        }
                                    } else if (!optionsCheck.includes('forEach:')) {
                                        var pathData = element.substring(0, element.lastIndexOf("/") + 1);
                                        if (element.includes('for-model')) {
                                            test = test.concat('\n')
                                        } else if (optionsCheck.includes(' path:')) {
                                            count = count + 1
                                            test = test.concat('\n')
                                            test = test.concat(`path: {{name}}/${path.dirname(element).replace('./', '')}`)
                                        } else {
                                            test = test.concat('\n')
                                        }
                                    }
                                    if (count == 3) {
                                        test = test.concat('\n---\n')
                                    } else {
                                        test = test.concat('\n')
                                    }

                                    if (test.length > 0) {
                                        content = test.concat(content)
                                    }
                                    var model = modelForElements[forEach];


                                    // if(model[0]._type == 'org.uengine.modeling.model.Policy' && model[0].relationEventInfo.length > 0)

                                    var process = async function (ele) {
                                        try {
                                            if (ele == undefined) {
                                                var optionsMetadataAndSource = content.split("---"); // 소스와 구분
                                                var optionsPathHeader = yamlpaser.load(optionsMetadataAndSource[0])
                                                var elementPath = element.split('/');
                                                var elementPathString = elementPath[0] + '/' + elementPath[1];
                                                if (!optionsPathHeader['path'].includes(elementPathString)) {
                                                    optionsPathHeader['path'] = elementPathString.concat(optionsPathHeader['path'])
                                                }

                                                var optionsPath = optionsPathHeader['path'].split('/');
                                                var optionsPathString = '';
                                                for (var o = 1; o < optionsPath.length; o++) {
                                                    if (o == 1) {
                                                        optionsPathString = optionsPathString.concat(optionsPath[o]);
                                                    } else {
                                                        optionsPathString = optionsPathString.concat('/' + optionsPath[o]);
                                                    }
                                                }
                                                var options = {
                                                    "package": `${optionsPathString}`.trim().replace(elementPath[1] + '/src/main/java/', '').replace("-", "").replace(/\//gi, '.'),
                                                    "packagePath": `${optionsPathString}`
                                                }

                                                ele = rootModel

                                            } else {
                                                var options = {
                                                    "package": `${filterName.trim().replace(/ /gi, ".").replace("-", "")}`,
                                                    "packagePath": `src/main/java/${filterName.replace(/ /gi, "/").replace("-", "")}`
                                                }
                                            }

                                            ele.options = options;
                                            ele.selectedSecurity = me.selectedSecurity
                                            //mustach
                                            // var gen = window.$Mustache.render(content, ele);

                                            //$HandleBars
                                            if (content.split("<function>")[1]) {
                                                var functionBlock = content.split("<function>")[1];
                                                functionBlock = functionBlock.replace("\n</function>", "");
                                                content = content.replace("\n</function>", "");
                                                content = content.replace("<function>\n", "");
                                                content = content.replace("<function>", "");
                                                content = content.replace(functionBlock, "");
                                                eval(functionBlock);
                                            }
                                            var compile = window.$HandleBars.compile(content);
                                            var gen = compile(ele)

                                            var metadataAndSource = gen.split("---"); // 소스와 구분

                                            var header = yamlpaser.load(metadataAndSource[0].replace(/\n\n/gi, "\n"))
                                            var options = {}
                                            Object.keys(header).forEach(function (keyValue, idx) {
                                                var key = keyValue
                                                var value = Object.values(header)[idx]
                                                if (key == 'path' && (value.lastIndexOf('.') == value.length - 1)) {
                                                    value = value.substring(0, value.lastIndexOf(".") - 1)
                                                }
                                                options[key] = value;
                                            })

                                            var representativeFor = options['representativeFor']
                                            var priority = options['priority']

                                            var fileName = options['fileName']
                                            if (template == 'spring-boot' && options['fileName'] && options['fileName'].includes("Impl")) {
                                                if (!ele.boundedContext.fallback) {
                                                    return;
                                                }
                                            }
                                            if (options['except'] == true) {
                                                return;
                                            }
                                            var fullPath = options['path'] + '/' + options['fileName'];
                                            if (fileName.includes('Application'))
                                                if (elementPathString && !fullPath.includes(elementPathString)) {
                                                    fullPath = elementPathString.concat(fullPath)
                                                }
                                            // /src/main/java/com/example/Application.java
                                            // for-model/gateway2/src/main/java/com/example/template/Application.java
                                            var source = ''

                                            if (metadataAndSource.length > 1) {
                                                for (var data in metadataAndSource) {

                                                    if (data != 0 && data < metadataAndSource.length - 1) {
                                                        source = source.concat(metadataAndSource[data] + '---\n')
                                                    } else if (data == metadataAndSource.length - 1) {
                                                        source = source.concat(metadataAndSource[data])
                                                    }
                                                }
                                            }

                                            var codeValue = {}
                                            var fullValue = {}
                                            source = source.replace('\n', '')
                                            if (source.length > 1) {
                                                var uuid = me.uuid();
                                                // if (source == undefined) {
                                                //     console.log(source, fullPath)
                                                // }
                                                var hashName = JSON.parse(JSON.stringify(fileName))
                                                var hashValue = JSON.parse(JSON.stringify(source))
                                                var hashPath = JSON.parse(JSON.stringify(fullPath))
                                                var hashConcat = hashName.concat(hashValue)
                                                hashConcat = hashConcat.concat(hashPath)

                                                var sourceHash = Math.abs(me.hashCode(hashConcat))
                                                //템플릿단에서 BC 파악 위해서 element의 BC 파악.
                                                var getBcId = null
                                                if (ele && ele.boundedContext && ele.boundedContext.elementView) {
                                                    getBcId = ele.boundedContext.elementView.id
                                                }

                                                if (ele._type && ele._type.endsWith("Model")) {
                                                    // /src/main/java/com/example/Application.java
                                                    // gateway2/src/main/java/com/example/template/Application.java
                                                    codeValue = {
                                                        'element': ele.elementView ? ele.elementView.id : null,
                                                        'key': uuid,
                                                        'hash': sourceHash,
                                                        'fileName': fileName,
                                                        'code': source,
                                                        'file': me.fileType(fileName),
                                                        'boundedContext': fullPath.split("/")[0],
                                                    }
                                                    fullValue = {
                                                        'bcId': getBcId,
                                                        'element': ele.elementView ? ele.elementView.id : null,
                                                        'key': uuid,
                                                        'fullPath': fullPath.replace('for-model/', ''),
                                                        'priority': priority,
                                                        'hash': sourceHash,
                                                    }
                                                } else {
                                                    if (ele._type && ele._type.endsWith("BoundedContext")) {
                                                        codeValue = {
                                                            'element': ele.elementView ? ele.elementView.id : null,
                                                            'key': uuid,
                                                            'hash': sourceHash,
                                                            'fileName': fileName,
                                                            'code': source,
                                                            'file': me.fileType(fileName),
                                                            'boundedContext': fullPath.split("/")[0],
                                                            'representativeFor': representativeFor ? representativeFor : null,
                                                            'forEach': forEach ? forEach : null
                                                        }

                                                        //For Dockerfile, pom.xml etc...
                                                        fullValue = {
                                                            'bcId': ele.elementView ? ele.elementView.id : null,
                                                            'element': ele.elementView ? ele.elementView.id : null,
                                                            'key': uuid,
                                                            'fullPath': fullPath,
                                                            'priority': priority,
                                                            'hash': sourceHash,
                                                        }
                                                    } else {
                                                        //////// why key is requred?
                                                        // -> Code view 관련 key 설정 없을시, 중복선택 막음

                                                        codeValue = {
                                                            'element': ele.elementView ? ele.elementView.id : null,
                                                            'fileName': fileName,
                                                            'key': uuid,
                                                            'hash': sourceHash,
                                                            'code': source,
                                                            'file': me.fileType(fileName),
                                                            'boundedContext': fullPath.split("/")[0],
                                                            'representativeFor': representativeFor ? representativeFor : null,
                                                            'forEach': forEach ? forEach : null
                                                        }

                                                        fullValue = {
                                                            'bcId': getBcId,
                                                            'element': ele.elementView ? ele.elementView.id : null,
                                                            'key': uuid,
                                                            'fullPath': fullPath,
                                                            'hash': sourceHash,
                                                            'priority': priority,
                                                        }
                                                    }
                                                }

                                                var diffObj = me.fullPathList.find(x => x.fullPath === fullPath);
                                                if (diffObj) {
                                                    if ((diffObj.priority < priority)) {
                                                        return;
                                                    }
                                                }

                                                // treeLists beforeFullPath 미포함.

                                                me.getCodeList.push(codeValue)
                                                me.fullPathList.push(fullValue)
                                                me.$set(me.newTreeHashLists, sourceHash, fullPath)
                                                me.setTreeHashLists = true

                                                fullValue.code = codeValue.code;
                                                var fileNameCheckArray = content.split("---");
                                                if (fileNameCheckArray[0].includes("fileName: {{")) {
                                                    if (ele.name != ele.oldName && ele.oldName != undefined && ele.oldName.length > 0) {
                                                        var nameCamelCase = _.camelCase(ele.oldName);
                                                        var namePascalCase = nameCamelCase.substring(0, 1).toUpperCase() + nameCamelCase.substring(1);
                                                        var beforeFullPath = "";
                                                        var stringArray = fullValue.fullPath.split("/");
                                                        stringArray.forEach(function (value, index) {
                                                            if (index != stringArray.length - 1) {
                                                                beforeFullPath = beforeFullPath.concat(value + "/");
                                                            } else {
                                                                beforeFullPath = beforeFullPath.concat(value.replace(ele.namePascalCase, namePascalCase));
                                                            }
                                                        })
                                                        fullValue.beforeFullPath = beforeFullPath;
                                                    }
                                                }
                                                if (ele.boundedContext || options.forEach == "BoundedContext") {
                                                    if (options.forEach == "BoundedContext") {
                                                        if (ele.oldName != undefined)
                                                            if (ele.name != ele.oldName) {
                                                                fullValue.beforeFullPath = fullPath.replace(ele.name, ele.oldName);
                                                            }
                                                    } else if (ele.boundedContext) {
                                                        if (ele.boundedContext.oldName != undefined) {
                                                            if (fullValue.beforeFullPath) {
                                                                fullValue.beforeFullPath = fullValue.beforeFullPath.replace(ele.boundedContext.name, ele.boundedContext.oldName)
                                                            } else {
                                                                fullValue.beforeFullPath = fullValue.fullPath.replace(ele.boundedContext.name, ele.boundedContext.oldName)
                                                            }
                                                        }
                                                    }
                                                }
                                                // treeLists beforeFullPath 포함.
                                                // fullValue.beforeFullPath = fullValue.beforeFullPath ? fullValue.beforeFullPath : null
                                                // me.getCodeList.push(codeValue)
                                                // me.fullPathList.push(fullValue)
                                                // me.$set(me.newTreeHashLists, sourceHash, fullPath)

                                                if (me.ideWindow) {
                                                    console.log("canvas code");
                                                    var projectId;
                                                    if (me.information && me.information.projectId) {
                                                        projectId = me.information.projectId;
                                                    } else {
                                                        projectId = me.params.projectId;
                                                    }
                                                    var message = {
                                                        "message": "code",
                                                        "type": "update",
                                                        "path": projectId + "/" + fullValue.fullPath,
                                                        "content": fullValue.code,
                                                    }
                                                    if (fullValue.beforeFullPath) {
                                                        message.beforePath = projectId + "/" + fullValue.beforeFullPath;
                                                    }
                                                    if (me.fullPathList.length == 1) {
                                                        message.start = true
                                                    }
                                                    if (options.mergeType) {
                                                        message.mergeType = options.mergeType
                                                    }
                                                    me.ideWindow.postMessage(message);
                                                }
                                            }
                                        } catch (e) {
                                            console.log(content)
                                            console.log(e)
                                        } finally {
                                            me.templateDoneCnt = me.templateDoneCnt + 1
                                        }
                                    }


                                    if (Array.isArray(model)) {
                                        model.forEach(function (modelElement) {
                                            if (template == modelElement.preferredPlatform) {
                                                process(modelElement)
                                                if (me.templateSendCnt == -1) me.templateSendCnt = 0
                                                me.templateSendCnt = me.templateSendCnt + 1
                                            }
                                        });
                                    } else {
                                        process(model);
                                        if (me.templateSendCnt == -1) me.templateSendCnt = 0
                                        me.templateSendCnt = me.templateSendCnt + 1
                                    }

                                }


                                var xhttp = new XMLHttpRequest();
                                xhttp.onreadystatechange = function () {

                                    if (this.readyState == 4 && this.status == 200) {
                                        // DONE && SUCCESS
                                        if (template == 'Custom Template') {
                                            var gitCodeObj = JSON.parse(this.responseText);
                                            var gitCodeTmp = Base64.decode(gitCodeObj.content)
                                            doit(gitCodeTmp)
                                        } else {
                                            // 해당 구문으로 존재하지 않는 파일에 대하여 예외처리가 가능함
                                            if (!this.responseText.includes("<!-- Is Not Template -->") && !this.responseText.includes("for-model/frontend")) {
                                                if (this.responseText.includes("<html")) {
                                                    if (this.responseURL.includes("html"))
                                                        doit(this.responseText);
                                                } else {
                                                    doit(this.responseText)
                                                }

                                            }
                                        }

                                        if (lastIndex == index) {
                                            me.mergeCodeList = me.arrayToObject(JSON.parse(JSON.stringify(me.getCodeList)))
                                            resolve()
                                        }
                                    }
                                };
                                if (template == 'Custom Template') {
                                    xhttp.open("GET", me.gitCodeUrl[element], true);
                                    xhttp.setRequestHeader('Authorization', 'token ' + me.gitAccessToken);
                                    xhttp.send();
                                } else {
                                    xhttp.open("GET", "/static/templates/" + template + "/" + element, true);
                                    xhttp.setRequestHeader("Cache-Control", "no-cache");
                                    xhttp.send();
                                }
                            });
                        })
                    } catch (e) {
                        if (me.templateSendCnt != -1 &&
                            me.templateSendCnt != me.templateDoneCnt) {
                            me.isListSettingDone = true
                        }
                        reject()
                    }
                })
            },
            getToppingSetting(rootModel, modelForElements) {
                var me = this
                return new Promise(async function (resolve, reject) {
                    try {
                        var filterName = JSON.parse(JSON.stringify(me.projectName))
                        filterName = me.filterProjectName(filterName)

                        if (me.preferredToppingPlatforms.length > 0) {
                            me.preferredToppingPlatforms.forEach(function (preferredPlatform) {
                                var template = preferredPlatform

                                // 아래 데이터는 npm 빌드때 파일시스템 tree 탐색을 통해 자동으로 생성하거나 일일이 작업해줘야 한다.
                                var toppingLastIndex = me.$manifestsPerToppings[template].length - 1

                                // 템플릿별 파일목록들
                                me.$manifestsPerToppings[template].forEach(function (element, index) {
                                    element = element.replace('./', '')
                                    var doit = function (content) {
                                        if (element.includes('for-model')) {
                                        }
                                        var test = ''
                                        var count = 0
                                        var optionsCheck = content.split('---')[0];
                                        if (!optionsCheck.includes('forEach:')) {
                                            count = count + 1
                                            if (element.includes('for-model')) {
                                                var forEach = 'Model'
                                                test = test.concat('forEach: ' + forEach)
                                            } else {
                                                var forEach = 'BoundedContext'
                                                test = test.concat('forEach: ' + forEach)
                                            }
                                        } else {
                                            var forEach = optionsCheck.split("forEach:")[1].split("\n")[0].trim();
                                        }

                                        if (!optionsCheck.includes('fileName:')) {
                                            count = count + 1
                                            if (element.split('/')) {
                                                var fileName = element.substring(element.lastIndexOf("/") + 1);
                                                test = test.concat('\n')
                                                if (fileName == 'gitignore') {
                                                    fileName = '.gitignore'
                                                }
                                                test = test.concat('fileName: ' + fileName)
                                            }
                                        }
                                        if (!optionsCheck.includes('path:')) {
                                            var pathData = element.substring(0, element.lastIndexOf("/") + 1);
                                            count = count + 1
                                            if (element.includes('for-model')) {
                                                test = test.concat('\n')
                                                test = test.concat(`path: ${path.dirname(element).replace('./', '')}`)
                                            } else {
                                                test = test.concat('\n')
                                                test = test.concat(`path: {{name}}/${path.dirname(element).replace('./', '')}`)
                                            }
                                        } else if (!optionsCheck.includes('forEach:')) {
                                            var pathData = element.substring(0, element.lastIndexOf("/") + 1);
                                            if (element.includes('for-model')) {
                                                test = test.concat('\n')
                                            } else if (optionsCheck.includes(' path:')) {
                                                count = count + 1
                                                test = test.concat('\n')
                                                test = test.concat(`path: {{name}}/${path.dirname(element).replace('./', '')}`)
                                            } else {
                                                test = test.concat('\n')
                                            }
                                        }
                                        if (count == 3) {
                                            test = test.concat('\n---\n')
                                        } else {
                                            test = test.concat('\n')
                                        }

                                        if (test.length > 0) {
                                            content = test.concat(content)
                                        }
                                        var model = modelForElements[forEach];

                                        // if(model[0]._type == 'org.uengine.modeling.model.Policy' && model[0].relationEventInfo.length > 0)

                                        var process = function (ele) {
                                            try {
                                                if (ele == undefined) {
                                                    var optionsMetadataAndSource = content.split("---"); // 소스와 구분
                                                    var optionsPathHeader = yamlpaser.load(optionsMetadataAndSource[0])
                                                    var elementPath = element.split('/');
                                                    var elementPathString = elementPath[0] + '/' + elementPath[1];
                                                    if (!optionsPathHeader['path'].includes(elementPathString)) {
                                                        optionsPathHeader['path'] = elementPathString.concat(optionsPathHeader['path'])
                                                    }

                                                    var optionsPath = optionsPathHeader['path'].split('/');
                                                    var optionsPathString = '';
                                                    for (var o = 1; o < optionsPath.length; o++) {
                                                        if (o == 1) {
                                                            optionsPathString = optionsPathString.concat(optionsPath[o]);
                                                        } else {
                                                            optionsPathString = optionsPathString.concat('/' + optionsPath[o]);
                                                        }
                                                    }
                                                    var options = {
                                                        "package": `${optionsPathString}`.trim().replace(elementPath[1] + '/src/main/java/', '').replace("-", "").replace(/\//gi, '.'),
                                                        "packagePath": `${optionsPathString}`
                                                    }

                                                    ele = rootModel

                                                } else {
                                                    var options = {
                                                        "package": `${filterName.trim().replace(/ /gi, ".").replace("-", "")}`,
                                                        "packagePath": `src/main/java/${filterName.replace(/ /gi, "/").replace("-", "")}`
                                                    }
                                                }

                                                ele.options = options;
                                                ele.selectedSecurity = me.selectedSecurity

                                                //mustach
                                                // var gen = window.$Mustache.render(content, ele);

                                                //$HandleBars
                                                if (content.split("<function>")[1]) {
                                                    var functionBlock = content.split("<function>")[1];
                                                    functionBlock = functionBlock.replace("\n</function>", "");
                                                    content = content.replace("\n</function>", "");
                                                    content = content.replace("<function>\n", "");
                                                    content = content.replace("<function>", "");
                                                    content = content.replace(functionBlock, "");
                                                    eval(functionBlock);
                                                }

                                                var compile = window.$HandleBars.compile(content);
                                                var gen = compile(ele)

                                                var metadataAndSource = gen.split("---"); // 소스와 구분
                                                var header = yamlpaser.load(metadataAndSource[0])
                                                var options = {}
                                                Object.keys(header).forEach(function (keyValue, idx) {
                                                    var key = keyValue
                                                    var value = Object.values(header)[idx]
                                                    if (key == 'path' && (value.lastIndexOf('.') == value.length - 1)) {
                                                        value = value.substring(0, value.lastIndexOf(".") - 1)
                                                    }
                                                    options[key] = value;
                                                })

                                                var fileName = options['fileName']
                                                if (template == 'spring-boot' && options['fileName'].includes("Impl")) {
                                                    if (!ele.boundedContext.fallback) {
                                                        return;
                                                    }

                                                }

                                                var fullPath = options['path'] + '/' + options['fileName']
                                                if (fileName.includes('Application'))
                                                    if (elementPathString && !fullPath.includes(elementPathString)) {
                                                        fullPath = elementPathString.concat(fullPath)
                                                    }
                                                // /src/main/java/com/example/Application.java
                                                // for-model/gateway2/src/main/java/com/example/template/Application.java
                                                var source = ''

                                                if (metadataAndSource.length > 1) {
                                                    for (var data in metadataAndSource) {

                                                        if (data != 0 && data < metadataAndSource.length - 1) {
                                                            source = source.concat(metadataAndSource[data] + '---\n')
                                                        } else if (data == metadataAndSource.length - 1) {
                                                            source = source.concat(metadataAndSource[data])
                                                        }
                                                    }
                                                }

                                                var codeValue = {}
                                                var fullValue = {}
                                                source = source.replace('\n', '')
                                                if (source.length > 1) {
                                                    var uuid = me.uuid();
                                                    var hashName = JSON.parse(JSON.stringify(fileName))
                                                    var hashValue = JSON.parse(JSON.stringify(source))
                                                    var hashPath = JSON.parse(JSON.stringify(fullPath))
                                                    var hashConcat = hashName.concat(hashValue)
                                                    hashConcat = hashConcat.concat(hashPath)

                                                    var sourceHash = Math.abs(me.hashCode(hashConcat))
                                                    if (ele._type == 'org.uengine.modeling.model.Model') {
                                                        // /src/main/java/com/example/Application.java
                                                        // gateway2/src/main/java/com/example/template/Application.java

                                                        codeValue = {
                                                            'key': uuid,
                                                            'hash': sourceHash,
                                                            'fileName': fileName,
                                                            'code': source,
                                                            'file': me.fileType(fileName),
                                                            'boundedContext': fullPath.split("/")[0],
                                                            'element': ele.element ? ele.elementView.id : null
                                                        }


                                                        fullValue = {
                                                            'key': uuid,
                                                            'fullPath': fullPath.replace('for-model/', ''),
                                                            'element': ele.element ? ele.elementView.id : null,
                                                            'hash': sourceHash,
                                                        }
                                                    } else {
                                                        if (ele._type == 'org.uengine.modeling.model.BoundedContext') {
                                                            codeValue = {
                                                                'key': uuid,
                                                                'hash': sourceHash,
                                                                'fileName': fileName,
                                                                'code': source,
                                                                'file': me.fileType(fileName),
                                                                'boundedContext': fullPath.split("/")[0],
                                                                'element': ele.element ? ele.elementView.id : null
                                                            }

                                                            fullValue = {
                                                                'key': uuid,
                                                                'fullPath': fullPath,
                                                                'element': ele.element ? ele.elementView.id : null,
                                                                'hash': sourceHash,
                                                            }
                                                        } else {
                                                            //////// why key is required?
                                                            //////// -> TreeView에서 사용하는 Key
                                                            codeValue = {
                                                                'key': uuid,
                                                                'hash': sourceHash,
                                                                'fileName': fileName,
                                                                'code': source,
                                                                'file': me.fileType(fileName),
                                                                'boundedContext': fullPath.split("/")[0],
                                                                'element': ele.element ? ele.elementView.id : null
                                                            };

                                                            fullValue = {
                                                                'key': uuid,
                                                                'fullPath': fullPath,
                                                                'hash': sourceHash,
                                                                'element': ele.element ? ele.elementView.id : null
                                                            };
                                                        }
                                                    }
                                                    var findIndex = me.fullPathList.findIndex(x => (x.fullPath == fullValue.fullPath))
                                                    if (findIndex == -1) {
                                                        me.fullPathList.push(fullValue)
                                                        me.getCodeList.push(codeValue)
                                                    } else {
                                                        me.getCodeList[findIndex].code = codeValue.code
                                                    }
                                                }
                                            } catch (e) {

                                                console.log(ele)
                                                console.log(e)
                                            } finally {
                                                me.toppingDoneCnt = me.toppingDoneCnt + 1
                                            }
                                        }


                                        if (Array.isArray(model)) {
                                            model.forEach(function (modelElement) {
                                                process(modelElement)
                                                if (me.toppingSendCnt == -1) me.toppingSendCnt = 0
                                                me.toppingSendCnt = me.toppingSendCnt + 1
                                            });
                                        } else {
                                            process(model);
                                            if (me.toppingSendCnt == -1) me.toppingSendCnt = 0
                                            me.toppingSendCnt = me.toppingSendCnt + 1
                                        }


                                    }

                                    var xhttp = new XMLHttpRequest();

                                    xhttp.onreadystatechange = function () {

                                        if (this.readyState == 4 && this.status == 200) {
                                            if (template == 'Custom Template') {
                                                var gitCodeObj = JSON.parse(this.responseText);
                                                var gitCodeTmp = Base64.decode(gitCodeObj.content)
                                                doit(gitCodeTmp)
                                            } else {
                                                // 해당 구문으로 존재하지 않는 파일에 대하여 예외처리가 가능함
                                                if (!this.responseText.includes("<!-- Is Not Template -->"))
                                                    doit(this.responseText);
                                            }
                                            if (toppingLastIndex == index) {
                                                me.mergeCodeList = me.arrayToObject(JSON.parse(JSON.stringify(me.getCodeList)))
                                                resolve()
                                            }
                                        }
                                    };
                                    if (template == 'Custom Template') {
                                        xhttp.open("GET", me.gitCodeUrl[element], true);
                                        xhttp.setRequestHeader('Authorization', 'token ' + me.gitAccessToken);
                                        xhttp.send();
                                    } else {
                                        xhttp.open("GET", "/static/toppings/" + template + "/" + element, true);
                                        xhttp.send();
                                    }
                                });
                            })
                        } else {
                            if (me.toppingSendCnt == -1) me.toppingSendCnt = 0
                            resolve()
                        }
                    } catch (e) {
                        if (me.toppingSendCnt != -1 &&
                            me.toppingSendCnt != me.toppingDoneCnt) {
                            me.isListSettingDone = true
                        }
                        reject()
                    }

                })
            },
            // jjy
            async getListSetting() {
                //USE CodeView
                var me = this
                // me.codeLoading = true
                me.isListSettingDone = false
                me.fullPathList = []
                me.getCodeList = []
                me.treeList = []
                // me.mergeStatus = false
                // console.log('methods- Start getListSetting')


                var filterName = JSON.parse(JSON.stringify(me.projectName))
                filterName = me.filterProjectName(filterName)

                var rootModelAndElementMap = me.convertModelForCodeGen(me.value, filterName);

                //codeView
                var rootModel = rootModelAndElementMap.rootModel
                var modelForElements = rootModelAndElementMap.modelForElements
                var preferredPlatforms = rootModelAndElementMap.preferredPlatforms

                rootModel.boundedContexts.forEach(function (bound, idx) {
                    bound.portGenerated = 8081 + idx

                    if (rootModel.boundedContexts[idx].aggregates.length >= 1) {
                        rootModel.boundedContexts[idx].aggregates.forEach(function (agg, aggIdx) {
                            if (!agg) return;

                            var lifeCycles = [
                                {trigger: 'PostPersist', annotation: '@PostPersist', events: [], commands: []},
                                {trigger: 'PostUpdate', annotation: '@PostUpdate', events: [], commands: []},
                                {trigger: 'PostRemove', annotation: '@PostRemove', events: [], commands: []},
                                {trigger: 'PrePersist', annotation: '@PrePersist', events: [], commands: []},
                                {trigger: 'PreUpdate', annotation: '@PreUpdate', events: [], commands: []},
                                {trigger: 'PreRemove', annotation: '@PreRemove', events: [], commands: []},
                            ]
                            // fieldDescriptors 전처리
                            agg.aggregateRoot.fieldDescriptors.forEach(function (fd, index) {
                                fd.name = fd.name
                                fd.nameCamelCase = _.camelCase(fd.name)
                                fd.namePascalCase = fd.nameCamelCase.substring(0, 1).toUpperCase() + fd.nameCamelCase.substring(1);
                                if (fd.isKey || index == 0) {
                                    agg.aggregateRoot.keyFieldDescriptor = fd;
                                    agg.keyFieldDescriptor = fd;
                                }
                            })

                            if (agg.commands)
                                agg.commands.forEach(function (co) {
                                    lifeCycles.some(function (lifeCycle) {
                                        if (!co.trigger || co.trigger == undefined) {
                                            if (co.restRepositoryInfo.method == "POST") {
                                                co.trigger = "@PrePersist"
                                            } else if (co.restRepositoryInfo.method == "DELETE") {
                                                co.trigger = "@PreRemove"
                                            } else if (co.restRepositoryInfo.method == "PATCH") {
                                                co.trigger = "@PreUpdate"
                                            }
                                        }
                                        if (lifeCycle.annotation == co.trigger) {
                                            lifeCycle.commands.push(co)
                                            return;
                                        }
                                    })

                                    if (co.controllerInfo.apiPath != '') {
                                        // co.controllerInfo.apiPath =co.controllerInfo.apiPath.replace('/',`//`)
                                    }

                                })

                            if (agg.events)
                                agg.events.forEach(function (ev) {
                                    ev.fieldDescriptors.forEach(function (fd) {
                                        fd.name = fd.name
                                        fd.nameCamelCase = _.camelCase(fd.name)
                                        fd.namePascalCase = fd.nameCamelCase.substring(0, 1).toUpperCase() + fd.nameCamelCase.substring(1);
                                        if (fd.isKey)
                                            ev.keyFieldDescriptor = fd;
                                    })
                                    lifeCycles.some(function (lifeCycle) {
                                        if (lifeCycle.annotation == ev.trigger) {
                                            lifeCycle.events.push(ev)
                                            return;
                                        }
                                    })
                                })

                            lifeCycles.forEach(function (lifeCycleNull, idx) {
                                if (lifeCycleNull.events.length == 0 && lifeCycleNull.commands.length == 0) {
                                    lifeCycles[idx] = null;
                                }
                            })

                            lifeCycles = lifeCycles.filter(n => n);

                            if (lifeCycles.length > 0) {
                                rootModel.boundedContexts[idx].aggregates[aggIdx].lifeCycles = lifeCycles;
                            }
                        })
                    }

                    if (rootModel.boundedContexts[idx].policies.length >= 1) {
                        rootModel.boundedContexts[idx].policies.forEach(function (po) {
                        })
                    }

                    if (rootModel.boundedContexts[idx].viewes.length >= 1) {
                        rootModel.boundedContexts[idx].viewes.forEach(function (vi) {

                            vi.fieldDescriptors.forEach(function (fd) {
                                fd.name = fd.name
                                fd.nameCamelCase = _.camelCase(fd.name)
                                fd.namePascalCase = fd.nameCamelCase.substring(0, 1).toUpperCase() + fd.nameCamelCase.substring(1);
                                if (fd.isKey)
                                    vi.keyFieldDescriptor = fd;
                            })

                        })
                    }

                })

                var getList = await me.getTemplateSetting(rootModel, modelForElements, preferredPlatforms);
                me.addTemplateCode();
                Promise.all([getList]).then(async function () {
                    var getTopping = await me.getToppingSetting(rootModel, modelForElements);
                    me.$ModelingBus.$emit("clearOld")
                    me.setBeforeCode()
                })
            },
            fileType(file) {
                var type;
                if (file.includes('.java')) {
                    type = 'java'
                } else if (file.includes('Dockerfile')) {
                    type = 'docker'
                } else if (file.includes('.xml')) {
                    type = 'xml'
                } else if (file.includes('.yaml') || file.includes('.yml') || file.includes('.properties') || file.includes('mvnw') || file.includes('.groovy')) {
                    type = 'txt'
                } else if (file.includes('md')) {
                    type = 'md'
                } else if (file.includes('.jpg') || file.includes('.png') || file.includes('.jpeg') || file.includes('.svg')) {
                    type = 'png'
                } else if (file.includes('.json')) {
                    type = 'json'
                } else if (file.includes('.py')) {
                    type = 'python'
                } else if (file.includes('.vue')) {
                    type = 'vue'
                } else if (file.includes('.js')) {
                    type = 'js'
                } else if (file.includes('.html')) {
                    type = 'html'
                } else if (file.includes('.go')) {
                    type = 'go'
                } else if (file.includes('.msaez')) {
                    type = 'properties'
                }

                return type
            },
            findFile(value, name) {
                var me = this
                var ob = null

                var hash = value.hash ? value.hash : null

                me.getCodeList.some(function (meta) {
                    if (meta.hash == hash && meta.fileName == name) {
                        ob = {
                            key: meta.key,
                            code: meta.code,
                            file: meta.file,
                            hash: meta.hash
                        }
                        return true;
                    }
                })
                if (!ob) {
                    //folder

                    var hashName = JSON.parse(JSON.stringify(name))
                    var hashValue = JSON.parse(JSON.stringify('undefined'))
                    var hashPath = JSON.parse(JSON.stringify(value.fullPath))
                    var hashConcat = hashName.concat(hashValue)
                    hashConcat = hashConcat.concat(hashPath)
                    var sourceHash = Math.abs(me.hashCode(hashConcat))

                    ob = {
                        key: sourceHash,
                        hash: sourceHash
                    }
                }
                return ob
            },
            //
            async codeModalShow() {
                var me = this

                try {
                    me.gitAccessToken = localStorage.getItem('gitAccessToken')
                    me.getCodeList = []
                    me.model = []

                    var filtered = me.filterProjectName(me.projectName)
                    if (filtered.replace(/\s/gi, "") == '') {
                        // validationResults
                        var validationResultIndex = me.canvasValidationResults.findIndex(x => (x.code == me.ESC_NOT_PJ_NAME))
                        var isExistValidationResult = validationResultIndex == -1 ? false : true
                        if (!isExistValidationResult) {
                            me.canvasValidationResults.push(me.validationFromCode(me.ESC_NOT_PJ_NAME))
                        }
                        me.projectName = window.prompt("Please input your ProjectName(English Only)")
                        return false
                    } else {
                        me.openCodeViewer()

                        // 0509
                        // me.openCode = [];
                        await me.getListSetting()
                        // closeByBackdrop

                        me.codeViewing = true;
                        me.checkName = true
                        return true
                    }
                } catch (e) {
                    console.log(e)
                    alert('codeModalShow:: ', e)
                    return false
                }
            },
            umlModalShow() {
                this.$modal.show('uml-modal');
            },
            async uploadMinio() {
                var me = this

                var filterName = JSON.parse(JSON.stringify(me.projectName))

                filterName = me.filterProjectName(filterName)


                if (me.treeList.length > 0) {
                    me.treeList.forEach(function (list) {
                        if (!list.file) {
                            me.reverse(list.children, list.name)
                        } else {
                            me.pathTmp.push({path: list.name, code: list.code})
                        }
                    })

                    var zip = new JSZip();

                    // var parents = [];

                    me.pathTmp.forEach(function (generateData) {
                        // if(typeof generateData == String) {
                        //     // zip.file(generateData.path,)
                        // }
                        if (generateData.path.includes('/')) {
                            // parents.push(generateData.path.split('/')[0])
                        }
                        zip.file(generateData.path, generateData.code)
                    })

                    // parents.forEach(function (prefix) {
                    //     zip.folder(prefix).forEach(function (relativePath, file) {
                    //     });
                    // })

                    zip.generateAsync({type: "blob"})
                        .then(function (content) {
                            // Force down of the Zip file
                            saveAs(content, `${filterName}.zip`);
                        });

                } else {
                    await me.getListSetting();
                    me.generateZip();
                }
            },
            async generateZip() {
                var me = this
                try {
                    var filterName = JSON.parse(JSON.stringify(me.projectName))
                    filterName = me.filterProjectName(filterName)

                    var promiseValue = await me.getListSetting();

                    function sleep(ms) {
                        return new Promise(resolve => setTimeout(resolve, ms))
                    }

                    if (!me.generateZipDialog || !me.isDownloading) {
                        me.generateZipDialog = true
                        me.isDownloading = true
                    }

                    while (!me.isListSettingDone) {
                        await sleep(1000);
                    }
                    // mergeTreeList의 세팅이 끝나야함.
                    // 파악을 어디서 하지?
                    Promise.all([promiseValue]).then(async function () {
                        me.treeList.forEach(function (list, idx) {
                            if (!list.file) {
                                me.reverse(list.children, list.name)
                            } else {
                                if (list.name.includes('Indexedfile'))
                                    me.pathTmp.push({name: list.name, key: list.key, path: list.name, code: list.code})
                            }
                        })

                        var zip = new JSZip();
                        // var parents = [];

                        me.pathTmp.forEach(function (generateData) {
                            // if(typeof generateData == String) {
                            //     // zip.file(generateData.path,)
                            // }
                            if (generateData.path.includes('/')) {
                                // parents.push(generateData.path.split('/')[0])
                            }
                            zip.file(generateData.path, generateData.code)
                        })

                        // parents.forEach(function (prefix) {
                        //     zip.folder(prefix).forEach(function (relativePath, file) {
                        //     });
                        // })

                        var rtn = await zip.generateAsync({type: "blob"})
                            .then(function (content) {
                                // Force down of the Zip file
                                saveAs(content, `${filterName}.zip`);
                                me.isDownloading = false
                                me.codeStatus = false
                                return true
                            }).catch(function (error) {
                                return false
                            })
                        // me.mergeStatus = null;
                        me.generateZipDialog = false
                        me.isDownloading = false
                        return rtn
                    })
                    return null
                } catch (e) {
                    console.log(`[Error] generateZip: ${e}`)
                    return false
                }
            },
            getPodStatus(userName, userGroup, projectName) {
                var me = this
                return new Promise(function (resolve, reject) {
                    var hashName;
                    try {
                        if (me.$route.params.labId) {
                            if (me.$parent.labInfo.independent) {
                                var hashPath = me.getClassPath('labs/' + me.$route.params.labId + '/' + me.$route.params.userId);
                            } else {
                                var hashPath = me.getClassPath(me.$route.params.userId);
                            }
                            hashName = "labs-" + me.hashCode(hashPath);
                        } else {
                            hashName = `ide-${me.hashCode(userGroup + "-" + userName)}`
                        }
                        me.$http.get(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/default/pods/${hashName}`).then(function (result) {
                            if (result.data.status.phase == "Running") {
                                resolve(true)
                            } else {
                                resolve(false)
                            }
                        }).catch(function (e) {
                            resolve(false)
                        })
                    } catch (e) {
                        alert('getPodStatus-ERROR :', e)
                        resolve(false)
                    }

                })
            },
            getServiceStatus(userName, userGroup, projectName) {
                var me = this
                var hashName = `ide-${me.hashCode(userGroup + "-" + userName)}`
                return new Promise(function (resolve, reject) {
                    me.$http.get(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/default/services/${hashName}`).then(function (result) {
                        resolve(true)
                    }).catch(function (e) {
                        resolve(false)
                    })
                })
            },
            deletePod(userName, userGroup, projectName) {
                var me = this
                return new Promise(function (resolve, reject) {
                    var hashName = `ide-${me.hashCode(userGroup + "-" + userName)}`
                    me.$http.delete(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/default/pods/${hashName}`).then(function (result) {
                        if (result.data.status.phase == "Running") {
                            resolve(true)
                        } else {
                            resolve(false)
                        }
                    }).catch(function (e) {
                        resolve(false)
                    })
                })
            },
            presignedURL(path) {
                var me = this
                return new Promise((resolve, reject) => {
                    me.$minioClient.presignedUrl('GET', 'eventstorming', path, 24 * 60 * 60, function (err, presignedUrl) {
                        if (err) return reject(err)
                        resolve(presignedUrl)
                    })
                });
            },
            deleteService(userName, userGroup, projectName) {
                var me = this
                return new Promise(function (resolve, reject) {
                    var hashName = `ide-${me.hashCode(userGroup + "-" + userName)}`
                    me.$http.delete(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/default/services/${hashName}`).then(function (result) {
                        if (result.data.status.phase == "Running") {
                            resolve(true)
                        } else {
                            resolve(false)
                        }
                    }).catch(function (e) {
                        resolve(false)
                    })
                })
            },
            async setGitRepository() {
                var me = this
                var userName = localStorage.getItem("email").split('@')[0].toLowerCase();
                var userGroup = localStorage.getItem("email").split('@')[1].split('.')[0].toLowerCase();
                var projectName = me.projectName.toLowerCase();
                var sshUrl = await me.makeGitRepo(me.gitInfo.name, me.gitInfo.token)
                me.sshUrl = "https://" + sshUrl.replace("git", me.gitInfo.token).replace(":", "/")
                me.linkedSCM = true;
                me.scmUrl = me.sshUrl;
                me.settingGitInfoDialog = false;

            },
            getClassPath(path) {
                if (this.classId) {
                    var classId = this.classId.replace('@', '/')
                } else {
                    var classId = this.$route.params.classId.replace('@', '/')
                }

                if (this.courseId) {
                    var courseId = this.courseId
                } else {
                    var courseId = this.$route.params.courseId
                }
                return `${courseId}/classes/${classId}/${path}`;
            },
            // async ideStartValidation() {
            //     var me = this
            //     var userName = localStorage.getItem("email").split('@')[0].toLowerCase();
            //     var userGroup = localStorage.getItem("email").split('@')[1].split('.')[0].toLowerCase();
            //     var projectName = me.projectName.toLowerCase();
            //     if (projectName.length < 1) {
            //         var tempName = window.prompt('projectName을 입력하여주세요.');
            //         me.projectName = tempName;
            //         return me.ideStartValidation();
            //     }
            //     var hashName;
            //     if (me.$route.params.labId) {
            //         if (me.$parent.labInfo.independent) {
            //             var hashPath = me.getClassPath('labs/' + me.$route.params.labId + '/' + me.$route.params.userId);
            //         } else {
            //             var hashPath = me.getClassPath(me.$route.params.userId);
            //         }
            //         hashName = "labs-" + me.hashCode(hashPath);
            //     } else {
            //         hashName = `ide-${me.hashCode(userGroup + "-" + userName)}`
            //     }
            //     // alert("test")
            //     me.$http.get(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/default/pods/${hashName}`).then(function (result) {
            //         me.openProjectIDE()
            //     }).catch(function (e) {
            //         if (e.toString().includes(500)) {
            //             me.openProjectIDE()
            //         }
            //     })
            // },
            // deleteIdeFile(userGroup, userName, projectName) {
            //     var me = this
            //     return new Promise(function (resolve) {
            //         var userName = localStorage.getItem("email").split('@')[0].toLowerCase();
            //         var userGroup = localStorage.getItem("email").split('@')[1].split('.')[0].toLowerCase();
            //         var hashName;
            //         if (me.$route.params.labId) {
            //             if (me.$parent.labInfo.independent) {
            //                 var hashPath = me.getClassPath('labs/' + me.$route.params.labId + '/' + me.$route.params.userId);
            //             } else {
            //                 var hashPath = me.getClassPath(me.$route.params.userId);
            //             }
            //             hashName = "labs-" + me.hashCode(hashPath);
            //         } else {
            //             hashName = `ide-${me.hashCode(userGroup + "-" + userName)}`
            //         }
            //         me.$http.delete(`${me.getProtocol()}//file.kuberez.io/api/delete`, {
            //             data: {
            //                 hashName: hashName,
            //                 filePath: `labs-eventstorming/${userGroup}/classes/users/labs/${localStorage.getItem("author")}`,
            //                 lab: `${projectName}`
            //             },
            //         }).then(function (data) {
            //             setTimeout(function () {
            //                 resolve()
            //             }, 4000)
            //
            //         }).catch(e => alert(e))
            //     })
            // },
            async openProjectIDE(gitUrl) {
                var me = this
                me.changedTmp = []
                me.codeStatus = false
                me.ideCheckDialog = false;
                me.$EventBus.$emit("progressing", {
                    progressing: true,
                    type: 'ES'
                })
                // this.gitUrl = gitUrl;
                var userName = localStorage.getItem("email").split('@')[0].toLowerCase();
                var userGroup = localStorage.getItem("email").split('@')[1].split('.')[0].toLowerCase();
                var projectName = me.projectName.toLowerCase();
                var projectId = 'untitled'

                if (me.isClazzModeling) {
                    projectId = me.$route.params.labId
                } else {
                    projectId = me.$route.params.projectId;
                }

                var podStatus = await me.getPodStatus(userName, userGroup, projectName);
                var hashName;

                // if (!me.mergeStatus) {
                await me.getListSetting();
                // }

                while (!me.codeStatus) {
                    await sleep(3000);
                }


                // if (me.ideUpdateCheck) {
                //     await me.deleteIdeFile(userGroup, userName, projectId);
                // }
                if (me.$route.params.labId) {
                    if (me.$parent.labInfo.independent) {
                        var hashPath = me.getClassPath('labs/' + me.$route.params.labId + '/' + me.$route.params.userId);
                        var filePath = hashPath

                    } else {
                        var hashPath = me.getClassPath(me.$route.params.userId);
                        var filePath = me.getClassPath('labs/' + me.$route.params.userId);

                    }
                    hashName = "labs-" + me.hashCode(hashPath);
                } else {
                    hashName = `ide-${me.hashCode(userGroup + "-" + userName)}`
                }

                me.$EventBus.$emit("hashName", {
                    hashName: hashName,
                })

                if (me.projectName.length < 1) {
                    var tempProjectName = window.prompt('Project Name을 입력하여 주세요.');
                    projectName = tempProjectName;
                    me.projectName = tempProjectName
                }

                function sleep(ms) {
                    return new Promise(resolve => setTimeout(resolve, ms))
                }

                // me.mergeStatus = false;

                me.changedCount = 0;
                if (me.treeList.length > 0) {
                    me.treeList.forEach(function (list) {
                        if (!list.file) {
                            me.reverse(list.children, list.name)
                        } else if (list.changed > 0) {
                            me.pathTmp.push({
                                path: list.name,
                                code: list.code,
                                changed: list.changed,
                                key: list.key,
                                path: list.path
                            })
                            me.changedTmp.push({
                                path: list.name,
                                code: list.code,
                                changed: list.changed,
                                key: list.key,
                                path: list.path
                            })
                            me.changedCount++;
                        } else if (list.isNew) {
                            me.pathTmp.push({
                                name: list.name,
                                path: list.name,
                                code: list.code,
                                isNew: true,
                                key: list.key,
                                path: list.path
                            })
                            me.changedTmp.push({
                                name: list.name,
                                path: list.name,
                                code: list.code,
                                isNew: true,
                                key: list.key,
                                path: list.path
                            })
                            me.changedCount++;
                        } else {
                            me.changedTmp.push({path: list.name, code: list.code, key: list.key, path: list.path})
                            me.pathTmp.push({path: list.name, code: list.code, key: list.key, path: list.path})
                        }
                    })

                    // if (me.changedCount > 0) {
                    //     me.changedModifying = true
                    //     me.cancelModifying = true
                    //     me.$EventBus.$emit("hideProgressing");
                    //     me.openCodeViewer()
                    //     // me.$modal.show('code-modal')
                    // }
                    //
                    // while (me.changedModifying && me.cancelModifying) {
                    //     await sleep(3000);
                    // }

                    if (me.changedModifying) {
                        me.changedModifying = false
                        me.$EventBus.$emit("endProgressing");
                        return;
                    }

                    me.$EventBus.$emit("nextStep");
                    var zip = new JSZip();

                    // var parents = [];

                    // Git URL 관련 처리 필요함..
                    // BoundedContext 찾기
                    var gitConnectedBoundedLists = []
                    Object.keys(me.attachedLists.boundedContextLists).forEach(function (bounded) {
                        if (me.attachedLists.boundedContextLists[bounded].gitURL) {
                            gitConnectedBoundedLists.push(me.attachedLists.boundedContextLists[bounded].name)
                        }
                    })
                    await me.makeDir(`labs-eventstorming/running/${userGroup}/classes/users/labs/${localStorage.getItem("email")}/${projectId}`)
                    /* me.$http.post(`${me.fileServerUrl}/api/makeDir`, {
                         "hashName": hashName,
                         "path": `home/minio/labs-eventstorming/running/${userGroup}/classes/users/labs/${localStorage.getItem("email")}/${projectId}`
                     }).catch(e => console.log(e));*/
                    me.pathTmp.forEach(function (generateData) {
                        console.log(generateData);
                        if (generateData.path.includes('/')) {
                            // parents.push(generateData.path.split('/')[0])
                        }
                        if (!gitConnectedBoundedLists.includes(generateData.path.split("/")[0]))
                            zip.file(generateData.path, generateData.code)
                    })

                    // parents. forEach(function (prefix) {
                    //     zip.folder(prefix).forEach(function (relativePath, file) {
                    //     });
                    // })


                    zip.generateAsync({type: "nodebuffer"})
                        .then(async function (content) {
                            var metaData = {
                                'Content-Type': 'application/zip',
                            }
                            me.$EventBus.$emit("nextStep")
                            // var minioClient = new Minio.Client({
                            //     endPoint: `minio.${me.getTenantId()}`,
                            //     port: 443,
                            //     useSSL: true,
                            //     accessKey: 'minio',
                            //     secretKey: 'minio123'
                            // });

                            var configPath = `${userGroup}/${userName}/config`
                            var checkConfigFile;
                            try {
                                checkConfigFile = await me.getString('minio://' + configPath + '/config');
                            } catch (e) {
                                checkConfigFile = null
                            }

                            if (podStatus) {
                                me.$EventBus.$emit("nextStep")

                                me.$EventBus.$emit("nextStep");
                                me.$EventBus.$emit("nextStep");
                                // Pod가 존재 한다면 파일만 추가
                                // IdeLoadingPage
                                if (gitUrl)
                                    me.ideWindow = window.open(`IdeLoadingPage?param=${hashName}&projectName=${me.$route.params.labId ? me.$route.params.labId : projectId}&giturl=${encodeURIComponent(gitUrl)}`, '_blank')
                                else
                                    me.ideWindow = window.open(`IdeLoadingPage?param=${hashName}&projectName=${me.$route.params.labId ? me.$route.params.labId : projectId}`, '_blank')
                                me.$EventBus.$emit("nextStep");

                                me.$nextTick(function () {
                                    me.overlayText = null
                                    me.pathTmp = []
                                    me.$EventBus.$emit("endProgressing");
                                })
                                return;
                            } else {
                                me.$EventBus.$emit("nextStep");

                                var convertEmail = me.userInfo.email.replace(/\./gi, '_')

                                if (me.isForeign) {
                                    me.toolResourceQuota.cpu = "4"
                                    me.toolResourceQuota.memory = "8Gi"
                                } else {
                                    me.resourceQuotaDialog = true;
                                    while (!me.setResourceQuota) {
                                        await sleep(1000);
                                    }
                                }
                                me.setResourceQuota = false

                                var setResourceType = me.resourceType

                                if (me.$route.params.labId) {
                                    var course = me.courseId;
                                    var clazz = me.classId;
                                    var clazzName = clazz
                                    var lab = me.labId;
                                }

                                //ide  && k8s setting
                                var spec = {
                                    "apiVersion": "uengine.org/v1alpha1",
                                    "kind": "Ide",
                                    "metadata": {
                                        "name": hashName
                                    },
                                    "spec": {
                                        "hashName": hashName,
                                        "userId": localStorage.getItem("author").replace("@", "_"),
                                        // "templateFile": `${projectId}.zip`,
                                        "image": 'msa-repository.kubeflow.kr/msaez/theia-full-test:v9',
                                        "tenant": me.$route.params.labId ? me.getTenantId() : "eventstorming",
                                        "course": me.$route.params.labId ? course : `${userGroup}`,
                                        "lab": me.$route.params.labId ? lab : `${projectId}`,
                                        "clazz": me.$route.params.labId ? clazzName : `users`,
                                        // "zipUrl": zipUrl,
                                        "status": "running"
                                    }
                                }
                                //set k8s
                                spec.spec.resourceQuota = me.toolResourceQuota;
                                await me.$http.post(`${me.getProtocol()}//api.${me.getTenantId()}/apis/uengine.org/v1alpha1/namespaces/default/ides`, spec);

                                if (me.toolResourceType) {
                                    setResourceType = `${setResourceType}@${me.toolResourceType}`
                                }

                                // resourceType
                                var resourceTypeObj = {
                                    resourceType: setResourceType
                                }
                                me.putObject(`db://enrolledUsers/${convertEmail}/usage/${hashName}`, resourceTypeObj)
                            }
                            // ----------- Resource Size basic 설정 END------------->


                            var operatorCheck = await me.checkIdeOperator(hashName);

                            function sleep(ms) {
                                return new Promise(resolve => setTimeout(resolve, ms))
                            }

                            while (!operatorCheck) {
                                operatorCheck = await me.checkIdeOperator(hashName);
                                await sleep(3000)
                            }
                            // me.setResourceQuota = false;
                            var obj = {
                                "course": `${userGroup}`,
                                "lab": `${userName}`,
                                "clazz": `${projectId}`,
                                "userId": localStorage.getItem("author").replace("@", "_")
                            }
                            await me.deleteConfig(hashName, obj)
                            await me.makeConfig(hashName, obj);
// IdeLoadingPage
                            if (this.gitUrl)
                                me.ideWindow = window.open(`IdeLoadingPage?param=${hashName}&projectName=${projectId}&giturl=${encodeURIComponent(gitUrl)}`, '_blank')
                            else
                                me.ideWindow = window.open(`IdeLoadingPage?param=${hashName}&projectName=${projectId}`, '_blank')
                            if (me.sshUrl) {
                                var commandParams = new URLSearchParams();
                                commandParams.append('filePath', `labs-eventstorming/running/${userGroup}/classes/users/labs/${localStorage.getItem("author")}`);
                                commandParams.append('lab', `${projectId}`);
                                commandParams.append('githubURL', `${me.sshUrl}`);
                                commandParams.append('hashName', `${hashName}`);
                                setTimeout(function () {
                                    me.$http.post(`${me.getProtocol()}//file.kuberez.io/api/runCommand`, commandParams)
                                }, 3000)
                            }
                            me.$EventBus.$emit("nextStep");
                            setTimeout(function () {
                                me.$http.post(`${me.getProtocol()}//file.kuberez.io/api/gitCommit`, gitParams)
                            }, 3000)

                            me.$nextTick(function () {
                                me.overlayText = null
                                me.pathTmp = []
                                me.$EventBus.$emit("endProgressing");
                            })
                            // })
                            me.$EventBus.$emit("nextStep")
                            // var zipUrl = await me.presignedURL(`${userGroup}/${userName}/${projectId}.zip`);
                        })

                } else {
                    await me.getListSetting();
                    me.openProjectIDE();
                }
            },
            checkIdeOperator(hashName) {
                var me = this
                if (me.classInfo) {
                    var serverToken = me.classInfo.token;
                    var serverUrl = me.classInfo.serverUrl;
                }

                if (!serverUrl || !serverToken) {
                    return new Promise(function (resolve) {
                        me.$http.get(`${me.getProtocol()}//api.${me.getTenantId()}/apis/uengine.org/v1alpha1/namespaces/default/ides/${hashName}/status`).then(function (result) {
                            result.data.status.conditions.forEach(function (item) {
                                if (item.reason == "InstallSuccessful" && item.type == "Deployed") {
                                    resolve(true)
                                }
                            })
                        }).catch(function (e) {
                            resolve(false)
                        })
                    })
                } else {
                    return new Promise(function (resolve) {
                        me.$http.get(`${me.getProtocol()}//api.${me.getTenantId()}/apis/uengine.org/v1alpha1/namespaces/default/ides/${hashName}/status?serverUrl=${serverUrl}&token=${serverToken}`).then(function (result) {
                            result.data.status.conditions.forEach(function (item) {
                                if (item.reason == "InstallSuccessful" && item.type == "Deployed") {
                                    resolve(true)
                                }
                            })
                        }).catch(function (e) {
                            resolve(false)
                        })
                    })
                }
            },
            makeGitRepo(projectName, accessToken) {
                var me = this
                return new Promise(function (resolve) {
                    me.$http.post("https://api.github.com/user/repos", {
                        name: `${projectName}`
                    }, {
                        headers: {
                            'Accept': 'application/vnd.github.v3+json',
                            "Authorization": `Bearer ${localStorage.getItem('gitAccessToken') ? localStorage.getItem('gitAccessToken') : accessToken}`
                        }
                    }).then(function (result) {
                        resolve(result.data.ssh_url);
                    }).catch(e => alert(e))
                })
            },

            reverse(item, path) {
                var me = this

                if (item)
                    item.forEach(function (list) {
                        if (list.children) {
                            //폴더 생성하기
                            var tmpPath = path + '/' + list.name

                            me.reverse(list.children, tmpPath);
                        } else {
                            //파일생성하
                            if (list.code) {
                                // if (list.name.includes('indexedfile'))
                                if (list.changed > 0) {
                                    me.pathTmp.push({
                                        name: list.name,
                                        path: list.name,
                                        code: list.code,
                                        changed: list.changed,
                                        key: list.key,
                                        path: list.path
                                    })
                                    me.changedTmp.push({
                                        name: list.name,
                                        path: list.name,
                                        code: list.code,
                                        changed: list.changed,
                                        key: list.key,
                                        path: list.path
                                    })
                                    me.changedCount++
                                } else if (list.isNew) {
                                    me.pathTmp.push({
                                        name: list.name,
                                        path: list.name,
                                        code: list.code,
                                        isNew: true,
                                        key: list.key,
                                        path: list.path
                                    })
                                    me.changedTmp.push({
                                        name: list.name,
                                        path: list.name,
                                        code: list.code,
                                        isNew: true,
                                        key: list.key,
                                        path: list.path
                                    })
                                    me.changedCount++
                                } else {
                                    me.pathTmp.push({
                                        name: list.name,
                                        key: list.key,
                                        path: path + '/' + list.name,
                                        code: list.code,
                                        path: list.path
                                    })
                                }
                            }
                        }
                    })
            },
            codeModalhide() {
                var me = this
                me.closeCodeViewer()

                me.codeViewing = false;
                // me.openCode = [];
            },
            ajax: function (url, method, payload, successCallback) {
                var xhr = new XMLHttpRequest();
                xhr.open(method, url, true);
                // xhr.withCredentials = true;
                xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
                xhr.onreadystatechange = function () {
                    if (xhr.readyState != 4 || xhr.status != 200) return;
                    successCallback(xhr.responseText);
                };
                xhr.send(JSON.stringify(payload));
            },

            // Todo: Refactoring 필요 ( 이전 로직 )
            async generateZipToFireBase(boundedId) {
                var me = this
                var pathTmp = []
                var boundedName = me.$refs[boundedId][0].value.name

                var data = {fullPathList: [], getCodeList: []}
                me.fullPathList.forEach(function (item) {
                    if (item.fullPath.split("/")[0] == boundedName) {
                        data.fullPathList.push(item)
                    }
                })
                me.getCodeList.forEach(function (item) {
                    if (item.boundedContext == boundedName) {
                        data.getCodeList.push(item)
                    }
                })
                var treeList = data.fullPathList.reduce((children, value) => {
                    value.fullPath.split('/').reduce((folder, o, i) => {

                        if (i === 0) {
                            var p = folder;
                        } else {
                            var p = folder.children = folder.children || [];
                        }

                        let f = p.find(x => x.name === o.trim());

                        if (!f) {
                            f = {
                                name: o.trim(),
                                key: findFile(value, o.trim()).key,
                                file: findFile(value, o.trim()).file,
                                code: findFile(value, o.trim()).code,
                                hash: findFile(value, o.trim()).hash,
                            }

                            p.push(f);
                        }

                        return f;
                    }, children);

                    return children;
                }, []);

                function reverse(item, path) {
                    var me = this
                    item.forEach(function (list) {
                        if (list.children) {
                            //폴더 생성하기
                            var tmpPath = path + '/' + list.name
                            reverse(list.children, tmpPath);
                        } else {
                            //파일생성하
                            if (list.code) {
                                pathTmp.push({path: path + '/' + list.name, code: list.code})
                            }
                        }
                    })
                };

                function findFile(value, name) {
                    var ob = null
                    var hash = value.hash ? value.hash : null

                    data.getCodeList.some(function (meta) {
                        if (meta.hash == hash && meta.fileName == name) {
                            ob = {
                                key: meta.key,
                                code: meta.code,
                                file: meta.file,
                                hash: meta.hash
                            }
                            return true;
                        }
                    })
                    if (!ob) {
                        ob = {
                            key: hash ? hash : name,
                            hash: hash ? hash : name
                        }
                    }

                    return ob
                };

                treeList.forEach(function (list) {
                    if (list.file == undefined) {
                        reverse(list.children, list.name)
                    } else {
                        pathTmp.push({path: list.name, code: list.code})
                    }
                })

                var zip = new JSZip();

                // var parents = [];
                pathTmp.forEach(function (generateData) {
                    if (generateData.path.includes('/')) {
                        // parents.push(generateData.path.split('/')[0])
                    }
                    zip.file(generateData.path, generateData.code)
                })

                // parents.forEach(function (prefix) {
                //     zip.folder(prefix).forEach(function (relativePath, file) {
                //     });
                // })


                zip.generateAsync({
                    type: 'nodebuffer',
                })
                    .then(async function (content) {

                        var metaData = {
                            'Content-Type': 'application/zip',
                        }

                        // var minioClient = new Minio.Client({
                        //     endPoint: `minio.${me.getTenantId()}`,
                        //     port: 443,
                        //     useSSL: true,
                        //     accessKey: 'minio',
                        //     secretKey: 'minio123'
                        // });


                        // var existCheck = await me.fileExistCheck(minioClient, existCheckMetaData);

                        var userName = localStorage.getItem("email").split('@')[0].toLowerCase();
                        var userGroup = localStorage.getItem("email").split('@')[1].split('.')[0].toLowerCase();
                        var projectName = me.projectName.toLowerCase()
                        var hashName = `ide-${me.hashCode(userGroup + "-" + userName)}`


                        var podStatus = await me.getPodStatus(userName, userGroup, projectName);
                        // Pod 미존재로 새로 실행
                        minioClient.putObject('eventstorming', `${userGroup}/${userName}/${projectName}/${boundedName}.zip`, content, metaData, {'Content-Type': 'application/zip',}, async function () {
                            var configPath = `${userGroup}/${userName}/config`
                            var checkConfigFile;
                            try {
                                checkConfigFile = await me.getString(`minio://${configPath}/config`);
                            } catch (e) {
                                checkConfigFile = null
                            }

                            // 만약 Config가 없다면 만들어줌.
                            if (!checkConfigFile) {
                                // 1. Namespace Check
                                var namespaceChecked = await me.existNamespaceCheck(hashName);
                                if (!namespaceChecked) {
                                    await me.createNamespace(hashName)
                                }
                                // 2. ServiceAccount Check
                                var serviceAccountChecked = await me.existServiceAccountCheck(hashName);
                                if (!serviceAccountChecked) {
                                    await me.createServiceAccount(hashName);
                                }

                                // 3. Role check
                                var roleChecked = await me.existRoleCheck(hashName);
                                if (!roleChecked) {
                                    await me.createRole(hashName)
                                }
                                // 4. Role Binding Check
                                var roleBindingChecked = await me.existRoleBindingCheck(hashName);
                                if (!roleBindingChecked) {
                                    await me.createRoleBinding(hashName)
                                }
                                // 5. get secret
                                var serviceAccount = await me.existServiceAccountCheck(hashName);
                                var secretName = serviceAccount.data.secrets[0].name
                                var secret = await me.getSecret(hashName, secretName)
                                var decodedToken = atob(secret);

                                // 6. upload Config
                                // 클러스터명, 서버ip 바꿔줄 것!
                                var configJson = {
                                    "apiVersion": "v1",
                                    "clusters": [
                                        {
                                            "cluster": {
                                                "insecure-skip-tls-verify": true,
                                                "server": "https://218.236.22.12:6443"
                                            },
                                            "name": "kcb-test2.k8s.local"
                                        }
                                    ],
                                    "contexts": [
                                        {
                                            "context": {
                                                "cluster": "kcb-test2.k8s.local",
                                                "namespace": hashName,
                                                "user": hashName
                                            },
                                            "name": "kcb-test2.k8s.local"
                                        }
                                    ],
                                    "current-context": "kcb-test2.k8s.local",
                                    "kind": "Config",
                                    "preferences": {},
                                    "users": [
                                        {
                                            "name": hashName,
                                            "user": {
                                                "token": decodedToken
                                            }
                                        }
                                    ]
                                }

                                // EventStorming쪽 Config로 넣어줘야함
                                minioClient.putObject('eventstorming', `${configPath}/config`, JSON.stringify(configJson), metaData, {
                                    'Content-Type': 'application/json',
                                })
                                // await minioClient.putObject(configPath + '/config', configJson)
                            }

                            var zipUrl = await me.presignedURL(`${userGroup}/${userName}/${projectName}/${boundedName}.zip`);
                            if (podStatus) {
                                // Pod 존재 하여 Pod 다운로드
                                var downloadPod = {
                                    "apiVersion": "v1",
                                    "kind": "Pod",
                                    "metadata": {
                                        "name": `${hashName}-download`,
                                        "labels": {
                                            "app": `${hashName}-download`,
                                        }
                                    },
                                    "spec": {
                                        "initContainers": [
                                            {
                                                "name": "mkdir",
                                                "image": "busybox",
                                                "command": ["mkdir", "-p", `/home/project/${userGroup}/${userName}/${projectName}/${boundedName}`],
                                                "volumeMounts": [
                                                    {
                                                        "mountPath": "/home/project",
                                                        "name": "test-storage",
                                                        "subPath": `eventstorming`
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "downloadzip",
                                                "image": "busybox",
                                                "command": ["wget", "-O", `/home/project/${userGroup}/${userName}/${projectName}/${boundedName}.zip`, zipUrl],
                                                "volumeMounts": [
                                                    {
                                                        "mountPath": "/home/project",
                                                        "name": "test-storage",
                                                        "subPath": `eventstorming`
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "unzip",
                                                "image": "busybox",
                                                "command": ["unzip", "-n", `/home/project/${userGroup}/${userName}/${projectName}/${boundedName}.zip`, "-d", `/home/project/${userGroup}/${userName}/${projectName}`],
                                                "volumeMounts": [
                                                    {
                                                        "mountPath": "/home/project",
                                                        "name": "test-storage",
                                                        "subPath": `eventstorming`
                                                    }
                                                ]
                                            }
                                        ],
                                        "containers": [
                                            {
                                                "name": "delete",
                                                "image": "wernight/kubectl",
                                                "command": ["sh", "-c", `kubectl delete po ${hashName}-download`],
                                                "volumeMounts": [
                                                    {
                                                        "mountPath": "/home/project",
                                                        "name": "test-storage",
                                                        "subPath": `eventstorming`
                                                    }
                                                ]
                                            }
                                        ],
                                        "volumes": [
                                            {
                                                "name": "test-storage",
                                                "persistentVolumeClaim": {
                                                    "claimName": "nfs"
                                                }
                                            }
                                        ]
                                    }
                                }
                                me.$http.post(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/default/pods`, downloadPod);
                                // IdeLoadingPage
                                me.ideWindow = window.open(`#/IdeLoadingPage?param=${hashName}`, '_blank')
                            } else {
                                me.$http.post(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/default/pods`, {
                                    "apiVersion": "v1",
                                    "kind": "Pod",
                                    "metadata": {
                                        "name": `${hashName}`,
                                        "labels": {
                                            "environment": "ide",
                                            "app": `${hashName}`
                                        }
                                    },
                                    "spec": {
                                        "initContainers": [
                                            {
                                                "name": "downloadzip",
                                                "image": "yauritux/busybox-curl",
                                                "command": ["curl", "-L", zipUrl, '--create-dirs', '-o', `/home/project/${userGroup}/${userName}/${projectName}/${boundedName}.zip`],
                                                "volumeMounts": [
                                                    {
                                                        "mountPath": "/home/project",
                                                        "name": "test-storage",
                                                        "subPath": "eventstorming"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "unzip",
                                                "image": "busybox",
                                                "command": ["unzip", "-n", `/home/project/${userGroup}/${userName}/${projectName}/${boundedName}.zip`, "-d", `/home/project/${userGroup}/${userName}/${projectName}`],
                                                "volumeMounts": [
                                                    {
                                                        "mountPath": "/home/project",
                                                        "name": "test-storage",
                                                        "subPath": "eventstorming"
                                                    }
                                                ]
                                            }
                                        ],
                                        "containers": [

                                            {
                                                "name": `${hashName}`,
                                                "image": "gcr.io/eventstorming-tool/theia-ide-labs:2.7",
                                                "securityContext": {
                                                    "privileged": true,
                                                    "runAsUser": 0
                                                },
                                                "env": [
                                                    {
                                                        "name": "DOCKER_HOST",
                                                        "value": `tcp://localhost:2375`
                                                    }
                                                ],
                                                "resources": {
                                                    "requests": {
                                                        "memory": "2Gi"
                                                    }
                                                },
                                                "volumeMounts": [
                                                    {
                                                        "mountPath": "/home/project",
                                                        "name": "test-storage",
                                                        "subPath": `eventstorming/${userGroup}/${userName}/${projectName}`
                                                    }
                                                ],
                                                "readinessProbe": {
                                                    "httpGet": {
                                                        "path": "/#/home/project",
                                                        "port": 3000
                                                    }
                                                }
                                            },
                                            {
                                                "name": "dind",
                                                "image": "docker:18.09.0-beta3-dind",
                                                "securityContext": {
                                                    "privileged": true,
                                                },
                                                "resources": {
                                                    "requests": {
                                                        "memory": "512Mi",
                                                        //"cpu": "20m"
                                                    }
                                                },
                                            }
                                        ],
                                        "volumes": [
                                            {
                                                "name": "docker-graph-storage",
                                                "emptyDir": {}
                                            },
                                            {
                                                "name": "test-storage",
                                                "persistentVolumeClaim": {
                                                    "claimName": "nfs"
                                                }
                                            }
                                        ]
                                    }
                                }).then(function () {
                                    me.$http.post(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/default/services`, {
                                        "apiVersion": "v1",
                                        "kind": "Service",
                                        "metadata": {
                                            "labels": {
                                                "environment": "ide",
                                                "app": `${hashName}`
                                            },
                                            "name": `${hashName}`,
                                            "namespace": "default"
                                        },
                                        "spec": {
                                            "ports": [
                                                {
                                                    "port": 3000,
                                                    "protocol": "TCP",
                                                    "targetPort": 3000
                                                }
                                            ],
                                            "selector": {
                                                "app": `${hashName}`
                                            },
                                            "sessionAffinity": "None",
                                            "type": "ClusterIP"
                                        },
                                        "status": {
                                            "loadBalancer": {}
                                        }
                                    }).then(
                                        function () {
                                            // IdeLoadingPage
                                            me.ideWindow = window.open(`#/IdeLoadingPage?param=${hashName}`, '_blank')
                                        }
                                    )
                                })
                            }
                        });
                    });
            },

            restApiPush: function () {
                var me = this;
                me.$http.post(`${me.getProtocol()}//api.${me.getTenantId()}/event/${me.projectName}`, me.value, {
                        responseType: "arraybuffer",
                        headers: {
                            'Content-Type': 'application/zip;'
                        }
                    }
                ).then(function (response) {
                    var blob = new Blob([response.data], {type: 'application/zip'});
                    var fileName = me.projectName + ".zip";
                    saveAs(blob, fileName);
                })
            },

            b64toBlob: function (b64Data, contentType, sliceSize) {
                contentType = contentType || '';
                sliceSize = sliceSize || 512;

                var byteCharacters = atob(b64Data);
                var byteArrays = [];

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

                var blob = new Blob(byteArrays, {type: contentType});
                return blob;
            },

            loadLocalTextToJsonFile(fileObj) {
                var me = this
                me.projectName = fileObj.projectName
                me.value = fileObj.value
            },

            recursiveDeepCopy(o) {
                var me = this
                var newO,
                    i;

                if (typeof o !== 'object') {
                    return o;
                }
                if (!o) {
                    return o;
                }

                if ('[object Array]' === Object.prototype.toString.apply(o)) {
                    newO = [];
                    for (i = 0; i < o.length; i += 1) {
                        newO[i] = me.recursiveDeepCopy(o[i]);
                    }
                    return newO;
                }

                newO = {};
                for (i in o) {
                    if (o.hasOwnProperty(i)) {
                        newO[i] = me.recursiveDeepCopy(o[i]);
                    }
                }
                return newO;
            },
            existNamespaceCheck(hashName) {
                var me = this
                return new Promise(function (resolve) {
                    me.$http.get(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/${hashName}`).then(function (result) {
                        resolve(true)
                    }).catch(function (e) {
                        resolve(false)
                    })
                })
            },
            createNamespace(hashName) {
                var me = this
                return new Promise(function (resolve) {
                    me.$http.post(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces`, {
                        "apiVersion": "v1",
                        "kind": "Namespace",
                        "metadata": {
                            "name": hashName
                        },
                        "spec": {
                            "finalizers": [
                                "kubernetes"
                            ]
                        }
                    }).then(function (result) {
                        resolve(true)
                    }).catch(function (e) {
                        resolve(false)
                    })
                })
            },
            existServiceAccountCheck(hashName) {
                var me = this
                return new Promise(function (resolve) {
                    me.$http.get(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/${hashName}/serviceaccounts/${hashName}`).then(function (result) {
                        resolve(result)
                    }).catch(function (e) {
                        resolve(false)
                    })
                })
            },
            createServiceAccount(hashName) {
                var me = this
                return new Promise(function (resolve) {
                    me.$http.post(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/${hashName}/serviceaccounts`, {
                        "apiVersion": "v1",
                        "kind": "ServiceAccount",
                        "metadata": {
                            "name": hashName,
                            "namespace": hashName
                        }
                    }).then(function (result) {
                        resolve(true)
                    }).catch(function (e) {
                        resolve(false)
                    })
                })
            },
            existRoleCheck(hashName) {
                var me = this
                return new Promise(function (resolve) {
                    me.$http.get(`${me.getProtocol()}//api.${me.getTenantId()}/apis/rbac.authorization.k8s.io/v1beta1/namespaces/${hashName}/roles/${hashName}`).then(function (result) {
                        resolve(true)
                    }).catch(function (e) {
                        resolve(false)
                    })
                })
            },
            createRole(hashName) {
                var me = this
                return new Promise(function (resolve) {
                    me.$http.post(`${me.getProtocol()}//api.${me.getTenantId()}/apis/rbac.authorization.k8s.io/v1beta1/namespaces/${hashName}/roles`, {
                        "kind": "Role",
                        "apiVersion": "rbac.authorization.k8s.io/v1beta1",
                        "metadata": {
                            "namespace": hashName,
                            "name": hashName
                        },
                        "rules": [
                            {
                                "apiGroups": [
                                    "*"
                                ],
                                "resources": [
                                    "*"
                                ],
                                "verbs": [
                                    "*"
                                ]
                            }
                        ]
                    }).then(function (result) {
                        resolve(true)
                    }).catch(function (e) {
                        resolve(false)
                    })
                })
            },
            existRoleBindingCheck(hashName) {
                var me = this
                return new Promise(function (resolve) {
                    me.$http.get(`${me.getProtocol()}//api.${me.getTenantId()}/apis/rbac.authorization.k8s.io/v1beta1/namespaces/${hashName}/rolebindings/${hashName}`).then(function (result) {
                        resolve(true)
                    }).catch(function (e) {
                        resolve(false)
                    })
                })
            },
            createRoleBinding(hashName) {
                var me = this
                return new Promise(function (resolve) {
                    me.$http.post(`${me.getProtocol()}//api.${me.getTenantId()}/apis/rbac.authorization.k8s.io/v1beta1/namespaces/${hashName}/rolebindings`, {
                        "kind": "RoleBinding",
                        "apiVersion": "rbac.authorization.k8s.io/v1beta1",
                        "metadata": {
                            "name": hashName,
                            "namespace": hashName
                        },
                        "subjects": [
                            {
                                "kind": "ServiceAccount",
                                "name": hashName
                            }
                        ],
                        "roleRef": {
                            "kind": "Role",
                            "name": hashName,
                            "apiGroup": "rbac.authorization.k8s.io"
                        }
                    }).then(function (result) {
                        resolve(true)
                    }).catch(function (e) {
                        resolve(false)
                    })
                })
            },
            getSecret(hashName, secretName) {
                var me = this
                return new Promise(function (resolve) {
                    me.$http.get(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/${hashName}/secrets/${secretName}`).then(function (result) {
                        resolve(result.data.data.token)
                    }).catch(function (e) {
                        resolve(false)
                    })
                })
            },
            hashCode(s) {
                return s.split("").reduce(function (a, b) {
                    a = ((a << 5) - a) + b.charCodeAt(0);
                    return a & a
                }, 0);
            },
            ideRunningCheck(hashName) {
                var me = this
                me.$http.get(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/default/pods/${hashName}/status`).then(function (result) {
                    if (result.data.status.conditions) {
                        result.data.status.conditions.forEach(function (status) {
                            if (status.type == "Ready" && status.status == "True") {
                                if (me.labInfo.independent) {
                                    me.ideUrl = `${me.getProtocol()}//${hashName}.kuberez.io`;
                                    clearInterval(me.ideInterval);
                                } else {
                                    me.ideUrl = `${me.getProtocol()}//${hashName}.kuberez.io/?labId=${me.labId}#/home/project/${me.labId}`;
                                    clearInterval(me.ideInterval);
                                }
                            }
                        })
                    }
                }).catch(function (e) {
                })
            },
            ideExistCheck(userEmail) {
                var me = this
                var lab = me.labId;
                if (me.labInfo.independent) {
                    var hashPath = me.getClassPath('labs/' + lab + '/' + userEmail);
                } else {
                    var hashPath = me.getClassPath(userEmail);

                }
                var hashName = "labs-" + me.hashCode(hashPath);
                return new Promise(function (resolve) {
                    me.$http.get(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/default/pods/${hashName}/status`).then(function (result) {
                        resolve(result)
                    }).catch(function (e) {
                        resolve(false)
                    })
                })
            },

            // //복사
            // copy: function () {
            //     var me = this
            //     if (!me.isReadModeling && !me.readOnly) {
            //         me.tmpValue = []
            //         Object.values(me.value.elements).forEach(function (tmp, idx) {
            //             if (tmp != null) {
            //                 if (tmp.selected == true) {
            //                     me.tmpValue.push(tmp)
            //                 }
            //             }
            //         })
            //     }
            // },
            // //붙여넣기
            // paste: function () {
            //     var me = this
            //     if (!me.isReadModeling && !me.readOnly) {
            //         var temp = JSON.parse(JSON.stringify(me.tmpValue))
            //         if (me.tmpValue != null) {
            //             temp.forEach(function (tmp, idx) {
            //                 tmp.elementView.id = me.uuid();
            //                 tmp.elementView.x = tmp.elementView.x + Math.floor(Math.random() * 101)
            //                 tmp.elementView.y = tmp.elementView.y + Math.floor(Math.random() * 101)
            //                 delete tmp.selected
            //                 me.addElementPush(tmp)
            //             })
            //         }
            //     }
            // },

            codeAlign(code) {
                var me = this
                var parsers = {
                    tabWidth: 4,
                    parser: 'java',
                    plugins: [plugins]
                }
                if (code.includes('<function>')) {
                    code = code.replace('<function>', '')
                }
                try {
                    var formatted = prettier.format(code, parsers)
                    return formatted
                } catch (e) {
                    console.log(e)
                    return code; //if fail return original
                }
            },

            openEmbeddedCanvas(val) {
                var me = this;
                me.overlayText = 'Loading';

                if (typeof val == "object") {
                    me.embeddedCanvasType = val.type;

                    me.aggregateRootId = val.aggId;
                    me.aggregateRootList = val.aggList;
                    me.embeddedCanvasValue = me.value.elements[val.aggId].aggregateRoot.entities;

                } else if (typeof val == "string") {
                    me.embeddedCanvasValue = {'elements': {}, 'relations': {}};
                    if (me.value.k8sValue != null) {
                        me.embeddedCanvasValue = me.value.k8sValue;
                    }

                    me.embeddedCanvasType = val;
                    me.boundedContextList = [];

                    Object.values(me.value.elements).forEach(function (el) {
                        if (el) {
                            if (el._type.endsWith("BoundedContext")) {
                                me.boundedContextList.push(el);
                            }
                        }
                    })

                }

                me.embeddedCanvasDialog = true;
            },
            closeEmbeddedCanvas() {
                var me = this;
                me.overlayText = null;

                if (me.embeddedCanvasType == "Domain Class Modeling") {
                    me.aggregateRootId = "";
                    me.aggregateRootList = [];

                } else if (me.embeddedCanvasType == "Kubernetes") {
                    me.boundedContextList = [];
                    me.$set(me.value, 'k8sValue', me.embeddedCanvasValue);

                    if (!me.isClazzModeling && me.isServerModeling) {
                        me.changedByMe = true;
                    }

                    var delta = jsondiffpatch.diff(me.copyValue, me.value);
                    if (me.initLoad && delta) {
                        me.modifiedElement(delta)
                    }
                }

                me.embeddedCanvasType = "";
                me.embeddedCanvasDialog = false;
                me.embeddedCanvasValue = {'elements': {}, 'relations': {}};
            },
            addTemplateCode() {
                var me = this;

                if (!me.value.k8sValue) {
                    return;
                }

                var yamlText = "";
                if (Object.values(me.value.k8sValue.elements).length > 0) {
                    Object.values(me.value.k8sValue.elements).forEach(function (item) {
                        if (item) {
                            if (item._type != "DestinationRuleSubset"
                                && item._type != "WorkflowDag"
                                && item._type != "WorkflowStep"
                            ) {
                                yamlText += json2yaml.stringify(item.object);
                            }
                        }
                    })
                }

                var hashName = JSON.parse(JSON.stringify('deployment.yml'))
                var hashValue = JSON.parse(JSON.stringify(yamlText))
                var hashPath = JSON.parse(JSON.stringify('kubernetes/deployment.yml'))
                var hashConcat = hashName.concat(hashValue)
                hashConcat = hashConcat.concat(hashPath)
                var sourceHash = Math.abs(me.hashCode(yamlText))

                var uuid = me.uuid();
                var addCodeObj = {
                    'element': null,
                    'fileName': 'deployment.yml',
                    'key': uuid,
                    'hash': sourceHash,
                    'code': yamlText,
                    'file': 'txt',
                    'boundedContext': 'for-model',
                    'representativeFor': null,
                    'forEach': 'for-model'
                };
                var addFullPath = {
                    'bcId': null,
                    'element': null,
                    'key': uuid,
                    'fullPath': 'kubernetes/deployment.yml',
                    'hash': sourceHash
                };

                me.fullPathList.push(addFullPath);
                me.getCodeList.push(addCodeObj);
            },
        }
    }
</script>


<style scoped lang="scss" rel="stylesheet/scss">
    .input-name {
        background-color: #ffffff;
        full-width: 10px;
    }

    .canvas-panel {
        top: 0;
        bottom: 0;
        left: 10;
        right: 0;
        /*position: relative;*/
        position: absolute;
        overflow: hidden;
        width: 100%;
        height: 100%;

        .fullcanvas {
            position: relative;
            width: 100%;
            height: 100%;
            top: 10%;
            left: 0;
            overflow: hidden;
        }

        .fullcanvashands {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 10%;
            left: 0;
            overflow: hidden;
            cursor: url('../../../../public/static/image/symbol/hands.png'), auto;
        }

        .toolsSide {
            position: absolute;
            width: 100px;
            left: 20px;
            top: 20px;
            padding: 4px;
            overflow: hidden;

            .icons {
                margin-top: 5px;
                margin-bottom: 5px;
            }

            .hands {
                margin-top: 5px;
                margin-bottom: 5px;
            }
        }

        .tools {
            position: absolute;
            width: 48px;
            left: 20px;
            top: 20px;
            padding: 4px;
            overflow: hidden;

            .icons {
                margin-top: 5px;
                margin-bottom: 5px;
            }

            .hands {
                margin-top: 5px;
                margin-bottom: 5px;
            }
        }

        .zoom {
            position: absolute;
            width: 42px;
            right: 20px;
            bottom: 120px;

            .icons {
                font-size: 25px;
                margin-left: 10px;
                margin-top: 5px;
                margin-bottom: 5px;
            }

            .hands {
                font-size: 25px;
                margin-left: 10px;
                margin-top: 5px;
                margin-bottom: 5px;
            }
        }

        .icons {
            cursor: pointer;
            font-size: 30px;

            &:hover {
                color: #1a76d2;
            }
        }

        .hands {
            cursor: pointer;
            font-size: 30px;
            color: #ffc124;
        }

        .export,
        .history,
        .import,
        .save {
            position: absolute;
            padding: 8px;

            .icons {
                font-size: 25px;
                margin-left: 10px;
            }
        }

        .import {
            left: 80px;
            bottom: 20px;
        }

        .export {
            left: 180px;
            bottom: 20px;
        }

        .history {
            left: 280px;
            bottom: 20px;
        }
    }

    .text-reader input[type="file"] { /* 파일 필드 숨기기 */
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
    }

    /* The whole thing */
    .custom-menu {
        display: none;
        z-index: 1000;
        position: absolute;
        overflow: hidden;
        border: 1px solid #CCC;
        white-space: nowrap;
        font-family: sans-serif;
        background: #FFF;
        color: #333;
        border-radius: 5px;
        padding: 0;
    }

    /* Each of the items in the list */
    .custom-menu li {
        padding: 8px 12px;
        cursor: pointer;
        list-style-type: none;
        transition: all 0.3s ease;
        user-select: none;
    }

    .custom-menu li:hover {
        background-color: #DEF;
    }

    /*.moveable-line.moveable-rotation-line {*/
    /*    height: 40px;*/
    /*    width: 1px;*/
    /*    transform-origin: 0.5px 39.5px;*/
    /*}*/

    /*.moveable {*/
    /*    font-family: "Roboto", sans-serif;*/
    /*    position: relative;*/
    /*    width: 400px;*/
    /*    height: 130px;*/
    /*    text-align: center;*/
    /*    font-size: 40px;*/
    /*    margin: 0 auto;*/
    /*    font-weight: 100;*/
    /*    letter-spacing: 1px;*/
    /*    background: white;*/
    /*}*/


    .video-list {
        height: 160px;
        width: auto;
        margin-left: 2px;
        background: transparent;
    }

    .video-list div {
        padding: 2px;
    }

    .video-item {
        display: inline-block;
        padding: 2px;
    }

    .rtc {
        .button {
            color: red;
        }

        .buttonHover {
            background-Color: white;
        }

        .content {
            background-Color: white;
        }

        .titlebar {
            background-color: white;
        }
    }

    @media only screen and (max-width: 781px) {

        #mobile-undo-redo {
            margin-left: 20px;
        }

        #project-name {
            position: absolute;
        }

        #action-btn {
            position: absolute;
            right: 0;
        }

        #mobile-action-btn {
            position: relative;
            right: 5px;
            bottom: -10px;
        }
    }

    #mobile-menu-popup-btn {
        position: absolute;
        right: 0;
        bottom: 25px;
    }

    #mobile-menu-popup-btn .v-speed-dial {
        position: absolute;
    }

    #mobile-menu-popup-btn .v-btn--floating {
        position: relative;
    }

    .codeModal {
        display: none; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 10; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0, 0, 0); /* Fallback color */
        background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    }

    .topping-radio-group label {
        font-size: 12px;
    }

    .topping-radio-group .topping-checkbox {
        margin-top: -25px;
    }

    .page {
        height: 100%;
        /*padding: 10px;*/
        background: #000;
    }

</style>
